{
    "order.directOrder.enquiry": "Enquiry",
    "order.directOrder.directOrder": "Direct order",
    "order.directOrder.confirmDirectOrder": "Confirm direct order",
    "order.directOrder.pleaseReviewTheDetailsBelowAndConfirmYourDirectOrder": "Please review the details below and confirm your direct order.",
    "order.directOrder.placingThisOrderImpliesAgreementToThe": "Placing this order implies agreement to the",
    "order.directOrder.selectSupplier": "Select a supplier.",
    "order.directOrder.placeDirectOrder": "Place direct order",
    "order.directOrder.placingOrder": "Placing order…",
    "order.directOrder.selectExactlyOneSupplierToPlaceDirectOrder": "Select exactly one supplier to place a direct order",
    "order.directOrder.enquiryCreatedOrderingFailed": "The enquiry was created, but ordering did not finish. You can continue from the enquiry.",
    "order.directOrder.couldNotStartDirectOrderCheckForm": "Could not start the direct order. Check the form and your ordering permissions, then try again.",
    "order.directOrder.couldNotConfirmOrderStatus": "Could not confirm the order status. Check the enquiry before trying to order again.",
    "btn.save.default": "Save",
    "btn.save.loading": "Saving…",
    "btn.delete": "Delete",
    "btn.cancel": "Cancel",
    "btn.goBack": "Go back",
    "btn.send": "Send",
    "btn.add": "Add",
    "btn.done": "Done",
    "btn.copy": "Copy",
    "btn.continue": "Continue",
    "btn.back": "Back",
    "global.superAdmin": "Super admin",
    "global.min": "min",
    "global.by": "by",
    "global.more": "more",
    "global.seeMore": "+{{count}} more",
    "global.system": "System",
    "global.unknown": "Unknown",
    "global.status": "Status",
    "global.yes": "Yes",
    "global.no": "No",
    "global.active": "Active",
    "global.unread": "Unread",
    "global.enabled": "Enabled",
    "global.disabled": "Disabled",
    "global.inactive": "Inactive",
    "global.optional": "Optional",
    "global.optionalLabel": "(optional)",
    "global.requiredLabel": "(required)",
    "global.settings": "Settings",
    "global.days": "day(s)",
    "global.address.title": "Address",
    "global.address.company": "Company name",
    "global.address.company.optional": "Company name",
    "global.address.street": "Street",
    "global.address.streetnumber": "Street number",
    "global.address.zipcode": "Zip code",
    "global.address.city": "City",
    "global.address.country": "Country",
    "global.address.invoiceaddress": "Invoice address",
    "global.address.placeholder.street": "e.g. Sample street",
    "global.address.placeholder.companyname": "e.g. Company ABC",
    "global.address.placeholder.streetnumber": "e.g. 15a",
    "global.address.placeholder.zipcode": "e.g 12232",
    "global.address.placeholder.city": "e.g. Hamburg",
    "global.address.placeholder.country": "e.g. Germany",
    "global.mailsettings.title": "Mail settings",
    "global.mailsettings.newsletter": "News updates",
    "global.mailsettings.receiveNews": "Receive news",
    "global.mailsettings.transactional": "Order updates",
    "global.mailsettings.receiveUpdates": "Receive order updates",
    "global.contact.title": "Contact",
    "global.contact.name": "Name",
    "global.contact.firstname": "First name",
    "global.contact.lastname": "Last name",
    "global.contact.email": "Email address",
    "global.email": "Email",
    "global.contact.invoicemail": "Invoice email",
    "global.contact.phone": "Phone",
    "global.contact.fax": "Fax",
    "global.contact.vatnumber": "VAT number",
    "global.contact.placeholder.name": "Name",
    "global.contact.placeholder.firstname": "e.g. Joe",
    "global.contact.placeholder.lastname": "e.g. Doe",
    "global.contact.placeholder.email": "e.g. john@doe.com",
    "global.contact.placeholder.invoicemail": "e.g. john@doe.com",
    "global.contact.placeholder.phone": "e.g. +49 213123123",
    "global.contact.placeholder.fax": "e.g. +49 213123123 1",
    "global.date.created": "Date created",
    "global.date.estimatedDelivery": "Estimated delivery",
    "global.date.delivery": "Delivery date",
    "global.date.timeelapsed": "Time elapsed",
    "global.notavailable": "N/A",
    "global.priceincomplete": "Price incomplete",
    "global.pleaseselect": "Please select…",
    "global.translationmissing": "No equivalent found",
    "global.save": "Save",
    "global.saved": "Saved",
    "global.saving": "Saving…",
    "global.loading": "Loading…",
    "global.startsearch": "Please start searching…",
    "global.notfound": "No search results…",
    "global.searching": "Searching for results …",
    "global.total": "Total",
    "global.product": "Product",
    "global.documentTitle": "{{title}} | Closelink",
    "global.genericError": "Something went wrong, please try again later.",
    "global.genericError.title": "Well, that's odd",
    "global.genericError.description": "Looks like something just didn’t load right. Try to reload.",
    "global.genericToastError": "Something went wrong, please try again later.",
    "global.coreData.viewDetails": "View details",
    "global.coreData.vessel": "Vessel",
    "global.coreData.viewVesselInformation": "View details",
    "global.coreData.customer": "Customer",
    "global.coreData.supplier": "Supplier",
    "global.coreData.viewCustomerInformation": "View details",
    "global.coreData.createdByUser": "Member",
    "global.coreData.viewCreatedByUserInformation": "View member information",
    "global.coreData.agent": "Agent",
    "global.coreData.noAgent": "No agent added",
    "global.coreData.viewAgentInformation": "View details",
    "global.coreData.estimatedDelivery": "Estimated delivery",
    "global.coreData.deliveryDate": "Estimated delivery date",
    "global.coreData.estimatedTimeOfArrival": "Estimated time of arrival",
    "global.coreData.estimatedTimeOfDeparture": "Estimated time of departure",
    "global.coreData.port": "Port",
    "global.coreData.buyerReference": "Buyer reference",
    "global.coreData.enquiryNote": "Enquiry note",
    "global.coreData.vendorReference": "Vendor reference",
    "global.coreData.supplyMode": "Supply mode",
    "global.coreData.paymentTerms": "Payment terms",
    "global.pagination.previous": "Previous",
    "global.pagination.next": "Next",
    "global.clearFilter.clearFilters": "Clear filters",
    "global.filterMultiSelect.xMoreItems": "+ {{count}} more",
    "global.filterMultiSelect.apply": "Apply",
    "global.filterText.apply": "Apply",
    "global.filterNumeric.apply": "Apply",
    "global.filterRadioGroup.apply": "Apply",
    "global.filterNumeric.isGreaterThan": "is greater than",
    "global.filterNumeric.isLessThan": "is less than",
    "global.filterNumeric.isEqualTo": "is equal to",
    "global.filterNumeric.moreThan": "More than {{value}}",
    "global.filterNumeric.lessThan": "Less than {{value}}",
    "global.filterNumeric.equalTo": "Equal to {{value}}",
    "global.datePicker.today": "Today",
    "global.datePicker.clear": "Clear",
    "global.datePicker.cancel": "Cancel",
    "global.datePicker.setDateRange": "Set date range",
    "global.datePicker.setDate": "Set date",
    "global.datePicker.presets.last7Days": "Last 7 days",
    "global.datePicker.presets.last14Days": "Last 14 days",
    "global.datePicker.presets.last30Days": "Last 30 days",
    "global.datePicker.presets.last3Months": "Last 3 months",
    "global.datePicker.presets.last12Months": "Last 12 months",
    "global.datePicker.presets.monthToDate": "Month to date",
    "global.datePicker.presets.quarterToDate": "Quarter to date",
    "global.datePicker.presets.custom": "Custom",
    "global.emptyFilterResult.noMatchingResults": "No results found",
    "global.emptyFilterResult.tryDifferentFilter": "There aren't any results for that query. Try using different filters.",
    "global.emptySearchResult.noSearchResults": "No search results found",
    "global.emptySearchResult.tryDifferentQueryr": "Please try again with a different search query",
    "global.close": "Close",
    "global.contains": "Contains",
    "errormessage.empty": "This field is required.",
    "errormessage.password": "Your password requires at least 6 characters.",
    "errormessage.email": "The email address is not valid.",
    "errormessage.amount": "The amount is not valid.",
    "errormessage.duplicate": "This value already exists.",
    "globalsearch.placeholder.admin": "Search orders and enquiries",
    "globalsearch.placeholder.customer": "Search orders by buyer ref, vessel, port…",
    "globalsearch.placeholder.supplier": "Search enquiries by vendor ref, vessel, port…",
    "navigation.dashboard": "Dashboard",
    "navigation.ports": "Ports",
    "navigation.orders": "Orders",
    "navigation.compare": "Compare",
    "navigation.planning": "Planning",
    "navigation.demandOverview": "Demand",
    "navigation.demandDefinitions": "Demand definitions",
    "navigation.order": "Order",
    "navigation.offers": "Offers",
    "navigation.offer": "Offer",
    "navigation.requestsForQuotes": "RFQs",
    "navigation.spots": "Spot enquiries",
    "navigation.rfqs": "Enquiries",
    "navigation.assignments": "Assignments",
    "navigation.createnew": "Create new",
    "navigation.customers": "Customers",
    "navigation.suppliers": "Suppliers",
    "navigation.vessels": "Vessels",
    "navigation.agents": "Agents",
    "navigation.contracts": "Contracts",
    "navigation.keyPorts": "Key ports",
    "navigation.reporting": "Statistics",
    "navigation.globalPrices": "Global prices",
    "navigation.users": "Members",
    "navigation.signOut": "Sign out",
    "navigation.personalDetails": "Personal details",
    "navigation.selectGroupContext": "Select group context",
    "navigation.group": "Group",
    "navigation.messageUs": "Contact support",
    "navigation.changelog": "Changelog",
    "navigation.feedback": "Send feedback",
    "navigation.hideSidebar": "Hide sidebar",
    "navigation.showSidebar": "Show sidebar",
    "navigation.tutorials": "Tutorials",
    "navigation.products": "Products",
    "navigation.integrations": "Integrations",
    "sidebar.section.customer": "Customer",
    "sidebar.section.supplier": "Supplier",
    "sidebar.section.superAdmin": "Super admin",
    "sidebar.proFeaturesBanner.customer.heading": "Share your vessel schedule",
    "sidebar.proFeaturesBanner.customer.description": "Get alternative offers by sharing expected port calls with your suppliers.",
    "sidebar.proFeaturesBanner.customer.cta": "Enable in settings",
    "sidebar.proFeaturesBanner.supplier.heading": "Need more flexibility when quoting?",
    "sidebar.proFeaturesBanner.supplier.description": "View vessel schedules and submit alternative quotes. Available free of charge for 60 days.",
    "sidebar.proFeaturesBanner.cta": "Learn more",
    "sidebar.proFeaturesBanner.dismiss": "Dismiss Pro features banner",
    "navigation.tooltips.users": "Members overview",
    "navigation.tooltips.customergroup": "Group settings",
    "navigation.tooltips.suppliergroup": "Group settings",
    "navigation.tooltips.settings": "Settings",
    "page.dashboardoverview": "Dashboard overview",
    "page.searchresultview": "Search",
    "page.portoverview": "Port overview",
    "page.portshow": "Port {{name}}",
    "page.orderoverview": "Order overview",
    "page.spotoverview": "Spot enquiries overview",
    "page.ordercreate": "Create enquiry",
    "page.orderdraft": "Create enquiry (draft) {{orderNumber}}",
    "page.orderedit": "Edit enquiry {{orderNumber}}",
    "page.offerEdit": "Edit order {{offerNumber}}",
    "page.spotcreate": "Create spot enquiry",
    "page.spotshow": "Spot enquiry {{spotNumber}}",
    "page.ordershow": "Offer overview {{orderNumber}}",
    "page.offerShowOffer": "Offer: {{vesselName}} - {{portName}}",
    "page.offerShowEnquiry": "Enquiry: {{vesselName}} - {{portName}}",
    "page.offerShowOrder": "Order: {{vesselName}} - {{portName}}",
    "page.vesselshow": "Vessel {{name}}",
    "page.vesseloverview": "Vessel overview",
    "page.reportingoverview": "Reporting overview",
    "page.supplieroverview": "Supplier overview",
    "page.assigmentoverview": "Assignment overview",
    "page.customers": "Customers",
    "page.suppliers": "Suppliers",
    "page.membersOverview": "Members",
    "page.members": "Members",
    "page.suppliergroupoverview": "Supplier overview",
    "page.customergroupoverview": "Customer overview",
    "page.suppliershow": "Supplier {{name}}",
    "page.memberDetailPage": "Member {{name}}",
    "page.customershow": "Customer {{name}}",
    "page.companyshow": "Company {{name}}",
    "page.tutorials": "Tutorials",
    "page.quotationProcess": "Enquiry: {{vesselName}} - {{portName}}",
    "page.productsOverview": "Products",
    "page.integrationsOverview": "Integrations",
    "page.agentDetails": "Agent {{name}}",
    "ago": "ago",
    "period.thismonth": "This month",
    "period.lastmonth": "Last month",
    "period.thisyear": "This year",
    "period.lastyear": "Last year",
    "compare.title": "Compare",
    "compare.company": "Company",
    "compare.price": "Price {{ppl}}",
    "compare.volume": "VOL {{volume}}",
    "compare.total": "total {{total}}",
    "compare.error": "N/A",
    "compare.remove": "Remove",
    "compare.vessel": "Vessel",
    "compare.placeholder.company": "Select company…",
    "compare.placeholder.vessel": "Select vessel…",
    "compare.placeholder.product": "Select product…",
    "compare.placeholder.packType": "Select pack type…",
    "compare.placeholder.port": "Select port…",
    "compare.createEnquiry": "Create enquiry",
    "compare.addPort": "Add port",
    "compare.keyPort.successHint": "Added key port!",
    "compare.keyPort.addButton": "Add to key ports",
    "compare.page.bar.headline": "Compare products, ports and suppliers",
    "compare.page.bar.description": "View and compare prices of contracted suppliers based on actual uploaded price lists at different ports.",
    "compare.overlay.bar.headline": "Compare ports and suppliers",
    "compare.overlay.bar.description": "You can compare the pricing of your contracted suppliers at various ports. Add additional ports by clicking the plus button. Select your favoured option(s) and proceed with apply selection. Multiple suppliers can only be selected for the same port.",
    "compare.itemsPopup.product": "Product",
    "compare.itemsPopup.total": "Total",
    "compare.itemsPopup.volume": "Volume",
    "compare.itemsPopup.button": "View details",
    "compare.itemsPopup.subtotal": "Subtotal",
    "compare.itemsPopup.requested": "Req:",
    "compare.partialPricing": "Partial pricing available",
    "state.LUBES.DRAFT.title": "Draft",
    "state.LUBES.ENQUIRY.title": "Open",
    "state.LUBES.ENQUIRY_SPOT.title": "Waiting for offer",
    "state.LUBES.QUOTED.title": "Quoted",
    "state.LUBES.QUOTED_SPOT.title": "Offer submitted",
    "state.LUBES.ORDER.title": "Ordered",
    "state.LUBES.CONFIRMED.title": "Confirmed",
    "state.LUBES.ACKNOWLEDGED.title": "Acknowledged",
    "state.LUBES.DELIVERED.title": "Delivered",
    "state.LUBES.DELIVERY_CONFIRMED.title": "Delivered",
    "state.LUBES.INVOICED.title": "Invoiced",
    "state.LUBES.CANCELED.title": "Order canceled",
    "state.LUBES.QUOTE_DECLINED.title": "Declined",
    "state.LUBES.QUOTE_CANCELED.title": "Enquiry canceled",
    "state.LUBES.QUOTE_CANCELED_SPOT.title": "Enquiry declined",
    "state.LUBES.ENQUIRY_EXPIRED.title": "Expired",
    "state.LUBES.ENQUIRY_DECLINED.title": "Enquiry declined",
    "state.LUBES.ENQUIRY_CANCELED.title": "Enquiry canceled",
    "state.LUBES.ENQUIRY_CANCELED_SPOT.title": "Enquiry canceled",
    "state.LUBES.SUPPLIER_ADJUSTED.title": "Supplier adjusted",
    "state.LUBES.CUSTOMER_ADJUSTED.title": "Customer adjusted",
    "statusbar.admin.spotenquiry.label": "Spot enquiry",
    "statusbar.admin.spotenquiry.subtitle": "The supplier has to fill in all required information to send an offer. ",
    "statusbar.admin.enquiry.label": "Contract enquiry",
    "statusbar.admin.enquiry.subtitle": "The supplier has to fill in all required information to quote the enquiry.",
    "statusbar.admin.spotquoted.label": "Offer sent",
    "statusbar.admin.spotquoted.subtitle": "The supplier has sent an offer.",
    "statusbar.admin.quoted.label": "Enquiry quoted",
    "statusbar.admin.quoted.subtitle": "The supplier has sent a quote.",
    "statusbar.admin.spotorder.label": "Spot order",
    "statusbar.admin.spotorder.subtitle": "Waiting for supplier confirmation.",
    "statusbar.admin.order.label": "Contract order",
    "statusbar.admin.order.subtitle": "Waiting for supplier confirmation.",
    "statusbar.admin.spotorderconfirmed.label": "Spot order confirmed",
    "statusbar.admin.spotorderconfirmed.subtitle": "The supplier confirmed the order.",
    "statusbar.admin.orderconfirmed.label": "Contract order confirmed",
    "statusbar.admin.orderconfirmed.subtitle": "The supplier confirmed the order.",
    "statusbar.admin.spotorderacknowledged.label": "Spot order acknowledged",
    "statusbar.admin.spotorderacknowledged.subtitle": "The supplier acknowledged the order.",
    "statusbar.admin.orderacknowledged.label": "Order acknowledged",
    "statusbar.admin.orderacknowledged.subtitle": "The supplier acknowledged the order.",
    "statusbar.admin.spotdelivered.label": "Spot order delivered",
    "statusbar.admin.spotdelivered.subtitle": "Estimated date of delivery has passed and delivery should have taken place.",
    "statusbar.admin.delivered.label": "Contract order delivered",
    "statusbar.admin.delivered.subtitle": "Estimated date of delivery has passed and delivery should have taken place.",
    "statusbar.admin.invoiced.label": "Contract order invoiced",
    "statusbar.admin.invoiced.subtitle": "The order has been marked as invoiced and can therefore no longer be edited.",
    "statusbar.admin.spotcompleted.label": "Spot order delivered",
    "statusbar.admin.spotcompleted.subtitle": "Estimated date of delivery has passed and delivery should have taken place.",
    "statusbar.admin.completed.label": "Contract order delivered",
    "statusbar.admin.completed.subtitle": "Estimated date of delivery has passed and delivery should have taken place.",
    "statusbar.admin.spotcanceled.label": "Spot order canceled",
    "statusbar.admin.spotcanceled.subtitle": "The order was canceled. ",
    "statusbar.admin.canceled.label": "Contract order canceled",
    "statusbar.admin.canceled.subtitle": "The order was canceled.",
    "statusbar.admin.quotecanceled.label": "Contract quote canceled",
    "statusbar.admin.quotecanceled.subtitle": "The quote was canceled. ",
    "statusbar.admin.enquirycanceled.label": "Contract enquiry canceled",
    "statusbar.admin.enquirycanceled.subtitle": "The enquiry was canceled.",
    "statusbar.admin.spotquotecanceled.label": "Spot quote canceled",
    "statusbar.admin.spotquotecanceled.subtitle": "The quote was canceled. ",
    "statusbar.admin.spotenquirycanceled.label": "Spot enquiry canceled",
    "statusbar.admin.spotenquirycanceled.subtitle": "The enquiry was canceled.",
    "statusbar.admin.spotquotedeclined.label": "Spot offer not selected",
    "statusbar.admin.spotquotedeclined.subtitle": "A competitor’s offer was selected by the customer.",
    "statusbar.admin.spotenquiryexpired.label": "Spot enquiry expired",
    "statusbar.admin.spotenquiryexpired.subtitle": "A competitor’s offer was selected by the customer.",
    "statusbar.admin.spotinvoiced.label": "Spot order invoiced",
    "statusbar.admin.spotinvoiced.subtitle": "The order has been marked as invoiced and can therefore no longer be edited.",
    "statusbar.admin.enquirydeclined.label": "Enquiry declined",
    "statusbar.admin.enquirydeclined.subtitle": "The enquiry was declined by the supplier.",
    "statusbar.admin.spotenquirydeclined.label": "Spot enquiry declined",
    "statusbar.admin.spotenquirydeclined.subtitle": "The enquiry was declined by the supplier.",
    "statusbar.admin.enquiryexpired.label": "Enquiry expired",
    "statusbar.admin.enquiryexpired.subtitle": "A competitor’s offer was selected.",
    "statusbar.admin.customerAdjustedApprovalPending.label": "Order changed - waiting for approval",
    "statusbar.admin.customerAdjustedApprovalPending.subtitle": "The customer has requested approval for the changed order.",
    "statusbar.admin.customerAdjustedApprovalDeclined.label": "Order changed - approval declined",
    "statusbar.admin.customerAdjustedApprovalDeclined.subtitle": "The approval request for the changed order was declined.",
    "statusbar.admin.customerAdjustedApprovalExpired.label": "Order changed - approval expired",
    "statusbar.admin.customerAdjustedApprovalExpired.subtitle": "The approval request for the changed order has expired.",
    "statusbar.admin.customerAdjustedApproval.label": "Changed order needs approval",
    "statusbar.admin.customerAdjustedApproval.subtitle": "The customer has changed the order and has to request approval.",
    "statusbar.admin.supplierAdjusted.label": "Order changed by supplier",
    "statusbar.admin.supplierAdjusted.subtitle": "The supplier has changed the order. The customer has to confirm the changes.",
    "statusbar.customer.order.label": "Ordered",
    "statusbar.customer.order.subtitle": "The order is sent to the supplier. Waiting for acknowledgement and confirmation.",
    "statusbar.customer.confirmed.label": "Order confirmed",
    "statusbar.customer.confirmed.subtitle": "Great news! The supplier confirmed your order.",
    "statusbar.customer.delivery.label": "Delivery day",
    "statusbar.customer.delivery.subtitle": "Have you received the order? Please mark the order as delivered.",
    "statusbar.customer.delivery.button": "Mark as delivered",
    "statusbar.customer.acknowledged.label": "Order acknowledged",
    "statusbar.customer.acknowledged.subtitle": "The supplier has acknowledged your order. Waiting for confirmation.",
    "statusbar.customer.delivered.label": "Order delivered",
    "statusbar.customer.delivered.subtitle": "Does the actual delivery differ from the order specification? If yes, please edit the order information to ensure correct reporting.",
    "statusbar.customer.deliveryconfirmed.label": "Order delivered",
    "statusbar.customer.deliveryconfirmed.subtitle": "Does the actual delivery differ from the order specification? If yes, please edit the order information to ensure correct reporting.",
    "statusbar.customer.invoiced.label": "Order invoiced",
    "statusbar.customer.invoiced.subtitle": "The order has been marked as invoiced and can therefore no longer be edited.",
    "statusbar.customer.canceled.label": "Order canceled",
    "statusbar.customer.canceled.subtitle": "The order was canceled.",
    "statusbar.customer.customerAdjusted.label": "Order changed - please confirm",
    "statusbar.customer.customerAdjusted.subtitle": "Please confirm due to changes in the order.",
    "statusbar.customer.customerAdjusted.button": "Confirm",
    "statusbar.customer.customerAdjustedApprovalPending.label": "Order changed - waiting for approval",
    "statusbar.customer.customerAdjustedApprovalPending.subtitle": "You have requested approval for the changed order.",
    "statusbar.customer.customerAdjustedApprovalPending.button": "Resend",
    "statusbar.customer.customerAdjustedApprovalDeclined.label": "Order changed - approval declined",
    "statusbar.customer.customerAdjustedApprovalDeclined.subtitle": "Your approval request for the changed order was declined.",
    "statusbar.customer.customerAdjustedApprovalDeclined.button": "Re-request",
    "statusbar.customer.customerAdjustedApprovalExpired.label": "Order changed - approval expired",
    "statusbar.customer.customerAdjustedApprovalExpired.subtitle": "Your approval request for the changed order has expired.",
    "statusbar.customer.customerAdjustedApprovalExpired.button": "Re-request",
    "statusbar.customer.customerAdjustedApprovalWithdrawn.label": "Changed order needs approval",
    "statusbar.customer.customerAdjustedApprovalWithdrawn.subtitle": "Please request approval due to changes in the order.",
    "statusbar.customer.customerAdjustedApprovalWithdrawn.button": "Re-request",
    "statusbar.customer.customerAdjustedApproval.label": "Changed order",
    "statusbar.customer.customerAdjustedApproval.subtitle": "The order has been changed. Waiting for acknowledgement and confirmation.",
    "statusbar.customer.customerAdjustedApproval.button": "Request",
    "statusbar.customer.supplierAdjusted.label": "Order changed by supplier",
    "statusbar.customer.supplierAdjusted.subtitle": "The supplier has changed your order. Please confirm the changes.",
    "statusbar.customer.supplierAdjusted.button": "Confirm",
    "statusbar.customer.productUnavailable.label": "Product unavailable",
    "statusbar.customer.productUnavailable.subtitle": "The supplier cannot provide this product for the current port and delivery date. Change the port or delivery date to request it again.",
    "statusbar.customer.productUnavailable.updateOrderButton": "Update order",
    "statusbar.supplier.addAlternativeQuote.label": "Enquiry quoted",
    "statusbar.supplier.addAlternativeQuote.subtitle": "Your quote has been sent to the customer. You can add an alternative quote to offer a different option.",
    "statusbar.supplier.addAlternativeQuote.button": "Add alternative quote",
    "statusbar.supplier.spotenquiry.label": "Create offer",
    "statusbar.supplier.spotenquiry.subtitle": "It takes one step to create and send your offer to the customer. Press the button on the right to get started.",
    "statusbar.supplier.spotenquiry.button": "Create offer",
    "statusbar.supplier.enquiry.label": "Create quote",
    "statusbar.supplier.enquiry.subtitle": "It takes one step to create and send your quote to the customer. Press the button on the right to get started.",
    "statusbar.supplier.enquiry.button": "Create quote",
    "statusbar.supplier.spotquoted.label": "Offer sent",
    "statusbar.supplier.spotquoted.subtitle": "The customer has received your offer.",
    "statusbar.supplier.quoted.label": "Enquiry quoted",
    "statusbar.supplier.quoted.subtitle": "The customer has received your quote.",
    "statusbar.supplier.quoted.additionalOfferUnavailableForCustomer.subtitle": "Additional quotes are not available for this enquiry.",
    "statusbar.supplier.quoted.button": "Edit offer",
    "statusbar.supplier.confirmed.label": "Order confirmed",
    "statusbar.supplier.confirmed.subtitle": "Proceed with the arrangement of the physical supply and inform your customer about any potential changes.",
    "statusbar.supplier.delivery.label": "Delivery confirmation required",
    "statusbar.supplier.delivery.subtitle": "The planned delivery date has been reached and delivery confirmation is required to continue processing.",
    "statusbar.supplier.delivery.button": "Mark as delivered",
    "statusbar.supplier.spotorder.label": "Confirm order",
    "statusbar.supplier.spotorder.subtitle": "Congratulations! The customer selected your offer. Please finally confirm to proceed with the process and make use of the chat function to discuss further details. Optionally you also can acknowledge beforehand.",
    "statusbar.supplier.acknowledged.label": "Confirm order",
    "statusbar.supplier.acknowledged.subtitle": "The order has been acknowledged. Confirm to start processing. Use chat to discuss further details.",
    "statusbar.supplier.confirmButton": "Confirm",
    "statusbar.supplier.order.label": "Order received",
    "statusbar.supplier.order.subtitle": "The customer placed an order and is waiting for your confirmation.",
    "statusbar.supplier.order.acknowledgeButton": "Acknowledge",
    "statusbar.supplier.customerAdjusted.label": "Order change not yet effective",
    "statusbar.supplier.customerAdjusted.subtitle": "The customer updated the order, but the previous order remains valid until the changes are approved.",
    "statusbar.supplier.supplierAdjusted.label": "Order changed",
    "statusbar.supplier.supplierAdjusted.subtitle": "You have changed the order. Waiting for confirmation from customer.",
    "statusbar.supplier.delivered.label": "Order delivered",
    "statusbar.supplier.delivered.subtitle": "Estimated date of delivery has passed and delivery should have taken place.",
    "statusbar.supplier.deliveryconfirmed.label": "Order delivered",
    "statusbar.supplier.deliveryconfirmed.subtitle": "Estimated date of delivery has passed and delivery should have taken place.",
    "statusbar.supplier.invoiced.label": "Order invoiced",
    "statusbar.supplier.invoiced.subtitle": "The order has been marked as invoiced and can therefore no longer be edited.",
    "statusbar.supplier.canceled.label": "Order canceled",
    "statusbar.supplier.canceled.subtitle": "The order was canceled.",
    "statusbar.supplier.enquirycanceled.label": "Enquiry closed",
    "statusbar.supplier.enquirycanceled.subtitle": "Unfortunately your offer was not selected by the customer.",
    "statusbar.supplier.spotenquirycanceled.label": "Enquiry expired",
    "statusbar.supplier.spotenquirycanceled.subtitle": "A competitor’s offer was selected. Reducing your response time could improve your chances to win a spot enquiry.",
    "statusbar.supplier.spotqoutedeclined.label": "Offer not selected",
    "statusbar.supplier.spotqoutedeclined.subtitle": "Unfortunately your offer was not selected by the customer.",
    "statusbar.supplier.spotquotenotselected.label": "No offer selected",
    "statusbar.supplier.updateQuotes.label": "Update quotes",
    "statusbar.supplier.updateQuotes.subtitle": "The customer has changed the enquiry. Please update your quotes.",
    "statusbar.supplier.enquirydeclined.label": "Enquiry declined",
    "statusbar.supplier.enquirydeclined.subtitle": "The enquiry was declined.",
    "statusbar.supplier.enquiryexpired.label": "Enquiry closed",
    "statusbar.supplier.enquiryexpired.subtitle": "You cannot place an offer anymore.",
    "statusbar.supplier.updateQuote.label": "Update quote",
    "statusbar.supplier.updateQuote.subtitle": "The customer has changed the enquiry. Please update your quote.",
    "statusbar.supplier.updateQuote.button": "Update quote",
    "appname": "Closelink",
    "login.pageTitle": "Login",
    "login.contactUs": "Contact us",
    "login.gtcSupplier": "GTC supplier",
    "login.gtcCustomer": "GTC customer",
    "login.imprint": "Imprint",
    "setNewPassword.error.newPasswordRequired": "Please enter a new password",
    "setNewPassword.error.newPasswordTooShort": "Your password requires at least 6 characters",
    "setNewPassword.error.passwordRepeatInvalid": "Please enter your new password again",
    "setNewPassword.error.insecurePassword": "Please enter a more secure password",
    "passwordStrength.feedbackText": "This bar indicates the strength of your password. Fill it up for a strong password.",
    "passwordStrength.strongPassword": "This is a strong password!",
    "passwordStrength.score.0": "Risky password.",
    "passwordStrength.score.1": "Very weak password.",
    "passwordStrength.score.2": "Weak password.",
    "passwordStrength.score.3": "Good password.",
    "passwordStrength.score.4": "Very good password.",
    "passwordStrength.error.empty": "Password cannot be empty",
    "passwordStrength.error.minLength": "Password must be at least 8 characters long",
    "passwordStrength.error.needsMoreTypes": "Use at least {{missingTypes}} more different character type(s)",
    "passwordStrength.suggestion.minLength": "Use at least 8 characters",
    "passwordStrength.suggestion.lowercase": "Use at least one lowercase letter",
    "passwordStrength.suggestion.uppercase": "Use at least one uppercase letter",
    "passwordStrength.suggestion.number": "Use at least one number",
    "passwordStrength.suggestion.specialChar": "Use at least one special character (!@#$%^&*)",
    "searchResult.title": "Search results",
    "searchResult.empty.heading": "What are you looking for?",
    "searchResult.empty.placeholder": "Search orders and offers",
    "searchResult.empty.helper": "Try searching by a vessel name, port, supplier, or order number.",
    "searchResult.orders": "Orders",
    "searchResult.enquiries": "Enquiries",
    "order.showAll": "Show all",
    "order.equivalentTooltip": "Equivalent of {{productName}}",
    "order.editPageTitle": "Enquiry",
    "order.details": "Details",
    "order.sortedBy": "Sorted by:",
    "order.sort": "Sort:",
    "order.overviewPageTitle": "Orders",
    "order.searchInputPlaceholder": "Search orders",
    "order.filterCompanyPlaceholder": "Filter companies",
    "order.filterSupplierPlaceholder": "Filter suppliers",
    "order.filterCustomerPlaceholder": "Filter customers",
    "order.markReadToast.success": "Order marked read",
    "order.markReadToast.error": "Failed to mark order as read",
    "order.markUnreadToast.success": "Order marked unread",
    "order.markUnreadToast.error": "Failed to mark order unread",
    "order.deleteDraftToast.success": "Draft deleted",
    "order.deleteDraftToast.error": "Failed to delete draft",
    "order.lubes.productsNotInCatalog.heading": "Some products aren’t listed for this vessel",
    "order.lubes.productsNotInCatalog.description": "The following products are not part of the vessel product catalog: {{products}}.",
    "order.lubes.unmappedProducts.heading": "Unmapped products need review",
    "order.lubes.unmappedProducts.description": "Select a Closelink product for each imported item before sending the enquiry.",
    "order.lubes.viewProducts.button": "View product catalog",
    "order.lubes.viewProducts.title": "Product catalog: {{vesselName}} ({{vesselImo}})",
    "order.tableActions": "Actions",
    "order.draftlabel": "Draft",
    "order.customer": "Customer",
    "order.supplier": "Supplier",
    "order.company": "Company",
    "order.missingvessel": "Please select a vessel to continue the supplier selection.",
    "order.nosuppliers": "Unfortunately there is no supplier assigned to the company of this vessel.",
    "order.outdatedtooltip": "Out of date",
    "order.noncontractedsuppliers": "Non-contracted",
    "order.contractedsupplier": "Contracted",
    "order.coreDataSubText": "Please select the vessel and enter all port information. Furthermore you can enter a buyer reference.",
    "order.suppliersubtext.simple": "Select the recipients of your request.",
    "order.suppliersubtext": "Select the recipients of your request. Spot market enquiries will be sent to all suppliers with a potential product availability in the particular port.",
    "order.scheduleSharingLabel": "Share vessel schedule with suppliers",
    "order.scheduleSharingDescription": "Only eligible suppliers included in this enquiry can view planned port calls",
    "order.productssubtext": "Use the product brand of your choice. Closelink will provide each supplier with a product translation.",
    "order.allocate.header": "Invite more suppliers",
    "order.allocate.subheader": "Inviting further suppliers to this enquiry increases your chances to receive better terms.",
    "order.allocate.btnconfirm": "Invite suppliers",
    "order.allocate.btnallocate": "Select suppliers",
    "order.spotmarket": "Spot market",
    "order.supplierSelection.spotSubtitle": "Include the wider Closelink network to receive alternative offers from global and regional suppliers and traders.",
    "order.supplierSelection.limited": "Limited",
    "order.supplierSelection.limitedTooltip": "This supplier cannot respond via Closelink chat.",
    "order.supplierSelection.outdated": "Outdated",
    "order.supplierSelection.outdatedTooltip": "No valid price list is available for the selected delivery date. This price is based on the latest available price list and is shown for reference only.",
    "order.supplierSelection.outdatedTooltipValidUntil": "Price list valid until: {{date}}",
    "order.newrfqs": "Open requests",
    "order.suppliermessageinfo": "You can send messages after submitting your offer.",
    "order.forwardedOfferMessageInfo": "This supplier can’t send or receive messages on Closelink. Only system messages are shown.",
    "order.sendMessageFailedToast": "Message not sent",
    "order.others": "Others",
    "order.quotes.emptylist": "Waiting for offers",
    "order.quotes.moretocome": "Waiting for offers from Closelink network",
    "order.quotes.closed": "Enquiry closed",
    "order.quotes.draft": "Draft: Waiting for completion",
    "order.quotes.canceledSpotEnquiryWithoutOffers": "Enquiry canceled without any spot offers",
    "order.offercount": "Offers",
    "order.btnmakeoffer": "Place offer",
    "order.btnviewoffer": "View offer",
    "order.makeoffer": "Action",
    "order.approvalState": "Approval",
    "order.createnewspot.spot": "Enquiry",
    "order.createnewspot.title": "Create enquiry",
    "order.createnewspot.productequivalents": "Equivalents",
    "order.createnewspot.subtitle": "Order",
    "order.createnewspot.disclaimer": "The above spot enquiry will be sent to all lubricant suppliers that agreed to our terms & conditions.",
    "order.createnewspot.switchtodirectorder": "Switch to direct order",
    "order.createnewspot.additionalmessage": "Additional message",
    "order.createnewspot.translationstitle": "Product equivalent translations",
    "order.tab.DRAFTED": "Drafts",
    "order.tab.ENQUIRED": "Enquiries",
    "order.tab.ORDERED": "Ordered",
    "order.tab.ACKNOWLEDGED": "Acknowledged",
    "order.tab.DELIVERED": "Delivered",
    "order.tab.CANCELED": "Canceled",
    "order.tab.EXPIRED": "Expired",
    "order.tab.CONFIRMED": "Confirmed",
    "order.detail.headline": "Enquiry",
    "order.detail.offers": "Offers",
    "order.detail.showMore": "Show more",
    "order.detail.spot": "Spot",
    "order.detail.approvalStatusLabel": "Approval status: ",
    "order.detail.waschangedwarning": "Waiting for offer to be updated by supplier",
    "order.detail.contracted": "Contracted suppliers",
    "order.detail.contractedenquiry": "Contract enquiry",
    "order.detail.contractual": "Contractual",
    "order.detail.paymentTerm": "Payment terms",
    "order.detail.spotenquiry": "Enquiry",
    "order.detail.waiting": "Waiting for offer",
    "order.detail.contractedsupplier": "Contracted supplier",
    "order.detail.declined": "Enquiry declined",
    "order.detail.state": "Status",
    "order.detail.edit": "Edit",
    "order.detail.btncancel": "Cancel enquiry",
    "order.detail.btncreateorder": "Create order",
    "order.detail.btnsendorder": "Send order",
    "order.detail.btnopenorder": "Open order",
    "order.detail.btnopenenquiry": "Open detail",
    "order.detail.btnopenoffer": "Open offer",
    "order.detail.warningtxt": "Changes have been made",
    "order.detail.warningtxtincomplete": "Information on price is incomplete",
    "order.detail.additionalmessage": "Additional message",
    "order.detail.supplierterms": "<a href='{{url}}' target='_blank'>Terms & conditions</a><br /> of {{supplier}}",
    "order.detail.noticedaysinfo": "Notice days: {{noticedays}}",
    "order.detail.noticedays": "Notice days",
    "order.detail.etdIsBelowNoticeDays": "Estimated delivery is below notice days",
    "order.detail.perLiter": "{{price}} per liter",
    "order.detail.offerComparison.overviewTab": "Overview",
    "order.detail.lineItemComparison.productsTab": "Products",
    "order.detail.lineItemComparison.differentFromRequestedProduct": "Different from requested product",
    "order.detail.lineItemComparison.differentFromRequestedProductWithName": "Different from requested product: {{productName}}",
    "order.detail.lineItemComparison.equivalentProduct": "Equivalent product: {{productName}}",
    "order.detail.lineItemComparison.equivalentToRequestedProduct": "Equivalent to requested product",
    "order.detail.lineItemComparison.sampleKitQuantity": "Sample kit - qty {{quantity}}",
    "order.detail.daysNotice": "{{days}} day(s) notice",
    "order.detail.redispatch": "Redispatch",
    "order.detail.showenquires": "Show enquiries",
    "order.detail.showofferlist": "Show offer list",
    "order.detail.showunquoted": "Show unqouted",
    "order.detail.hideunquoted": "Hide unqouted",
    "order.detail.surcharges": "Surcharges",
    "order.detail.header.headline": "Order",
    "order.detail.header.actions.edit": "Edit",
    "order.detail.header.actions.copy": "Copy enquiry to new enquiry",
    "order.detail.header.actions.showOfferList": "Show offer list",
    "order.detail.header.actions.redispatch": "Redispatch",
    "order.detail.header.actions.showOrderedProducts": "Show ordered products",
    "order.detail.header.actions.cancelAll": "Cancel all",
    "order.detail.header.actions.export": "Download enquiry as PDF",
    "order.detail.coreData.vessel": "Vessel",
    "order.detail.coreData.vesselPopup.button": "Info",
    "order.detail.coreData.vesselPopup.headline": "Vessel details",
    "order.detail.coreData.vesselPopup.name": "Name",
    "order.detail.coreData.vesselPopup.mmsi": "MMSI",
    "order.detail.coreData.vesselPopup.type": "Type",
    "order.detail.coreData.vesselPopup.registrationPlace": "Place of registration",
    "order.detail.coreData.vesselPopup.deadweight": "Deadweight",
    "order.detail.coreData.vesselPopup.grossTonnage": "Gross tonnage",
    "order.detail.coreData.vesselPopup.viewVesselInfo": "View details",
    "order.detail.coreData.agentPopup.headline": "Agent details",
    "order.detail.coreData.agentPopup.button": "View details",
    "order.detail.coreData.agentPopup.generalData": "General data",
    "order.detail.coreData.agentPopup.mainContactData": "Main contact data",
    "order.detail.coreData.agentPopup.name": "Agent name",
    "order.detail.coreData.agentPopup.ports": "Ports",
    "order.detail.coreData.agentPopup.address": "Address",
    "order.detail.coreData.agentPopup.remarks": "Remarks",
    "order.detail.coreData.agentPopup.contact.name": "Contact name",
    "order.detail.coreData.agentPopup.contact.phoneNumber": "Contact phone number",
    "order.detail.coreData.agentPopup.contact.address": "Contact address",
    "order.detail.coreData.agentPopup.contact.emailAddress": "Contact email address",
    "order.detail.coreData.agentPopup.contact.faxNumber": "Fax",
    "order.detail.coreData.port": "Port",
    "order.detail.coreData.dateDelivery": "Estimated delivery",
    "order.detail.coreData.company": "Company",
    "order.detail.coreData.agent": "Agent",
    "order.detail.coreData.dateCreated": "Date created",
    "order.detail.coreData.buyerReference": "Buyer reference",
    "order.detail.coreData.spotSuppliers": "Spot suppliers",
    "order.detail.coreData.source": "Source",
    "order.detail.coreData.contractedSuppliers": "Contracted suppliers",
    "order.detail.coreData.orderNumber": "Order number",
    "order.detail.coreData.status": "Status",
    "order.detail.coreData.creationComment": "Imported information",
    "order.detail.coreData.comment": "Comment",
    "order.detail.coreData.noAgent": "No agent added",
    "order.detail.offerCard.waitingForQuote": "Waiting for quote",
    "order.detail.offerCard.quoted": "Quoted",
    "order.detail.offerCard.ordered": "Ordered",
    "order.detail.offerCard.viewOrder": "View order",
    "order.detail.offerCard.canceled": "Canceled",
    "order.detail.offerCard.actions.viewSupplierDetails": "View supplier details",
    "order.detail.offerCard.actions.requestKyc": "Request KYC",
    "order.detail.offerCard.actions.cancelKycRequest": "Cancel KYC request",
    "order.detail.offerCard.actions.cancelRequest": "Cancel request",
    "order.detail.offerCard.actions.cancelOffer": "Cancel offer",
    "order.detail.offerCard.cancelPopup.enquiry.headline": "Cancel request?",
    "order.detail.offerCard.cancelPopup.enquiry.button": "Cancel request",
    "order.detail.offerCard.cancelPopup.quoted.headline": "Cancel offer?",
    "order.detail.offerCard.cancelPopup.quoted.button": "Cancel offer",
    "order.detail.offerCard.cancelPopup.description": "You have to state a reason for the cancellation. The reason will also be displayed to the supplier.",
    "order.detail.offerCard.cancelPopup.lastOpen.description": "You have to state a reason for the cancellation. The reason will also be displayed to the supplier. You are canceling the last open offer. The enquiry will remain open. You can request more suppliers.",
    "order.detail.offerCard.cancelPopup.lastOpen.descriptionWithSpot": "You have to state a reason for the cancellation. The reason will also be displayed to the supplier. You are canceling the last open offer. The enquiry will remain open. You can request more suppliers or use the spot market.",
    "order.detail.offerCard.enquiryDeclined": "Enquiry declined",
    "order.detail.showDeclinedSpotOffer": "Show 1 declined spot offer",
    "order.detail.showDeclinedSpotOffers": "Show {{count}} declined spot offers",
    "order.detail.hideDeclinedSpotOffers": "Hide declined spot offers",
    "order.detail.offerCard.viewOfferDetails": "View offer details",
    "order.detail.offerCard.waitingForApproval": "Waiting for approval",
    "order.detail.offerCard.approved": "Approved",
    "order.detail.offerCard.declined": "Approval declined",
    "order.detail.offerCard.withdrawn": "Approval withdrawn",
    "order.detail.offerCard.withdrawnMessage": "Changes made, approval withdrawn.",
    "order.detail.offerCard.requestExpired": "Expired approval",
    "order.detail.offerCard.changed": "Changed",
    "order.detail.offerCard.supplierRead": "Read by supplier",
    "order.detail.offerCard.waitingForQuoteUpdate": "Waiting for quote update",
    "order.detail.offerCard.bestLiterPrice": "Best liter price",
    "order.detail.offerCard.recommended": "Recommended",
    "order.detail.offerCard.portChanged": "Port changed",
    "order.detail.requestSuppliers.button": "Request more suppliers",
    "order.detail.requestSuppliers.errorToast": "Suppliers not requested, please try again",
    "order.detail.requestSuppliers.spot": "Spot market",
    "order.detail.requestSuppliers.title": "Request more suppliers",
    "order.detail.requestSuppliers.description": "By expanding the number of suppliers, you increase your chances of receiving better conditions.",
    "order.detail.requestSuppliers.suppliers": "Suppliers",
    "order.detail.requestSuppliers.contractsLabel": "Contracts",
    "order.detail.requestSuppliers.contractCount": "{{count}} contracts",
    "order.detail.requestSuppliers.cancel": "Cancel",
    "order.detail.requestSuppliers.submit": "Send request",
    "order.detail.defaultContractReference.referenceOnly": "For reference only",
    "order.detail.defaultContractReference.description": "Based on the vessel default contract.",
    "order.detail.redispatchSuccessToast": "Order redispatched",
    "order.detail.redispatchErrorToast": "Failed to redispatch order",
    "order.detail.orderModal.offerAcceptance": "Offer acceptance",
    "order.detail.orderModal.termsAndConditions1": "Acceptance of the offer implies agreement to the",
    "order.detail.orderModal.termsAndConditions2": "of {{supplier}}, unless other individual agreements take precedence.",
    "order.detail.orderModal.termsAndConditionsLink": "Terms & conditions",
    "order.detail.orderModal.onAcceptance": "On acceptance, all other offers will expire and suppliers will be notified.",
    "order.detail.orderModal.placeOrder": "Place order",
    "order.detail.orderModal.acceptLabel": "I have read and accept the terms & conditions",
    "order.detail.orderModal.total": "Total",
    "order.detail.orderModal.partialTotal": "Subtotal",
    "order.detail.orderModal.pricingToBeConfirmed": "To be confirmed",
    "order.detail.orderModal.partialPricing": "{{price}} (partial pricing available)",
    "order.list.copy": "Copy to new Enquiry",
    "order.list.action": "Action",
    "order.spotNumber": "Enquiry",
    "order.actions.seemoredetails": "+ see more details",
    "order.actions.exportinfo": "Export",
    "order.actions.currentorder": "Show ordered Products",
    "order.actions.initialinfo": "Initial RfQ/order",
    "order.itemsDrawerTitle": "Ordered products",
    "order.showEnquiredProducts": "Show enquired products",
    "order.hideEnquiredProducts": "Hide enquired products",
    "order.ordertype": "Order type",
    "order.excludeAssignedSuppliersInfo": "By default, your contractual suppliers linked to you in Closelink will receive a normal enquiry.",
    "order.excludeAssignedSuppliers": " Click here to exclude your contractual suppliers completely from this enquiry",
    "order.contractorder": "Contract enquiry",
    "order.spotenquiry": "Enquiry",
    "order.additionalcharges": "Additional charges per supplier may apply.",
    "order.commentForSupplier": "Add notes for suppliers",
    "order.commentForSupplierCaption": "Please note that your comment will be shared with all selected suppliers.",
    "order.supplyMode.label": "Supply mode",
    "order.supplyMode.placeholder": "Please select…",
    "order.noticeDays.label": "Notice days",
    "order.noticeDays.tooltip": "Notice days",
    "order.noticeDays.placeholder": "e.g. 2",
    "order.createnew": "New enquiry",
    "order.createNewDraft": "Enquiry",
    "order.draft": "Draft",
    "order.source.maerskIntegration": "Ship Manager",
    "order.source.publicApi": "Public API",
    "order.source.vesselRequisition": "Vessel requisition",
    "order.source.mariApps": "MariApps",
    "order.source.cloudFleetManagerIntegration": "Cloud Fleet Manager",
    "order.source.bassNetIntegration": "BASSnet",
    "order.saveAsDraftButton": "Save draft",
    "order.saveDraftButton": "Save draft",
    "order.savedAsDraftToast": "Draft saved",
    "order.successDraftToast": "Draft saved",
    "order.errorDraftToast": "Couldn't save draft",
    "order.validationFailedToast": "Validation failed. Please review your entered information and try again.",
    "order.tankLabel": "Tank: {{tankName}} ({{oilType}})",
    "order.editexisting": "Edit",
    "order.notice": "Please complete marked fields to send offer. Time elapsed since enquiry: {{time}}",
    "order.contractednotice": "This enquiry is part of a general spot enquiry. To ensure equal comparability, changes are not possible. You can only change details after creating the order at the spot offer overview.",
    "order.createdBy": "{{date}} by {{name}}",
    "order.updatedBy": "{{date}} by {{name}}",
    "order.disclaimer": "Information displayed is AIS based and has been provided by our partnering service provider FleetMon. We cannot take responsibility for the accuracy of the data received. Please verify the chosen port and delivery date in the course of the order process.",
    "order.applynextport": "Apply port & date",
    "order.route.past": "Last port",
    "order.route.present": "Current location",
    "order.route.future": "Next port",
    "order.route.order": "Order port",
    "order.route.received": "received",
    "order.vesselinfo.missing": "No information available.",
    "order.vesselinfo.general": "The ship {{name}} (IMO: {{imo}}, MMSI: {{mmsiNumber}}) is a {{type}} registered in {{flag}}. ",
    "order.vesselinfo.deadweight": "The vessel has a deadweight of {{dwt}} tonnes. ",
    "order.vesselinfo.buildyear": "It was built in {{yearBuild}}. ",
    "order.vesselinfo.gtonnage": "The gross tonnage is {{gt}}. ",
    "order.vesselinfo.tonnes": "{{grossTonnage}} tonnes",
    "order.productunit": "Unit",
    "order.productunitvalue": "L",
    "order.productgroup": "Group",
    "order.requestedproduct": "Req:",
    "order.type": "Type",
    "order.emptylist": "No entries",
    "order.createtitle": "New order",
    "order.translated": "<strong>Warning!</strong><br /> The translation of your products is only a suggestion. Please make sure you are ordering the right products and get in touch with your supplier, if necessary!",
    "order.btnreject": "Reject",
    "order.emptymessages": "No messages yet",
    "order.addCoreData": "Add",
    "order.additem": "Add product",
    "order.addsurcharge": "Add surcharge / waiver",
    "order.subtitle": "Order",
    "order.listsubtitle": "Orders",
    "order.headline": "Orders",
    "order.overview": "Overview",
    "order.enquiryorder": "Enquiry / order",
    "order.directorder": "Direct order",
    "order.switchtospot": "Switch to enquiry",
    "order.price": "Price",
    "order.pricePopover": "Based on each product’s dedicated unit (e.g. liter or kilogram)",
    "order.pos": "Pos",
    "order.category": "Category",
    "order.ordernumber": "Order number",
    "order.id": "ID",
    "order.date": "Date created",
    "order.created": "Created",
    "order.status": "Status",
    "order.dateConfirmation": "Date confirmation",
    "order.product": "Product",
    "order.volume": "Volume",
    "order.itemtotal": "Total",
    "order.new": "New order",
    "order.send": "Send",
    "order.agent": "Agent",
    "order.agentemail": "Agent mail",
    "order.agentphone": "Agent phone",
    "order.invoiceaddress": "Invoice address",
    "order.alternativeport": "Alternative port",
    "order.vessel": "Vessel",
    "order.port": "Port",
    "order.unit": "Unit",
    "order.total": "Total",
    "order.comment": "Comment",
    "order.coreData": "Vessel & port",
    "order.suppliers": "Suppliers",
    "order.products": "Products",
    "order.unitsize": "Packsize",
    "order.packtype": "Packtype",
    "order.quantity": "Quantity",
    "order.agentOptional": "Agent",
    "order.buyerreference": "Buyer reference",
    "order.buyerReferenceOptional": "Buyer reference",
    "order.buyerreferenceshort": "Buyer ref.",
    "order.previousBuyerReferences.info": "Previous buyer references: {{references}}",
    "order.vendorreference": "Vendor reference",
    "order.vendorreferenceshort": "Vendor ref.",
    "order.btnsave": "Save",
    "order.surcharges.createtitle": "Create surcharge/waiver",
    "order.surcharges.addButton": "Surcharge/waiver",
    "order.surcharges.surcharge": "Surcharge",
    "order.surcharges.waiver": "Waiver",
    "order.surcharges.name": "Description",
    "order.surcharges.value": "Amount",
    "order.samplekit.title": "Used oil sample kit",
    "order.samplekit.packtype": "Packet",
    "order.samplekit.add": "Add oil sample kit",
    "order.samplekit.createtitle": "Add sample kit",
    "order.samplekit.name.placeholder": "Short description",
    "order.samplekit.name.label": "Name",
    "order.samplekit.quantity.placeholder": "e.g. 1",
    "order.samplekit.quantity.label": "Package quantity",
    "order.samplekit.total.placeholder": "e.g. 100",
    "order.packagePrices.total": "Total",
    "order.packagePrices.product": "Product",
    "order.emailQuoteSupplierWarning": "Your enquiry will be forwarded to all chosen suppliers, but kindly be aware that {{supplier}} cannot respond via Closelink chat.",
    "order.btncreate": "Send enquiry",
    "order.btncompare": "Compare",
    "order.editproducts": "Edit",
    "order.btnenquiry": "Send enquiry",
    "order.btnorder": "Send order",
    "order.btnenquiryorder": "Send as …",
    "order.btnopenspotoverview": "Open offer overview",
    "order.btncancel": "Cancel",
    "order.btnclose": "Close",
    "order.btnconfirm": "Confirm",
    "order.btndeliveryconfirm": "Confirm delivery",
    "order.confirmdelivery": "Confirm delivery data",
    "order.confirmdeliverycopy": "Please check all relevant information before confirming the delivery.",
    "order.btndelivered": "Delivered",
    "order.btnadjust": "Adjust order",
    "order.btquote": "Quote enquiry",
    "order.btnspotquote": "Send offer",
    "order.btndeletedraft": "Delete draft",
    "order.btndelete": "Delete",
    "order.dateDelivery": "Estimated delivery",
    "order.dateDeliveryShort": "Est. delivery",
    "order.dateDeliveryConfirmed": "Delivery date",
    "order.daysuntil": "(in {{days}} days)",
    "order.daysUntilTomorrow": "(tomorrow)",
    "order.daystoday": "(Today)",
    "order.copy": "Copy to new enquiry",
    "order.createEnquiryButton": "Create enquiry",
    "order.markread": "Mark as read",
    "order.markunread": "Mark as unread",
    "order.export.button": "Export",
    "order.export.calloutDescription": "Includes orders from the ordered stage onward. Date range is based on delivery date.",
    "order.export.calloutHeading": "Drafts, enquiries, and quoted offers aren't included",
    "order.export.cancelButton": "Cancel",
    "order.export.customerGroupLabel": "Customer group",
    "order.export.datePresets.currentYear": "Current year ({{year}})",
    "order.export.datePresets.lastMonth": "Last month",
    "order.export.datePresets.lastYear": "Last year ({{year}})",
    "order.export.downloadButton": "Export",
    "order.export.errorToast": "Error exporting orders",
    "order.export.pdf": "Export as PDF",
    "order.export.title": "Export orders",
    "order.export.vessel": "Notify vessel",
    "order.history.drawerTitle": "Initial enquiry",
    "order.deliveredorders.confirm": "Confirm details",
    "order.deliveredorders.completeorder": "Action",
    "order.recentactivities.open": "Open",
    "order.recentactivities.openorder": "Action",
    "order.customerRead": "Read",
    "order.customerReadTooltip": "Read by customer",
    "order.customerReadShort": "CR",
    "order.supplierRead": "Read",
    "order.supplierReadTooltip": "Read by supplier",
    "order.supplierReadShort": "SR",
    "order.stockbox.lastUpdatedTooltip": "Last updated: {{date}}",
    "order.stockbox.day": "{{day}} day ago",
    "order.stockbox.days": "{{days}} days ago",
    "order.stockbox.hour": "{{hour}} hour ago",
    "order.stockbox.hours": "{{hours}} hours ago",
    "order.stockbox.minute": "{{minute}} minute ago",
    "order.stockbox.minutes": "{{minutes}} minutes ago",
    "order.productSuccessorHintTooltip": "New product name available. Click to select latest product name.",
    "order.lubricationChart": "View lubrication chart",
    "order.edit.headline": "Edit enquiry {{orderId}}",
    "order.edit.toast.update.error": "Failed to update order",
    "order.edit.update": "Update enquiry",
    "order.edit.cancel": "Cancel",
    "order.quickfilter.all": "All",
    "order.quickfilter.notApproved": "Not approved",
    "order.quickfilter.notConfirmed": "Not confirmed",
    "order.quickfilter.notAcknowledged": "Not acknowledged",
    "order.quickfilter.open": "Open",
    "ports.headline": "Ports",
    "ports.subheadline": "Overview",
    "ports.create": "Create port",
    "ports.emptylist": "No ports yet",
    "port.emptyList": "No ports yet",
    "port.createTitle": "Create port",
    "port.editTitle": "Edit port",
    "port.createPort": "Create port",
    "port.updatePort": "Update port",
    "port.subtitle": "Port details",
    "port.name": "Port",
    "port.locode": "Locode",
    "port.latitude": "Latitude",
    "port.longitude": "Longitude",
    "port.country": "Country",
    "port.aliases": "Aliases",
    "port.locCodeAliases": "Locode aliases",
    "port.timeZone": "Timezone",
    "port.locodeAlreadyExists": "A locode you entered already exists. Please check existing ports and their locodes.",
    "port.generalError": "Sorry, something went wrong.",
    "port.createPortSuccessToast": "Port created",
    "port.updatePortSuccessToast": "Port updated",
    "port.updatePortErrorToast": "Port was not updated",
    "port.requiredError": "Required",
    "port.longitudeOptionalLabel": "Longitude",
    "port.latitudeOptionalLabel": "Latitude",
    "port.aliasesOptionalLabel": "Aliases",
    "port.locCodeAliasesOptionalLabel": "Locode aliases",
    "portdirectory.info": "Information received from the supplier's official and publicly accessible homepage in January 2017. No guarantee for accuracy and currentness of shown data. Error in information can occur. Please liaise with your supplier to ensure a smooth delivery.",
    "portdirectory.titleshort": "Port & order info",
    "portdirectory.title": "Port & order information",
    "portdirectory.noticerequired": "Notice required",
    "portdirectory.deliverymode": "Delivery mode",
    "portdirectory.deliverytype": "Delivery type",
    "portdirectory.bulkmin": "Bulk min: ",
    "portdirectory.ibcsmin": "IBCs min: ",
    "portdirectory.drumspumpedmin": "Drums pumped min: ",
    "portdirectory.packedmin": "Packed min: ",
    "portdirectory.truckmin": "Truck min: ",
    "portdirectory.bargemin": "Barge min: ",
    "portdirectory.bulknotice": "Bulk notice:",
    "portdirectory.generalnotice": "General notice:",
    "portdirectory.workingdays": "working day(s)",
    "portdirectory.notesandcharges.title": "Notes & charges",
    "portdirectory.productrange.title": "Product range availability",
    "portdirectory.productrange.CASTROL_CORE.name": "CORE",
    "portdirectory.productrange.CASTROL_CORE.description": "Castrol's core range of marine products are normally available at this port.",
    "portdirectory.productrange.CASTROL_MAIN.name": "MAIN",
    "portdirectory.productrange.CASTROL_MAIN.description": "A broad range of Castrol's marine products, in addition to the core range, are available at this port.",
    "portdirectory.productrange.CASTROL_FULL.name": "FULL",
    "portdirectory.productrange.CASTROL_FULL.description": "A complete range of Castrol's marine products, including Core and Main grades, are available at this port.",
    "portdirectory.productrange.CASTROL_EXTERN.name": "EXTERN",
    "portdirectory.productrange.CASTROL_EXTERN.description": "In this country Castrol's marine products are available via local partners.",
    "portdirectory.productrange.LUBMARINE_PREMIUM.name": "PREMIUM",
    "portdirectory.productrange.LUBMARINE_PREMIUM.description": "The full list of marine and auxiliary lubricants, including a full range of synthetic lubricants and greases, is available in ports designated as Premium.",
    "portdirectory.productrange.LUBMARINE_CORE.name": "CORE",
    "portdirectory.productrange.LUBMARINE_CORE.description": "The core range of marine and auxiliary lubricants meeting most common marine lubricant applications is available in ports designated as Core.",
    "portdirectory.productrange.LUBMARINE_LIMITED.name": "LIMITED",
    "portdirectory.productrange.LUBMARINE_LIMITED.description": "Only a limited range and limited quantity of marine lubricants is available in ports designated as Limited.",
    "portdirectory.productrange.LUBMARINE_SI.name": "STE",
    "portdirectory.productrange.LUBMARINE_SI.description": "Subject to Inquiry. Please contact our office to receive confirmation of stock availability and date of delivery.",
    "portdirectory.productrange.LUKOIL_FULL.name": "FULL",
    "portdirectory.productrange.LUKOIL_FULL.description": "At a port which belongs to the Full range group, all LUKOIL Marine Lubricants are available.",
    "portdirectory.productrange.LUKOIL_CORE.name": "CORE",
    "portdirectory.productrange.LUKOIL_CORE.description": "Ports that belong to the Extended and Core range group offer slightly fewer products then the Full range although the important main grades are available.",
    "portdirectory.productrange.LUKOIL_EXTENDED.name": "EXTENDED",
    "portdirectory.productrange.LUKOIL_EXTENDED.description": "Ports that belong to the Extended and Core range group offer slightly fewer products then the Full range although the important main grades are available.",
    "portdirectory.productrange.LUKOIL_STI.name": "STE",
    "portdirectory.productrange.LUKOIL_STI.description": "Ports that are marked as STI - Subject to inquiry - please contact your local office to evaluate supply possibilities. ",
    "portdirectory.productrange.CHEVRON_HALLMARK.name": "HALLMARK",
    "portdirectory.productrange.CHEVRON_HALLMARK.description": "Chevron is now delivering even more at 25 stategic Hallmark Ports.",
    "portdirectory.productrange.CHEVRON_LUBRICANTS.name": "LUBE PORT",
    "portdirectory.productrange.CHEVRON_LUBRICANTS.description": "Ports where Chevron's marine products are available.",
    "portdirectory.productrange.EXXON_ONE_STAR.name": "1 STAR",
    "portdirectory.productrange.EXXON_ONE_STAR.description": "The star rating indicates the available product portfolio and potentially the leadtimes and supply options.",
    "portdirectory.productrange.EXXON_TWO_STAR.name": "2 STAR",
    "portdirectory.productrange.EXXON_TWO_STAR.description": "The star rating indicates the available product portfolio and potentially the leadtimes and supply options.",
    "portdirectory.productrange.EXXON_THREE_STAR.name": "3 STAR",
    "portdirectory.productrange.EXXON_THREE_STAR.description": "The star rating indicates the available product portfolio and potentially the leadtimes and supply options.",
    "portdirectory.productrange.EXXON_FOUR_STAR.name": "4 STAR",
    "portdirectory.productrange.EXXON_FOUR_STAR.description": "The star rating indicates the available product portfolio and potentially the leadtimes and supply options.",
    "portdirectory.productrange.EXXON_FIVE_STAR.name": "5 STAR",
    "portdirectory.productrange.EXXON_FIVE_STAR.description": "The star rating indicates the available product portfolio and potentially the leadtimes and supply options.",
    "portdirectory.productrange.SHELL_STANDARD.name": "LUBE PORT",
    "portdirectory.productrange.SHELL_STANDARD.description": "Ports where Shell's marine products are available.",
    "portdirectory.productrange.GULF_STANDARD.name": "LUBE PORT",
    "portdirectory.productrange.GULF_STANDARD.description": "Ports where Gulf's marine products are available.",
    "country.name": "Country",
    "country.placeholder.name": "Country",
    "priceCompare.compareBtn": "Compare prices",
    "priceCompare.updatedToastDeliveryDate": "Supplier, port and estimated delivery date updated",
    "priceCompare.updatedToast": "Supplier and port updated",
    "priceCompare.singleBestPrice.heading": "Prices for {{supplier}} in {{port}} may be lower",
    "priceCompare.singleBestPrice.description": "Based on your selection, we calculated that you can save with {{supplier}} in {{port}}.",
    "priceCompare.singleBestPrice.applyBtn": "Apply",
    "priceCompare.lowerOptionsAvailable.heading": "Lower priced options available",
    "priceCompare.lowerOptionsAvailable.description": "Optimize your selection by comparing prices for all selected products across multiple ports.",
    "priceCompare.discoverBestPrices.heading": "Discover the best prices",
    "priceCompare.discoverBestPrices.description": "Optimize your selection by comparing prices for all selected products across multiple ports.",
    "placeholder.filter.customer": "Filter by customers",
    "placeholder.filter.company": "Filter by companies",
    "placeholder.filter.supplier": "Filter by suppliers",
    "placeholder.userType": "Select member type",
    "placeholder.role": "Select role",
    "placeholder.apikey": "Select company access Level",
    "placeholder.group": "Group",
    "placeholder.customergroup": "Customer group",
    "placeholder.suppliergroup": "Supplier group",
    "placeholder.reportfilter": "Filter report…",
    "placeholder.productunit": "L/KG",
    "placeholder.port": "Search ports…",
    "placeholder.customer": "Select customers…",
    "placeholder.company": "Select company…",
    "placeholder.supplier": "Select suppliers…",
    "placeholder.packType": "Please select…",
    "placeholder.packSize": "e.g. 208",
    "placeholder.quantity": "e.g. 100",
    "placeholder.price": "e.g. 2.239",
    "placeholder.name": "Name",
    "placeholder.agent": "e.g. Black Pearl Agency, Sparrow Street…",
    "placeholder.dateDelivery": "e.g. 30/06/2016",
    "placeholder.search": "Search list…",
    "placeholder.product": "Start typing to search…",
    "placeholder.buyerreference": "e.g. 123456",
    "placeholder.password": " ",
    "placeholder.message": "Additional message…",
    "placeholder.leaveAComment": "Leave a comment…",
    "placeholder.write": "Write message…",
    "placeholder.surcharges.value": "e.g. 100.00",
    "placeholder.surcharges.name": "Short notice",
    "placeholder.phone": "e.g. +49 213123123",
    "placeholder.fax": "e.g. +49 213123123 1",
    "placeholder.vessel.search": "Search vessels",
    "placeholder.vessel.company": "e.g. Sample Corp.",
    "placeholder.noticeDays": "e.g. 5",
    "placeholder.vendorReference": "e.g. 123456",
    "product.type": "Type",
    "product.category": "Category",
    "schedule.arrival": "Arrival",
    "schedule.departure": "Departure",
    "schedule.priceCompare.defaultSupplier": "Default supplier",
    "schedule.priceCompare.bestAlternative": "Best alternative",
    "schedule.priceCompare.lowestPrice": "Lowest price",
    "schedule.priceCompare.marketPrice": "Market price",
    "schedule.priceCompare.bestContract": "Best contract",
    "schedule.priceCompare.cheapestOption": "Cheapest option",
    "schedule.priceCompare.difference": "Difference: {{difference}}",
    "schedule.priceCompare.basedOnCalculatedAverageLubes": "Based on calculated average: {{averageConsumption}} L/day",
    "schedule.priceCompare.basedOnFixedAverageLubes": "Based on fixed average: {{averageConsumption}} L/day",
    "schedule.priceCompare.daysLeftSailing": "{{daysLeft}} days left sailing",
    "schedule.priceCompare.oneDayLeftSailing": "1 day left sailing",
    "schedule.priceCompare.tooltipSafetyReserve": "Safety reserve:",
    "schedule.priceCompare.tooltipWarningLimit": "Warning limit:",
    "schedule.priceCompare.tooltipConsumptionRate": "Consumption rate:",
    "schedule.priceCompare.tooltipRemainingSailing": "Remaining sailing:",
    "schedule.priceCompare.oneDay": "1 day",
    "schedule.priceCompare.multipleDays": "{{days}} days",
    "schedule.priceCompare.unitLiters": "L",
    "schedule.priceCompare.unitLitersPerDay": "L/day",
    "schedule.priceCompare.outOfReach": "Out of reach",
    "schedule.priceCompare.onSafetyReserve": "Safety reserve",
    "schedule.priceCompare.warningLimit": "Warning limit",
    "schedule.unavailable.title": "Vessel schedule unavailable",
    "schedule.unavailable.description": "Vessel schedules are provided through an integration with your fleet management system. To enable schedules for your fleet, please contact our support team.",
    "schedule.portCall": "Port call",
    "vessel.company": "Company",
    "vessel.stocks": "Stocks",
    "vessel.scheduleEmpty": "No schedule data",
    "vessel.paying": "Paying",
    "vessel.active": "Active",
    "vessel.directOrderAllowed": "Direct order allowed",
    "vessel.info": "Details",
    "vessel.editInfo": "Edit",
    "vessel.invoicecompany": "Invoice company",
    "vessel.searchCompanyPlaceholder": "Search for a company…",
    "vessel.filterCompanyPlaceholder": "Filter for a company…",
    "vessel.emptylist": "No vessels found.",
    "vessel.noResults.description": "Try adjusting your filters to find the vessels you're looking for.",
    "vessel.name": "Vessel",
    "vessel.imo": "IMO",
    "vessel.types": "Types",
    "vessel.services": "Services",
    "vessel.customer": "Customer",
    "vessel.id": "Vessel ID",
    "vessel.vesseltype": "Type",
    "vessel.schedule": "Schedule",
    "vessel.compareSuppliers": "Compare supply options",
    "vessel.invoiceaddress": "Invoice address",
    "vessel.form.email": "Email address",
    "vessel.form.defaultSupplier": "Default supplier",
    "vessel.form.defaultContract": "Default contract",
    "vessel.form.defaultContractAutoSelected": "This contract was selected automatically because it was the only applicable contract. You can change or remove it.",
    "vessel.form.invoiceInformation": "Invoice information",
    "vessel.form.postalAddress": "Postal address",
    "vessel.form.billingAddress": "Billing address",
    "vessel.form.address": "Address",
    "vessel.form.address.optional": "Address",
    "vessel.form.postalCode": "Postal code",
    "vessel.form.streetNumber": "Street number",
    "vessel.form.townCity": "Town/City",
    "vessel.form.nameRequired": "Please enter a vessel name",
    "vessel.form.imoRequired": "Please enter an IMO number",
    "vessel.form.companyNameRequired": "Please enter a company name",
    "vessel.form.vat": "VAT number",
    "vessel.form.invoiceEmailAddress": "Invoice email address",
    "vessel.form.countryRequired": "Please enter a country name",
    "vessel.form.streetName": "Street name",
    "vessel.form.streetRequired": "Please enter a street name",
    "vessel.form.streetNumberRequired": "Please enter a street number",
    "vessel.form.cityRequired": "Please enter a city name",
    "vessel.form.zipCodeRequired": "Please enter a postal code",
    "vessel.form.adminSettings": "Admin settings",
    "vessel.form.activeVessel": "Active vessel",
    "vessel.form.payingVessel": "Paying vessel",
    "vessel.form.directOrder": "Direct order",
    "vessel.lastedit": "Last edit",
    "vessel.edit.editVessel": "Edit vessel",
    "vessel.edit.updateVessel": "Update vessel",
    "vessel.edit.emailNotifications": "Email alerts",
    "vessel.edit.emailNotificationsText": "By enabling any of the following email alerts, the company will no longer receive these emails for this vessel.",
    "vessel.edit.recipients": "Recipients",
    "vessel.edit.orderUpdates": "Order updates",
    "vessel.edit.orderUpdatesText": "e.g new offer, offer changes to order, order changes to order confirmed and chat messages.",
    "vessel.edit.stockWarningLevel": "Stock warning level",
    "vessel.edit.stockWarningLevelText": "A reminder is sent when a warning level of a tank is reached.",
    "vessel.edit.safetyReserve": "Safety reserve level",
    "vessel.edit.safetyReserveText": "A reminder is sent when a safety reserve level of a tank is reached.",
    "vessel.edit.keyPortCall": "Key port call",
    "vessel.edit.keyPortCallText": "An alert is sent if a vessel calls a key port within the next 6 weeks.",
    "vessel.edit.sendToVessel": "Send to vessel",
    "vessel.edit.sendToOthers": "Send to others",
    "vessel.edit.attachments": "Attachments",
    "vessel.edit.lubricationChart": "Lubrication chart",
    "vessel.edit.lubricationChartNote": "Uploading a lubrication chart will process the file and update the vessel products.",
    "vessel.edit.uploadFile": "Upload file",
    "vessel.edit.validEmailAddress": "Please enter a valid email address",
    "vessel.insertROB": "Insert ROB",
    "vessel.create": "Create vessel",
    "vessel.exportAll.button": "Download all vessels as XLSX",
    "vessel.exportAll.downloading": "Downloading vessels",
    "vessel.exportAll.downloadError": "Failed to download vessels",
    "vessel.exportAll.downloadSuccess": "Vessels downloaded",
    "vessel.migration.button": "Migrate vessel data",
    "vessel.migration.headline": "Migrate vessel data",
    "vessel.migration.description": "Copies the selected data from the source vessel to the target vessel. The source vessel stays unchanged.",
    "vessel.migration.sourceVessel": "Source vessel",
    "vessel.migration.sourceVesselCaption": "Only inactive vessels can be migrated",
    "vessel.migration.targetVessel": "Target vessel",
    "vessel.migration.targetVesselCaption": "Create the target vessel first. Only active vessels with the same IMO and customer group as the source vessel are shown",
    "vessel.migration.dataTypesLabel": "Data to copy",
    "vessel.migration.dataTypes.tanks": "Tanks",
    "vessel.migration.dataTypes.stocks": "Stocks",
    "vessel.migration.dataTypes.consumptionPresets": "Consumption presets",
    "vessel.migration.schedulesHint": "Schedules are linked by IMO and customer group, so the target vessel already shares them with the source vessel",
    "vessel.migration.submit": "Migrate",
    "vessel.migration.success": "Vessel data migrated (tanks: {{tanks}}, stocks: {{stocks}}, consumption presets: {{presets}})",
    "vessel.migration.error": "Failed to migrate vessel data",
    "vessel.migration.sourceCustomerError": "Failed to load the company of the source vessel",
    "vessel.new": "New vessel",
    "vessel.searchplaceholder": "Search",
    "vessel.updatetitle": "Update vessel",
    "vessel.createtitle": "Create vessel",
    "vessel.createsubtitle": "Please fill the mandatory fields. Upon saving the Closelink team will be informed and activate the vessel.",
    "vessel.subtitle": "Vessel",
    "vessel.listsubtitle": "Vessels",
    "vessel.overview": "Overview",
    "vessel.filters.search": "Search",
    "vessel.filters.filterBySearch": "Filter by name or IMO",
    "vessel.filters.filterByDefaultSupplier": "Filter by default supplier",
    "vessel.overviewpagetitle": "Vessels",
    "vessel.maxvolume": "Max volume",
    "vessel.minvolume": "Threshold",
    "vessel.oildefaults": "Oil defaults",
    "vessel.oiltypeminvoumes": "Min volumes",
    "vessel.oiltypemaxvoumes": "Max volumes",
    "vessel.oiltypedefaultproducts": "Default products",
    "vessel.defaultsupplier": "Default supplier",
    "vessel.defaultContract": "Default contract",
    "vessel.default": "Default",
    "vessel.contracts.title": "Contracts",
    "vessel.contracts.emptyState.title": "No contracts available",
    "vessel.contracts.emptyState.description": "There are no active or awarded contracts available for this vessel. Review all contracts to create or update vessel access.",
    "vessel.contracts.emptyState.action": "View contracts",
    "vessel.contracts.actions.viewContractDetails": "View contract details",
    "vessel.contracts.actions.setDefaultContract": "Set as default contract",
    "vessel.contracts.actions.clearDefaultContract": "Clear default contract",
    "vessel.contracts.actions.excludeVesselFromContract": "Exclude vessel from contract",
    "vessel.contracts.actions.excludeVessel": "Exclude vessel",
    "vessel.contracts.defaultContract.updateSuccess": "Default contract updated",
    "vessel.contracts.defaultContract.updateError": "Could not update default contract",
    "vessel.contracts.excludeSuccess": "Vessel excluded from contract",
    "vessel.contracts.excludeError": "Could not exclude vessel from contract",
    "vessel.contracts.setDefaultModal.title": "Set default contract",
    "vessel.contracts.setDefaultModal.description": "Setting [{{contractName}}] as the default contract.",
    "vessel.contracts.setDefaultModal.descriptionWithSupplier": "Setting [{{contractName}}] as the default contract will also update the default supplier.",
    "vessel.contracts.setDefaultModal.currentDefaultSupplier": "Current default supplier",
    "vessel.contracts.setDefaultModal.newDefaultSupplier": "New default supplier",
    "vessel.contracts.excludeModal.title": "Exclude vessel from contract",
    "vessel.contracts.excludeModal.description": "Excludes the vessel from [{{contractName}}]. It will no longer be available when creating enquiries for this vessel.",
    "vessel.detailsLoadingError": "Oops. Something went wrong.",
    "vessel.insertRemainingOnBoardPopup.headline": "Update ROB data",
    "vessel.insertRemainingOnBoardPopup.description": "Please enter the date of measurement. Following you can enter the ROB values that need to be updated.",
    "vessel.insertRemainingOnBoardPopup.dateMeasured": "Date of measurement",
    "vessel.insertRemainingOnBoardPopup.oilTypePlaceholder": "e.g. 30000",
    "vessel.insertRemainingOnBoardPopup.updateButton": "Update stocks",
    "vessel.insertRemainingOnBoardPopup.maxVolume": "max {{maxVolume}}L",
    "vessel.insertRemainingOnBoardPopup.stockAnnotation": "max. {{maxVolume}}",
    "vessel.insertRemainingOnBoardPopup.dateMeasuredInFuture": "The selected date of measurement is in the future",
    "vessel.requisitionForm.label": "Generate requisition form",
    "vessel.requisitionForm.downloadButton": "Download file",
    "vessel.requisitionForm.downloading": "Downloading XLSX",
    "vessel.requisitionForm.downloadError": "Failed to download XLSX",
    "vessel.requisitionForm.downloadSuccess": "XLSX downloaded",
    "vessel.requisitionForm.sendToVesselButton": "Send to vessel",
    "vessel.newEnquiry": "Create enquiry",
    "vessel.newEnquiryDisabledHint": "Please contact us to activate the vessel",
    "vessel.vesselRequisitionSentToast": "Email sent to your vessel",
    "vessel.vesselUpdateSuccessToast": "Vessel updated",
    "vessel.vesselUpdateErrorToast": "Vessel was not updated",
    "vessel.documentTitle": "Vessel {{name}}",
    "vessel.remainingOnBoard.successToast": "ROBs saved",
    "vessel.remainingOnBoard.errorToast": "Failed to save ROBs",
    "vessel.remainingOnBoard.headline": "Remaining on board",
    "vessel.remainingOnBoard.insertButton": "Update ROBs",
    "vessel.remainingOnBoard.inLiter": "in liter",
    "vessel.remainingOnBoard.placeholderTitle": "No remaining on board defined",
    "vessel.remainingOnBoard.placeholder": "Remaining on board provides a great way to improve your planning.\nGet notified about upcoming demand, all automated! Contact us to learn more.",
    "vessel.remainingOnBoard.editTanks": "Edit tanks",
    "vessel.remainingOnBoard.createTanks": "Create tanks",
    "vessel.remainingOnBoard.contactUs": "Contact us",
    "vessel.remainingOnBoard.safetyReserve": "Safety reserve: {{safetyReserve}} L",
    "vessel.remainingOnBoard.warningLimit": "Warning limit: {{warningLimit}} L",
    "vessel.editTanksPopup.headline": "Edit tanks",
    "vessel.editTanksPopup.description": "Here you can add, delete and edit the tanks of this vessel.",
    "vessel.editTanksPopup.table.headers.name": "Name",
    "vessel.editTanksPopup.table.headers.category": "Category",
    "vessel.editTanksPopup.table.headers.warningLimit": "Warning limit",
    "vessel.editTanksPopup.table.headers.maxVolume": "Max volume",
    "vessel.editTanksPopup.table.headers.safetyReserve": "Safety reserve",
    "vessel.editTanksPopup.table.headers.defaultProduct": "Default product",
    "vessel.editTanksPopup.table.removeTank": "Remove",
    "vessel.editTanksPopup.table.addTank": "Add tank",
    "vessel.editTanksPopup.successToast": "Vessel tanks updated",
    "vessel.editTanksPopup.errorToast": "Failed to update vessel tanks",
    "vessel.editTanksPopup.confirmExit": "Discard changes and leave the edit tanks window?",
    "vessel.typesInput.label": "Types",
    "vessel.servicesInput.label": "Services",
    "vessel.lubricationChart": "Lubrication chart",
    "vessel.postalAddress": "Postal address",
    "vessel.invoiceEmailAddress": "Invoice email address",
    "vessel.invoiceVAT": "Invoice VAT",
    "vessel.chooseFile": "Choose file",
    "vessel.averageConsumption.title": "Average consumption",
    "vessel.averageConsumption.infoText": "The calculated daily average consumption based on historical ROB reports and associated timetables (last 90 days).",
    "vessel.averageConsumption.noConsumptionPlaceholder": "No data to show in selected time period.",
    "vessel.averageConsumption.noPresets.title": "No consumption graphs yet",
    "vessel.averageConsumption.noPresets.description": "Consumption graphs will be displayed here after defining presets.",
    "vessel.averageConsumption.today": "Today",
    "vessel.averageConsumption.differenceTooltip": "Difference to fixed daily average consumption",
    "vessel.averageConsumption.notEnoughData": "Not enough data to show in selected time period.",
    "vessel.averageConsumption.qualityIndicator.GOOD.headline": "Good data quality",
    "vessel.averageConsumption.qualityIndicator.GOOD.description": "The underlying data is of high quality. The average consumption data and predictions should be accurate in respect to the data that is currently available.",
    "vessel.averageConsumption.qualityIndicator.FAIR.headline": "Fair data quality",
    "vessel.averageConsumption.qualityIndicator.FAIR.description": "The underlying data is of fair quality, although it may occasionally be inaccurate. Average consumption data and predictions are expected to be fairly accurate, but they still need to be viewed with some caution.",
    "vessel.averageConsumption.qualityIndicator.POOR.headline": "Poor data quality",
    "vessel.averageConsumption.qualityIndicator.POOR.description": "The data available for this category is limited, and the accuracy of the data may vary considerably. Consequently, it is not possible to guarantee that the average consumption data and predictions are always accurate.",
    "vessel.products.headline": "Products",
    "vessel.products.emptyState": "No products yet",
    "vessel.products.emptyState.description": "Upload or drag & drop your lubrication chart to build the product catalog automatically, or add products manually.",
    "vessel.products.addProducts": "Add product",
    "vessel.products.productName": "Product",
    "vessel.products.supplierName": "Supplier",
    "vessel.products.productGroup": "Group",
    "vessel.products.dateCreated": "Created",
    "vessel.products.dateUpdated": "Updated",
    "vessel.products.note": "Note",
    "vessel.products.archived": "Outdated",
    "vessel.products.archivedTooltip": "This product is outdated. Consider removing it.",
    "vessel.products.inTank": "In tank",
    "vessel.products.custom": "Custom",
    "vessel.products.manualEditsCallout": "Based on lubrication chart with manual edits.",
    "vessel.products.export": "Export as Excel",
    "vessel.products.downloading": "Downloading vessel products",
    "vessel.products.downloadSuccess": "Vessel products downloaded",
    "vessel.products.downloadError": "Failed to download vessel products",
    "vessel.products.uploadButton": "Upload lubrication chart",
    "vessel.products.replaceWarning": "Uploading replaces the entire product list.",
    "vessel.products.toasts.uploading": "Uploading and processing lubrication chart",
    "vessel.products.toasts.uploadSuccess": "Successfully built product list with {{count}} products",
    "vessel.products.toasts.uploadError": "Failed to upload and process lubrication chart",
    "vessel.products.toasts.noProductsFound": "No products could be extracted from the uploaded file. Please try a different file.",
    "vessel.products.toasts.dropzone.invalidFileFormat": "Invalid file format. Please upload a PDF or image file.",
    "vessel.products.toasts.dropzone.invalidFileSize": "File is too large. Maximum file size is 5MB.",
    "vessel.products.toasts.dropzone.multipleFilesNotAllowed": "Only one file can be uploaded at a time.",
    "vessel.products.toasts.dropzone.unknownError": "Failed to upload file. Please try again.",
    "vessel.products.filters.supplierGroup": "Supplier",
    "vessel.products.filters.filterBySupplierGroup": "Filter by supplier",
    "vessel.products.filters.productGroup": "Group",
    "vessel.products.filters.filterByProductGroup": "Filter by group",
    "vessel.products.filters.product": "Product",
    "vessel.products.filters.filterByProduct": "Filter by product",
    "vessel.products.filters.searchForProduct": "Search for product",
    "vessel.products.filters.tank": "In tank",
    "vessel.products.filters.filterByTankPresence": "Filter by tank presence",
    "vessel.products.filters.note": "Note",
    "vessel.products.filters.filterByNote": "Filter by note",
    "vessel.products.inCatalog": "Part of vessel product catalog",
    "vessel.products.actions.edit": "Edit",
    "vessel.products.actions.remove": "Remove",
    "vessel.products.actions.removeAll": "Remove all products",
    "vessel.products.modal.product": "Product",
    "vessel.products.modal.note": "Note",
    "vessel.products.editModal.title": "Edit product",
    "vessel.products.addModal.title": "Add product",
    "vessel.products.deleteConfirm.headline": "Remove product?",
    "vessel.products.deleteConfirm.text": "This will remove the selected product from the vessel's product table. They won't be available where restrictions apply. This action cannot be undone.",
    "vessel.products.deleteAllConfirm.headline": "Remove all products?",
    "vessel.products.deleteAllConfirm.text": "This will permanently remove all products from the vessel’s product table. They won’t be available where restrictions apply. This action cannot be undone.",
    "vessel.products.deleteAllConfirm.button": "Remove all",
    "vessel.products.toasts.deleteSuccess": "Product deleted",
    "vessel.products.toasts.deleteError": "Failed to delete product",
    "vessel.products.toasts.deleteAllSuccess": "All products deleted",
    "vessel.products.toasts.deleteAllError": "Failed to delete all products",
    "vessel.products.toasts.addSuccess": "Product added",
    "vessel.products.toasts.addError": "Failed to add product",
    "vessel.products.replaceModal.headline": "Replace lubrication chart?",
    "vessel.products.replaceModal.description": "Uploading a new chart will remove all products previously imported from the last chart and rebuild the list automatically. Custom products you added manually won't be affected. This action cannot be undone.",
    "vessel.products.replaceModal.replace": "Replace chart",
    "vessel.products.unmatchedCallout.headingOne": "1 entry needs review",
    "vessel.products.unmatchedCallout.headingOther": "{{count}} entries need review",
    "vessel.products.unmatchedCallout.description": "These entries couldn't be matched with certainty. Add any relevant products, or mark them as reviewed to continue.",
    "vessel.products.unmatchedCallout.review": "Review entries",
    "vessel.products.unmatchedModal.title": "Review unmatched entries",
    "vessel.products.unmatchedModal.description": "We couldn't confidently match these entries to products in your catalog. Review each entry and select a product to add to the table, or leave it empty to skip it.",
    "vessel.products.unmatchedModal.unmatchedItem": "Unmatched entry",
    "vessel.products.unmatchedModal.product": "Product",
    "vessel.products.unmatchedModal.selectProduct": "Select a product...",
    "vessel.products.unmatchedModal.markAllReviewed": "Mark all as reviewed",
    "vessel.products.unmatchedModal.submit": "Add selected products",
    "vessel.products.unmatchedModal.toasts.success": "Selected products added",
    "vessel.products.unmatchedModal.toasts.allReviewed": "All entries marked as reviewed",
    "vessel.products.unmatchedModal.toasts.error": "Failed to review unmatched products",
    "vessel.products.emptyState.disclaimer": "Some products may not be detected automatically and can be added manually.",
    "supplier.name": "Company",
    "supplier.updatetitle": "Update company",
    "supplier.createtitle": "Create company",
    "supplier.createCompany": "Create company",
    "supplier.contact": "Contact",
    "supplier.datecreated": "Created",
    "supplier.mail": "Email address",
    "supplier.testcompany": "Test",
    "supplier.edit": "Edit company",
    "supplier.subtitle": "Company",
    "supplier.noCompanyNameError": "Please enter a company name",
    "supplier.noEmailAddressError": "Please enter a valid email address",
    "supplier.noCompanyTypeError": "Please select a company type",
    "supplier.createErrorToast": "Failed to create company",
    "supplier.showGtcDescription": "The terms and conditions are displayed when ordering from a contracted supplier.",
    "supplier.messageSettings.editMessageSettings": "Edit message settings",
    "supplier.messageSettings.updateMessageSettings": "Update message settings",
    "supplier.messageSettings.headline": "Messages",
    "supplier.messageSettings.explanation": "Closelink automatically informs the customer once an order was quoted or confirmed. Additionally you can add a custom message which is sent to the customer for specific order updates.",
    "supplier.messageSettings.quotationMessageLabel": "Additional offer message",
    "supplier.messageSettings.messagePlaceholder": "Type in message…",
    "supplier.messageSettings.orderConfirmationMessageLabel": "Additional confirmation message",
    "suppliers.subheadline": "Companies",
    "suppliers.headline": "Overview",
    "suppliers.create": "Create company",
    "suppliers.emptylist": "No companies yet.",
    "suppliers.detailsSectionHeadline": "Details",
    "suppliergroup.name": "Group",
    "suppliergroup.companies": "Companies",
    "suppliergroup.type": "Type",
    "suppliergroup.createtitle": "Create supplier group",
    "suppliergroup.createGroup": "Create group",
    "suppliergroup.editTitle": "Edit group",
    "suppliergroup.updateGroup": "Update group",
    "suppliergroup.testcompany": "Test",
    "suppliergroup.subtitle": "Group",
    "suppliergroup.btnUploadLogo": "Replace logo image",
    "suppliergroup.btnDownloadLogo": "Download logo image",
    "suppliergroup.btnRemoveLogo": "Remove logo image",
    "suppliergroup.uploadImagePlaceholder": "Upload logo image",
    "suppliergroup.logoUploadDescription": "Appears in offers. JPEG or PNG under 2MB.",
    "suppliergroup.logoAlt": "Company logo",
    "suppliergroup.logo": "Logo",
    "suppliergroup.createSupplierGroupSuccessToast": "Supplier group created",
    "suppliergroup.createSupplierGroupErrorToast": "Failed to create supplier group",
    "suppliergroup.toasts.logoUploadLoading": "Uploading logo",
    "suppliergroup.toasts.logoUploadSuccess": "Logo uploaded",
    "suppliergroup.toasts.logoUploadError": "Failed to upload logo",
    "suppliergroup.toasts.deleteLogoLoading": "Removing logo",
    "suppliergroup.toasts.deleteLogoSuccess": "Logo removed",
    "suppliergroup.toasts.deleteLogoError": "Failed to remove logo",
    "suppliergroup.toasts.updateSupplierGroupSuccess": "Group updated",
    "suppliergroup.toasts.updateSupplierGroupError": "Failed to update group",
    "customergroup.name": "Group",
    "customergroup.companies": "Companies",
    "customergroup.createtitle": "Create group",
    "customergroup.createGroup": "Create group",
    "customergroup.editTitle": "Edit group",
    "customergroup.updateGroup": "Update group",
    "customergroup.testcompany": "Test",
    "customergroup.subtitle": "Group",
    "customergroup.createCustomerGroupSuccessToast": "Customer group created",
    "customergroup.createCustomerGroupErrorToast": "Failed to create customer group",
    "customergroup.customerHealthButton": "View customer health report",
    "customergroups.headline": "Customers",
    "customergroups.create": "Create group",
    "customergroups.groupName": "Name",
    "customergroups.searchForCustomerGroup": "Search for customer group",
    "suppliergroups.headline": "Suppliers",
    "suppliergroups.create": "Create group",
    "suppliergroups.filters.filterByName": "Filter by group name",
    "suppliergroups.filters.filterBySpotAllowed": "Filter by spot allowed",
    "suppliergroups.filters.filterByTest": "Filter by test",
    "suppliergroups.filters.filterByType": "Filter by type",
    "suppliergroups.filters.name": "Group",
    "suppliergroups.filters.spotAllowed": "Spot allowed",
    "suppliergroups.filters.test": "Test",
    "suppliergroups.filters.type": "Type",
    "suppliergroups.groupName": "Name",
    "suppliergroups.searchForSupplierGroup": "Search for supplier group",
    "termsAndConditions.groupAdmin.headline": "Terms & conditions",
    "termsAndConditions.groupAdmin.description": "Please take a moment to review and acknowledge our <a href='https://www.closelink.com/terms-and-conditions' target='_blank'>terms & conditions</a>. By proceeding, you indicate your understanding and acceptance of these terms as part of our agreement.",
    "termsAndConditions.groupAdmin.acceptHeadline": "I have read and accept the terms & conditions.",
    "termsAndConditions.groupAdmin.acceptDescription": "Please ensure you have thoroughly reviewed our terms & conditions before proceeding.",
    "termsAndConditions.groupAdmin.newsletterHeadline": "I want Closelink to send me the latest news via email.",
    "termsAndConditions.groupAdmin.newsletterDescription": "Stay informed! Opt in to receive the latest news and updates from Closelink directly to your email.",
    "termsAndConditions.groupAdmin.legalCaption": "By clicking the button “Accept terms & conditions” below, you agree to the terms & conditions and, if selected, to receive the latest news via email.",
    "termsAndConditions.groupAdmin.acceptButton": "Accept terms & conditions",
    "termsAndConditions.groupAdmin.notAcceptedError": "Please accept the terms & conditions.",
    "termsAndConditions.user.headline": "Before you start using Closelink:",
    "termsAndConditions.user.description": "An owner must first accept our <a href='https://www.closelink.com/terms-and-conditions' target='_blank'>terms & conditions</a> on behalf of your organization. Please reach out to your administrator and request them to complete this step. Once the terms & conditions are accepted, you'll be ready to explore Closelink.",
    "termsAndConditions.user.legalCaption": "If you have any questions or need assistance, feel free to contact us at <a href='mailto:hello@closelink.com'>hello@closelink.com</a>.",
    "termsAndConditions.user.acceptButton": "Contact administrator",
    "termsAndConditions.mailTo.subject": "Accept Closelink terms & conditions",
    "termsAndConditions.mailTo.body": "Please accept the Closelink terms & conditions. https://closelink.com/app/",
    "termsAndConditions.logOutButton": "Log out",
    "customer.name": "Company",
    "customer.subtitle": "Company",
    "customer.updatetitle": "Update company",
    "customer.createtitle": "Create company",
    "customer.createCompany": "Create company",
    "customer.datecreated": "Created",
    "customer.mail": "Email",
    "customer.testcompany": "Test",
    "customer.edit": "Edit company",
    "customer.assignments.subheadline": "Assignments",
    "customer.assignments.create": "Create assignment",
    "customer.users": "Members",
    "customer.customer": "Customer",
    "customer.createCustomerCompanyErrorToast": "Failed to create company",
    "customer.noTypeSelectedError": "Please select a company type",
    "customer.noCompanyNameError": "Please enter a company name",
    "customer.noEmailError": "Please enter a valid email address",
    "messages.longmessage": "Message too long.",
    "customers.subheadline": "Companies",
    "customers.headline": "Overview",
    "customers.create": "Create company",
    "customers.emptylist": "No companies yet.",
    "customers.details.editAdminSettings": "Edit admin settings",
    "customers.details.settings": "Settings",
    "customers.details.automaticallyMarkAsDelivered": "Order delivery",
    "customers.details.automaticallyMarkAsDeliveredDescription": "Orders are automatically marked as delivered 3 days after their delivery date.",
    "customers.detailsSectionHeadline": "Details",
    "customers.twoStepAuthHeadline": "Two-step authentication",
    "customers.twoStepAuthSwitchLabel": "Require two-step authentication for your group",
    "customers.twoStepAuthSwitchCalloutTitle": "What this setting does:",
    "customers.twoStepAuthSwitchCalloutLine1": "This will require any group member without two-step authentication to enable it the next time they sign in.",
    "customers.twoStepAuthSwitchCalloutLine2": "They won't be able to access Closelink until setup is complete.",
    "customers.supplierPermissionsHeadline": "Supplier permissions",
    "customers.scheduleSharingSwitchLabel": "Allow suppliers to access vessel schedules",
    "customers.scheduleSharingDescription": "Suppliers with advanced quoting capabilities can view the vessel's port calls when responding to an enquiry.",
    "customers.excludeCompaniesSwitchLabel": "Exclude companies from schedule sharing",
    "customers.excludeCompaniesHeadline": "Select companies to exclude",
    "sso.emptyState.headline": "Enable SSO for your account",
    "sso.emptyState.description": "Enter the customer's Connection ID to create a new connection.",
    "sso.addConnectionId": "Add connection ID",
    "sso.addConnectionIdModal.title": "Add connection ID",
    "sso.addConnectionIdModal.description": "Enter the customer's connection ID to enable SSO. Once saved, you can map external groups to roles and companies in Closelink.",
    "sso.connectionIdLabel": "Connection ID",
    "sso.connectionIdPlaceholder": "conn_xxx...",
    "sso.enableSsoButton": "Enable SSO",
    "sso.enableSuccess": "SSO enabled for {{groupName}}.",
    "sso.enableError": "Couldn't enable SSO. Try again.",
    "sso.connectionIdRequired": "Connection ID is required",
    "sso.groupsHeadline": "SSO groups",
    "sso.groupsSubheadlinePrefix": "Manage how external groups from your identity provider map to roles and companies in Closelink for your connection:",
    "sso.createGroup": "Create group",
    "sso.disableSso": "Disable SSO",
    "sso.table.groupName": "Group name",
    "sso.table.role": "Role",
    "sso.table.companies": "Companies",
    "sso.table.actions": "",
    "sso.emptyTable": "Control access by mapping external groups to roles and companies.",
    "sso.createGroupModal.title": "Create SSO group",
    "sso.createGroupModal.description": "Map an external group from your identity provider to roles and companies in Closelink.",
    "sso.groupNameLabel": "Group name",
    "sso.groupNameHelperText": "Used to identify this group in Closelink.",
    "sso.roleLabel": "Role",
    "sso.companiesLabel": "Companies",
    "sso.companiesPlaceholder": "Select companies...",
    "sso.createMoreLabel": "Create more",
    "sso.createGroupButton": "Create group",
    "sso.createGroupSuccess": "{{groupName}} group was created.",
    "sso.createGroupError": "Couldn't create group. Try again.",
    "sso.groupNameRequired": "Group name is required",
    "sso.groupNameInvalidCharacters": "Group name can only contain letters, numbers, spaces, underscores, and dashes",
    "sso.groupNameDuplicate": "A group with this name already exists",
    "sso.roleRequired": "Role is required",
    "sso.editGroupModal.title": "Edit SSO group",
    "sso.saveGroupButton": "Save",
    "sso.updateGroupSuccess": "{{groupName}} group was updated.",
    "sso.updateGroupError": "Couldn't update the group. Try again.",
    "sso.deleteGroupModal.title": "Delete SSO group",
    "sso.deleteGroupModal.description": "This will remove the group and its assigned role and companies. Members of companies not mapped to any SSO group will fall back to default sign-in.",
    "sso.deleteGroupButton": "Delete group",
    "sso.deleteGroupSuccess": "{{groupName}} group was deleted.",
    "sso.deleteGroupError": "Couldn't delete the group. Try again.",
    "sso.disableSsoModal.title": "Disable SSO",
    "sso.disableSsoModal.description": "Disabling SSO will revoke the connection ID. Users will no longer be able to sign in with your identity provider. Any groups you've set up will be kept but hidden until you re-enable SSO.",
    "sso.disableSsoModal.connectionIdLabel": "Connection ID",
    "sso.disableSsoButton": "Disable SSO",
    "sso.disableSuccess": "SSO disabled for {{groupName}}.",
    "sso.disableError": "Couldn't disable SSO. Try again.",
    "sso.advertisement.headline": "Enable SSO for your account",
    "sso.advertisement.description": "SSO lets your users sign in with your company's identity provider. Setup requires manual activation by our team. Contact support to get started.",
    "sso.contactSupport": "Contact support",
    "customers.requisitionForm.downloadButton": "Generate requisition forms",
    "customers.requisitionForm.downloading": "Downloading requisition forms",
    "customers.requisitionForm.downloadError": "Failed to download requisition forms",
    "customers.requisitionForm.downloadSuccess": "Requisition forms downloaded",
    "customers.vesselProducts.downloadButton": "Download vessel products",
    "customers.vesselProducts.downloading": "Downloading vessel products",
    "customers.vesselProducts.downloadError": "Failed to download vessel products",
    "customers.vesselProducts.downloadSuccess": "Vessel products downloaded",
    "company.showGtc": "Show terms and conditions",
    "company.portavailability": "Spot port availability",
    "company.lubesSpotPortAvailability": "Lubricants",
    "company.testCompany": "Test company",
    "company.trial": "Trial",
    "company.name": "Company name",
    "company.internalName": "Internal name",
    "company.internalName.tooltip": "Visible only within your group. External parties will still see: {{companyName}}",
    "company.internalName.caption": "Visible only within your group. External parties always see the legal company name.",
    "company.internalName.tooltip.superAdmin": "Visible only within the group. External parties will still see: {{companyName}}",
    "company.internalName.caption.superAdmin": "Visible only within the group. External parties always see the legal company name.",
    "company.premiumfeaturesallowed": "Premium features",
    "company.title": "Company",
    "company.detailsHeadline": "Details",
    "company.edit": "Edit company",
    "company.email": "Email address",
    "company.fax": "Fax",
    "company.invoiceVAT": "VAT number",
    "company.phone": "Phone",
    "company.address": "Company address",
    "company.resetpassword": "Set new password",
    "company.settings": "Settings",
    "company.spotallowed": "Spot",
    "company.emailQuoteOnly": "Email quote only",
    "company.information": "Additional information",
    "company.companyInformation": "Company information",
    "company.headquarter": "Headquarters",
    "company.description": "Description",
    "company.spotsupplierid": "Spot enquiry supplier",
    "company.gtcAccepted": "Closelink T&Cs",
    "company.gtc": "Terms & conditions",
    "company.gtcStatusAccepted": "Accepted",
    "company.gtcNotAccepted": "Not accepted",
    "company.gtcView": "View",
    "company.placeholder.headquarter": "e.g. Hamburg, Germany",
    "company.placeholder.description": "Description …",
    "company.placeholder.gtcUrl": "e.g. https://www.closelink.com/terms-and-conditions",
    "company.placeholder.invoiceVAT": "e.g. DE21344333",
    "company.productsettings": "Product settings",
    "company.lubes": "Lubes",
    "company.spotsettings": "Spot settings",
    "company.spotSupplierExclusions": "Spot supplier exclusions",
    "company.translateproductgroup": "Translate product group",
    "company.supplierproductgroups": "Product limitations",
    "company.notificationSettings.emailNotificationSettingsHint": "Some vessels email settings may override these settings.",
    "company.notificationSettings.emailNotificationSettings": "Email notification settings",
    "company.notificationSettings.emailNotification": "Email notifications",
    "company.notificationSettings.statusUpdate": "Status update (enquiry, offer, order)",
    "company.notificationSettings.statusUpdateDescription": "e.g new offer, offer changes to order, order changes to order confirmed, etc.",
    "company.notificationSettings.newDetails": "New details (enquiry, offer, order)",
    "company.notificationSettings.newDetailsDescription": "e.g product added/changed/deleted.",
    "company.notificationSettings.newChatMessages": "New chat messages (offer, order)",
    "company.notificationSettings.systemReminders": "System reminders",
    "company.notificationSettings.stockWarningLevelReminder": "Stock warning level",
    "company.notificationSettings.stockWarningLevelReminderDescription": "An alert is sent when the warning level of a tank is reached.",
    "company.notificationSettings.safetyReserveLevel": "Safety reserve level",
    "company.notificationSettings.safetyReserveLevelDescription": "An alert is sent when the safety reserve level of a tank is reached.",
    "company.notificationSettings.keyPortCallReminder": "Key port call",
    "company.notificationSettings.keyPortCallReminderDescription": "An alert is sent if a vessel calls a key port within the next 6 weeks.",
    "company.notificationSettings.orderDeliveryReminder": "Order delivery",
    "company.notificationSettings.orderDeliveryReminderDescription": "A reminder will be sent 3 days before the delivery date is reached.",
    "company.notificationSettings.openEnquiryReminder": "Open enquiry",
    "company.notificationSettings.openEnquiryReminderDescription": "A reminder will be sent 3 days before the estimated delivery date is reached.",
    "company.generalInformation.title": "General information",
    "company.generalInformation.editCompany": "Edit company",
    "company.generalInformation.update": "Update company",
    "company.editSettings": "Edit",
    "company.editMessages": "Edit messages",
    "company.adminSettings": "Super admin settings",
    "company.toasts.informationUpdateSuccess": "Information updated",
    "company.toasts.informationUpdateError": "Information update failed",
    "company.error.name": "Enter company name",
    "company.error.supplierType": "Select type",
    "company.error.translationSupplierProductGroup": "Select translate product Group",
    "users.subheadline": "Members",
    "users.headline": "Overview",
    "users.emptylist": "No members yet.",
    "users.invite": "Invite member",
    "user.headline": "Members",
    "user.searchPlaceholder": "Search members",
    "user.emptyList": "No members found",
    "user.userDetails": "Member details",
    "user.inviteTitle": "Invite member",
    "user.invitationToasts.success": "Invite sent",
    "user.invitationToasts.error": "Failed to send invite email",
    "user.resendInvitation": "Resend invitation",
    "user.resendInvitationToasts.success": "Invite email sent again",
    "user.resendInvitationToasts.error": "Failed to send invite email again",
    "user.editUserToasts.success": "Member updated",
    "user.editUserToasts.error": "Failed to update member",
    "user.activateUserToasts.success": "Member activated successfully",
    "user.activateUserToasts.error": "Failed to activate member",
    "user.userroleexplanation.GROUP_ADMIN": "An owner can view/edit group and group associated company information.",
    "user.userroleexplanation.COMPANY_ADMIN": "An administrator can view/edit all information within the assigned companies.",
    "user.userroleexplanation.COMPANY_EMPLOYEE.CUSTOMER": "A member can create orders and view information of assigned companies.",
    "user.userroleexplanation.COMPANY_EMPLOYEE.SUPPLIER": "A member can create quotes and view information of assigned companies.",
    "user.userroleexplanation.COMPANY_INSPECTOR": "A viewer can only view information of assigned companies.",
    "user.error.fields": "Please check for field errors.",
    "user.error.userType": "Please select a member type.",
    "user.error.groupId": "Please select a group.",
    "user.error.userRole": "Please select a role.",
    "user.error.companyIds": "Please select a least one company.",
    "user.error.requiredEmail": "Enter email address",
    "user.error.requiredFirstName": "Enter first name",
    "user.error.requiredLastName": "Enter last name",
    "user.error.requiredUserType": "Enter a member type.",
    "user.error.requiredGroupId": "Enter a group.",
    "user.error.requiredUserRole": "Enter a role.",
    "user.error.requiredCompanyIds": "Enter at least one company.",
    "user.error.emailNotUnique": "The email is already in use, choose a different one",
    "user.error.emailInvalid": "Please enter a valid email address",
    "user.accesstitle": "Access settings",
    "user.coredatatitle": "Profile settings",
    "user.group": "Group",
    "user.companies": "Companies",
    "user.companyColumn": "Company",
    "user.passwordlabel": "Password",
    "user.passwordrepeatlabel": "Repeat password",
    "user.firstname": "First name",
    "user.lastname": "Last name",
    "user.status": "Status",
    "user.statusHeader": "Active",
    "user.dateCreated": "Date created",
    "user.dateUpdated": "Last updated",
    "user.dateLastLogin": "Last login",
    "user.loginTimes": "Login times",
    "user.loginStats.info": "Last login and login times are tracked since October 02, 2025.",
    "user.userType": "Type",
    "user.activity.title": "Activity",
    "user.invitetitle": "Invite member",
    "user.sendInvite": "Send invite",
    "user.invitesubtitle": "The invitation will be sent via email. The employee has to accept the invitation and complete the account.",
    "user.resetpassword": "Set new password",
    "user.subtitle": "Profile",
    "user.company": "Company",
    "user.name": "Name",
    "user.phone": "Phone number",
    "user.phoneInput": "Phone number",
    "user.mail": "Email",
    "user.news": "News",
    "user.orderUpdates": "Order updates",
    "user.role": "Role",
    "user.editMember": "Edit member",
    "user.updateMember": "Update member",
    "user.emailPreferences": "Email preferences",
    "user.datecreated": "Date created",
    "user.password.reset": "Set new password",
    "user.password.old": "Old password",
    "user.password.new1": "New password",
    "user.password.new2": "Repeat new password",
    "user.password.mismatch": "Passwords don't match.",
    "user.password.passwordNotStrongEnough": "This password is too easy to guess. Change your password to something stronger.",
    "user.action": "Action",
    "user.you": "You",
    "user.activateMemberButton": "Activate member",
    "user.setInactiveButton": "Deactivate",
    "user.setActiveButton": "Activate",
    "user.deactivateMemberButton": "Deactivate member",
    "user.deactivateMemberConfirm": "Are you sure you want to deactivate this member? This will prevent them from accessing Closelink. You can reactivate them at any time.",
    "user.deactivateMemberHeadline": "Deactivate member",
    "user.nameNotProvided": "Name not provided",
    "user.ssoManaged": "SSO managed",
    "user.ssoManagedTooltip": "Managed by SSO",
    "mfa.authenticator.title": "Two-step authentication",
    "mfa.authenticator.description": "Set up an authenticator app to add an extra layer of security to your account.",
    "mfa.authenticator.emptyAdminState": "This member does not have any two-step authentication method.",
    "mfa.authenticator.emptyState": "Secure your account by enabling two-step authentication with an authenticator app.",
    "mfa.authenticator.supportedApps": "Currently, only authenticator apps are supported",
    "mfa.authenticator.add": "Add authentication method",
    "mfa.authenticator.backupCodePrompt": "If your backup code is lost or compromised, [generate a new one] to sign in to your account.",
    "mfa.authenticator.tableHeader.method": "Method",
    "mfa.authenticator.tableHeader.dateAdded": "Date added",
    "mfa.authenticator.tableHeader.lastUsed": "Last used",
    "mfa.authenticator.methodName": "Authenticator app",
    "mfa.authenticator.lastUsedNever": "Never",
    "mfa.authenticator.action.remove": "Remove",
    "mfa.authenticator.action.menuLabel": "Authentication method actions",
    "mfa.backupCode.generateTitle": "Generate new backup code",
    "mfa.backupCode.generateDescription": "A backup code allows you to bypass two step authentication if you lose your device. If you've lost your backup code, you can generate a new one. The new backup code will invalidate any previous backup code.",
    "mfa.backupCode.btn.generate": "Generate code",
    "mfa.backupCode.displayTitle": "Generate new backup code",
    "mfa.backupCode.displayDescription": "Save your new emergency backup code and store it somewhere safe. If you lose access to your authenticator app, you can use this code to bypass two-step authentication.",
    "mfa.backupCode.btn.copy": "Copy to clipboard",
    "mfa.backupCode.btn.download": "Download",
    "mfa.backupCode.btn.saved": "I have saved my backup code",
    "mfa.delete.title": "Remove two-step authentication method",
    "mfa.delete.message": "Are you sure you want to remove the method:",
    "mfa.delete.method": "Authentication app?",
    "mfa.delete.btn.remove": "Remove",
    "mfa.error.enrollmentFailed": "Failed to generate enrollment ticket. Please try again.",
    "mfa.error.recoveryCodeFailed": "Failed to generate recovery code. Please try again.",
    "mfa.error.deleteFailed": "Failed to remove authentication method. Please try again.",
    "mfa.ssoManagedTooltip": "Two-step authentication is managed by your SSO provider",
    "apikey.title": "API keys",
    "apikey.description": "API keys allow you to authenticate with Closelink’s public API. You can create keys with different permission levels depending on your needs. Keep your keys safe — never expose them in the browser or client-side code. For more information, feel free to [contact us].",
    "apikey.key": "Secret key",
    "apikey.name": "Key name",
    "apikey.lastUsed": "Last used",
    "apikey.neverUsed": "Never",
    "apikey.companies": "Assigned companies",
    "apikey.add": "Create secret key",
    "apikey.emptylist": "No API access keys yet.",
    "apikey.datecreated": "Created",
    "apikey.action": "Action",
    "apikey.edit": "Edit",
    "apikey.updatetitle": "Edit secret key",
    "apikey.createtitle": "Create secret key",
    "apiKey.saveTitle": "Save your key",
    "apiKey.saveDescription": "Please save this secret key somewhere safe and accessible. For security reasons, you won't be able to view it again through your Closelink account. If you lose this secret key, you'll need to generate a new one.",
    "apikey.companyaccesslevel": "Permission",
    "apikey.noCompanySelectedError": "Please select at least one company",
    "apikey.noAccessLevelSelectedError": "Please select an access level",
    "apikey.noNameError": "Please enter a name",
    "apiKey.createSecretKey": "Create secret key",
    "apiKey.creationError": "Failed to create secret key, please try again",
    "apiKey.updateError": "Failed to update secret key, please try again",
    "apiKey.assignedCompaniesPlaceholder": "Select companies...",
    "apikey.permission": "Permission",
    "apiKey.revokeTitle": "Revoke secret key",
    "apiKey.revokeDescription": "API requests made using this key will be rejected, which could cause any systems still depending on it to break. Once revoked, you'll no longer be able to view or modify this API key.",
    "apiKey.revokeKey": "Revoke key",
    "apiKey.revokeError": "Failed to revoke key, please try again",
    "apikey.enableColumnHeader": "Active",
    "apiKey.copied": "Copied to clipboard",
    "apiKey.copyFailed": "Failed to copy api key, please try again",
    "onboard.pageTitle": "Welcome on board",
    "onboard.completeAccount": "Complete your account",
    "onboard.enterInformationBelow": "Complete your registration with your invited email {{emailAddress}} by entering the required information below.",
    "onboard.completeRegistration": "Complete registration",
    "onboard.firstName": "First name",
    "onboard.lastName": "Last name",
    "onboard.enterPhoneNumber": "Enter your phone number",
    "onboard.enterPassword": "Enter a password",
    "onboard.allowMarketingCommunication": "I would like to receive emails about product updates. If you check this box, you will occasionally receive helpful and relevant emails from Closelink. However, you can unsubscribe at any time.",
    "onboard.privacyPolicy": "Privacy policy",
    "onboard.contactUs": "Contact us",
    "onboard.error.requiredFirstName": "Enter your first name",
    "onboard.error.requiredLastName": "Enter your last name",
    "onboard.error.requiredPassword": "Please enter a password",
    "onboard.error.passwordTooShort": "Your password requires at least 6 characters",
    "onboard.error.insecurePassword": "Please choose a more secure password",
    "onboard.error.emailNotUnique": "The email is already in use, choose a different one",
    "onboard.error.weCouldNotConnectToCloselink": "We could not connect to the Closelink system, please try again",
    "onboard.error.invitationLinkNoLongerValid": "The invitation link is no longer valid",
    "onboard.error.furtherSupportInformation": "If you need further support please reach out to our support.",
    "error.public.notFound.title": "Page not found",
    "error.public.notFound.description": "The page you are looking for does not exist or is no longer available. If you believe this is an error, please contact our support team for assistance.",
    "error.public.contactSupport": "Contact support",
    "welcomePopup.youHaveMadeIt": "You've made it!",
    "welcomePopup.welcomeOnBoard": "Welcome on board.",
    "welcomePopup.letsGetStarted": "Let's get started",
    "dashboard.headline": "Dashboard",
    "dashboard.recentactivities": "Recent activities",
    "dashboard.unconfirmeddeliveries": "Unconfirmed deliveries",
    "dashboard.requests": "Open requests",
    "dashboard.quickstats.headline": "Quick stats",
    "dashboard.quickstats.volume": "Volume",
    "dashboard.quickstats.deliveries": "Deliveries",
    "dashboard.quickstats.orders": "Orders",
    "dashboard.quickstats.ppl": "per Liter",
    "dashboard.quickstats.total": "Total",
    "dashboard.quickstats.customers": "Customers",
    "dashboard.emptyList": "No recent activities.",
    "dashboard.approvalRequests": "Pending approval requests",
    "dashboard.approvalRequestsCreatedBy": "Created by",
    "dashboard.approvalRequestsCreatedAt": "Created at",
    "dashboard.approvalRequestsTotal": "Total",
    "assignments.title": "Assignments",
    "assignments.lastUpload": "Last upload",
    "assignments.lastUploadAdmin": "Last upload (admin)",
    "assignments.viewPriceLists": "View price lists",
    "assignments.priceListPopup.title": "Price lists",
    "assignments.priceListPopup.uploaded": "uploaded at {{date}}",
    "assignments.customer": "Customer",
    "assignments.company": "Company",
    "assignments.editAssignment": "Edit assignment",
    "assignments.lastUploaded": "Last uploaded",
    "assignments.portLimitations": "Port limitations",
    "assignments.update": "Update assignment",
    "assignments.nouploads": "No uploads yet.",
    "assignments.downloadUploads": "Download uploads",
    "assignments.dlpricelistbtn": "Download price list template",
    "assignments.lastupload": "Last upload:",
    "assignments.emptylist": "No assignments yet.",
    "assignments.name": "Name",
    "assignments.mail": "Email address",
    "assignments.create": "Create assignment",
    "assignments.status": "Status",
    "assignments.action": "Action",
    "assignments.defaultPaymentTermDays": "Days",
    "assignments.confirmbutton": "Confirm",
    "assignments.upload": "Upload",
    "assignments.btnupload": "Upload price list",
    "assignments.btnuploading": "Uploading …",
    "assignments.uploadNewPriceList": "Upload new price list",
    "assignments.downloadRecentPriceList": "Download recent price list",
    "assignments.supplier": "Supplier",
    "assignments.admin.headline": "Overview",
    "assignments.admin.subheadline": "Assignments",
    "assignments.admin.invite": "Create assignment",
    "assignments.suppliers.headline": "Overview",
    "assignments.suppliers.subheadline": "Suppliers",
    "assignments.suppliers.supplier": "Supplier",
    "assignments.suppliers.company": "Company",
    "assignments.suppliers.maxinfo": "Max 3 suppliers allowed",
    "assignments.suppliers.emptylist": "No suppliers found",
    "assignments.suppliers.invitedSuccessfullyToast": "Supplier invited successfully",
    "assignments.suppliers.companyRequired": "Please select a company",
    "assignments.suppliers.supplierRequired": "Please select a supplier",
    "assignments.suppliers.inviteMailRequired": "Please enter an email address",
    "assignments.suppliers.customerLabel": "Customer",
    "assignments.suppliers.supplierLabel": "Supplier",
    "assignments.suppliers.emailAddressLabel": "Email address",
    "assignments.customers.headline": "Overview",
    "assignments.customers.subheadline": "Customers",
    "assignments.customers.infoPopover": "<strong>Info:</strong> Customers shows an overview of all customers linked to you on Closelink.",
    "assignments.overviewPageTitle": "Suppliers",
    "assignments.searchInputPlaceholder": "Search for supplier or port…",
    "assignments.toasts.uploadSuccess": "Price list uploaded",
    "assignments.toasts.uploadError": "Failed to upload price list",
    "assignments.toasts.uploadLoading": "Uploading price list",
    "assignments.toasts.downloadBlocked": "Download blocked by browser. Please allow popups and try again.",
    "assignments.toasts.updateError": "Failed to update assignment",
    "assignments.toasts.createSuccess": "Assignment created",
    "assignments.toasts.createError": "Failed to create assignment",
    "assignments.customerRequired": "Please select a customer",
    "assignments.supplierRequired": "Please select a supplier",
    "assignments.noAssignmnents": "No assignments found",
    "assignments.customerDetails.emptyStateDescription": "No suppliers are assigned to this company yet.",
    "assignments.tryDifferentFilter": "Please try again with a different filter",
    "assignments.deleteAssignment.delete": "Delete assignment",
    "assignments.deleteAssignment.headline": "Delete assignment?",
    "assignments.deleteAssignment.description": "This will permanently remove this assignment between the customer ({{customer}}) and the supplier ({{supplier}}). This action cannot be undone.",
    "assignments.deleteAssignment.deleteSuccess": "Assignment deleted",
    "reporting.pagetitle": "Statistics",
    "reporting.subtitle": "Statistics",
    "reporting.title": "Overview",
    "reporting.generaldata": "General",
    "reporting.vessels": "Vessels",
    "reporting.supplier": "Suppliers",
    "reporting.customer": "Customers",
    "reporting.product": "Products",
    "reporting.productgroup": "Product groups",
    "reporting.general.deliveries": "Deliveries",
    "reporting.general.volumes": "Volumes",
    "reporting.general.costs": "Total",
    "reporting.general.customersvol": "Volume customers",
    "reporting.general.ppl": "per Liter",
    "reporting.general.vesselsvol": "Volume vessels",
    "reporting.general.portsvol": "Volume ports",
    "reporting.general.productsvol": "Volume products",
    "reporting.general.productgroupsvol": "Volume product groups",
    "reporting.port": "Ports",
    "reporting.completed": "Completed orders",
    "reporting.ppl": "PpL ($)",
    "reporting.volume": "Volume (L)",
    "reporting.total": "Total ($)",
    "reporting.empty": "No data found",
    "reporting.noStatistics.title": "No completed orders",
    "reporting.noStatistics.description": "There are no statistics available for the selected period. Please try a different period.",
    "reporting.dateRangePresets.lastYear": "Last year ({{year}})",
    "reporting.dateRangePresets.currentYear": "Current year ({{year}})",
    "reporting.dateRangePresets.lastMonth": "Last month",
    "reporting.dateRangePresets.currentMonth": "Current month",
    "reporting.dateRangePresets.lastSixMonths": "Last 6 months",
    "reporting.filter.vessel.title": "Vessel",
    "reporting.filter.vessel.filterByVessel": "Filter by vessel",
    "reporting.filter.vessel.searchForVessel": "Search for vessel",
    "reporting.filter.supplier.title": "Supplier",
    "reporting.filter.supplier.filterBySupplier": "Filter by supplier",
    "reporting.filter.supplier.searchForSupplier": "Search for supplier",
    "reporting.filter.port.title": "Port",
    "reporting.filter.port.filterByPort": "Filter by port",
    "reporting.filter.port.searchForPort": "Search for port",
    "reporting.filter.product.title": "Product",
    "reporting.filter.product.filterByProduct": "Filter by product",
    "reporting.filter.product.searchForProduct": "Search for product",
    "reporting.filter.productGroup.title": "Product Group",
    "reporting.filter.productGroup.filterByProductGroup": "Filter by product group",
    "reporting.filter.productGroup.searchForProductGroup": "Search for product group",
    "reporting.filter.customer.title": "Customer",
    "reporting.filter.customer.filterByCustomer": "Filter by customer",
    "reporting.filter.customer.searchForCustomer": "Search for customer",
    "reporting.barTooltipLabels.completedOrders": "Completed orders: {{orders}}",
    "reporting.barTooltipLabels.ppl": "${{price}}",
    "reporting.barTooltipLabels.total": "${{total}}",
    "reporting.pieTooltipLabels.completedOrders": "Completed orders: {{orders}} ({{percentage}}%)",
    "reporting.pieTooltipLabels.total": "${{total}} ({{percentage}}%)",
    "reporting.pieTooltipLabels.volume": "{{volume}} ({{percentage}}%)",
    "actions.save": "Save",
    "actions.send": "Send",
    "actions.cancel": "Cancel",
    "actions.cancelall": "Cancel all",
    "actions.edit": "Edit",
    "actions.viewoffer": "View offer",
    "actions.vieworder": "View order",
    "actions.create": "Create",
    "actions.confirm": "Confirm",
    "actions.confirmDelivery": "Confirm delivery",
    "actions.adjust": "Adjust",
    "actions.applyselection": "Apply selection",
    "actions.ok": "OK",
    "actions.ordernow": "Place order",
    "actions.invite": "Invite",
    "actions.close": " Close",
    "actions.selectall": "Select all",
    "actions.unselectall": "Unselect all",
    "tutorials.subtitle": "Tutorials",
    "tutorials.title": "Overview",
    "tutorials.supplier.video1": "1. Introduction",
    "tutorials.supplier.video2": "2. Finalize set-up",
    "tutorials.supplier.video3": "3. Offer to spot enquiry",
    "tutorials.supplier.video4": "4. Confirm customer order",
    "tutorials.customer.video1": "1. Introduction",
    "tutorials.customer.video2": "2. Finalize set-up",
    "tutorials.customer.video3": "3. Create an enquiry",
    "tutorials.customer.video4": "4. Compare offers and create order",
    "message.createtitle": "Message to {{recipient}}",
    "message.writemessage": "Write message",
    "message.placeholder": "Type…",
    "message.text": "Text",
    "supplierInvite.requiredField": "This field is required.",
    "supplierInvite.invalidEmailAddress": "The email address is not valid.",
    "groupAcceptTerms.newsletter": "I want Closelink to send me the latest news via email.",
    "alert.deleteDraft.headline": "Delete draft {{reference}}",
    "alert.deleteDraft.text": "Deleted drafts can’t be restored. Are you sure you want to delete this draft?",
    "alert.resendInvitation.title": "Success",
    "alert.resendInvitation.message": "The invitation has been resent.",
    "alert.passwordNotStrongEnough.message": "This password is too easy to guess. Change your password to something stronger.",
    "alert.datedeliverychange.title": "Delivery date changed",
    "alert.datedeliverychange.message": "Please specify the reason for the delivery date change, for instance “Vessel ETA changed”, to inform your suppliers accordingly!",
    "alert.datedeliverychange.btnok": "Ok",
    "alert.datedeliverychange.error": "You have to state a reason for the change.",
    "alert.datedeliverychange.btncancel": "Close",
    "alert.datedeliverychange.placeholder": "Change reason (visible to suppliers)",
    "alert.datedeliverychange.success.title": "Delivery date changed",
    "alert.datedeliverychange.success.message": "The enquiry has been changed.",
    "alert.updateversion.title": "New version",
    "alert.updateversion.message": "There is a new version of Closelink available. Press Ok to update now.",
    "alert.mailnotunique.title": "Member already exists",
    "alert.mailnotunique.message": "A member with this email address already exists. Please choose a different one.",
    "alert.vesselexportsuccess.title": "Success",
    "alert.vesselexportsuccess.message": "The mail has been sent.",
    "alert.spotsuccess.title": "Success",
    "alert.spotsuccess.message": "The spot enquiry has been successfully transmitted.",
    "alert.addapikeysuccess.title": "Success",
    "alert.addapikeysuccess.message": "The API access key was successfully created.",
    "alert.invitesucess.title": "Success",
    "alert.invitesucess.message": "The member will receive an invitation email shortly.",
    "alert.vesselexportmissingmailerror.title": "Error",
    "alert.vesselexportmissingmailerror.message": "There is no email address in the vessel details. Please update your vessel with an email address.",
    "alert.redispatch.title": "Success",
    "alert.redispatch.message": "The spot has been redispatched.",
    "alert.translationerror.title": "Sorry!",
    "alert.translationerror.message": "The product {{productname}} could not be translated.",
    "alert.defaulterror.title": "Sorry, an error occurred!",
    "alert.defaulterror.message": "An unknown error. Please try again.",
    "alert.ordernotcomplete.title": "Sorry, an error occurred!",
    "alert.ordernotcomplete.message": "The order is not complete yet. Please fill out all mandatory fields.",
    "alert.deleteorder.title": "Delete order?",
    "alert.deleteorder.message": "The order will be deleted.",
    "alert.deleteorder.btnok": "Delete",
    "alert.deleteorder.btncancel": "Cancel",
    "alert.deletedraft.title": "Delete draft?",
    "alert.deletedraft.message": "The draft will be deleted.",
    "alert.deletedraft.btnok": "Delete",
    "alert.deletedraft.btncancel": "Cancel",
    "alert.cancelorder.title": "Cancel enquiry?",
    "alert.cancelorder.message": "You must provide a reason to cancel this order.",
    "alert.cancelorder.btnok": "Cancel enquiry",
    "alert.cancelorder.btnclose": "Go back",
    "alert.cancelorder.btncancel": "Close",
    "alert.cancelorder.label": "Cancellation reason",
    "alert.cancelorder.placeholder": "Type…",
    "alert.cancelorder.error": "Enter a cancellation reason",
    "alert.cancelspot.title": "Cancel enquiry?",
    "alert.cancelspot.message": "Do you really want to cancel the spot enquiry?",
    "alert.cancelspot.btnok": "Cancel enquiry",
    "alert.cancelspot.btncancel": "Close",
    "alert.cancelspot.placeholder": "Cancel reason (visible to suppliers)",
    "alert.cancelspot.error": "You have to state a reason for the cancellation.",
    "alert.cancelspot.success.title": "Canceled",
    "alert.cancelspot.success.message": "The enquiry has been canceled.",
    "alert.cancelordersuccess.title": "Canceled",
    "alert.cancelordersuccess.message": "The order has been canceled.",
    "alert.rejectorder.title": "Reject enquiry/order?",
    "alert.rejectorder.message": "You have to state a reason for the rejection.",
    "alert.rejectorder.btnok": "Reject enquiry/order",
    "alert.rejectorder.btncancel": "Cancel",
    "alert.rejectorder.btnclose": "Close",
    "alert.rejectorder.label": "Reject reason",
    "alert.rejectorder.placeholder": "Type…",
    "alert.rejectorder.error": "You have to state a reason for the rejection.",
    "alert.rejectordersuccess.title": "Rejected",
    "alert.rejectordersuccess.message": "The enquiry/order has been rejected.",
    "alert.deleteordersuccess.title": "Success",
    "alert.deleteordersuccess.message": "The draft has been deleted.",
    "alert.duplicateorder.title": "Duplicate order?",
    "alert.duplicateorder.message": "The order will be duplicated.",
    "alert.duplicateorder.btnok": "Duplicate",
    "alert.duplicateorder.btncancel": "Cancel",
    "alert.duplicateordersuccess.title": "Success",
    "alert.duplicateordersuccess.message": "The order has been duplicated.",
    "alert.uploadsuccess.title": "Success",
    "alert.uploadsuccess.message": "The price list was successfully uploaded.",
    "alert.confirmorder.title": "Confirm order",
    "alert.confirmorder.message": "Please make sure you checked all relevant order details before confirming.",
    "alert.confirmorder.datamissing": "Please make sure to fill in all missing details and review the relevant order information before confirming.",
    "alert.confirmorder.btnok": "Confirm order",
    "alert.confirmorder.btncancel": "Cancel",
    "alert.confirmChanges.title": "Confirm changes",
    "alert.confirmChanges.message": "Please make sure you checked all changes before confirming",
    "alert.confirmChanges.button": "Confirm changes",
    "alert.acknowledge.title": "Acknowledge order",
    "alert.acknowledge.message": "Please make sure you checked all relevant order details before acknowledging.",
    "alert.acknowledge.btnok": "Acknowledge order",
    "alert.acknowledge.btncancel": "Cancel",
    "alert.quotespotorder.title": "Send offer",
    "alert.quotespotorder.message": "You will place a binding offer in accordance with our terms & conditions.<br />In case your offer is chosen Closelink will charge a transaction fee of <strong>{{feeValue}}</strong> <strong>{{feeCurrency}}</strong>.<br />Your offer remains valid as such unless you change your offer details or reject the spot enquiry. <br /><br />You can change your offer details or reject a spot enquiry only as long as the customer did not agree to your offered terms.",
    "alert.quotespotorder.messagefreeofcharge": "You will place a binding offer in accordance with our terms & conditions.<br /><br />In case your offer is chosen the transaction is <strong>free of charge</strong>.<br /><br />Your offer remains valid as such unless you change your offer details or reject the spot enquiry. <br /><br />You can change your offer details or reject a spot enquiry only as long as the customer did not agree to your offered terms.",
    "alert.quotespotorder.messageundefined": "You will place a binding offer in accordance with our terms & conditions.<br /><br />In case your offer is chosen Closelink will charge a transaction fee of N/A.<br /><br />Your offer remains valid as such unless you change your offer details or reject the spot enquiry. <br /><br />You can change your offer details or reject a spot enquiry only as long as the customer did not agree to your offered terms.",
    "alert.quotespotorder.btnok": "Send",
    "alert.quotespotorder.btncancel": "Cancel",
    "alert.orderconfirmcreate.title": "Spot suppliers included",
    "alert.orderconfirmcreate.message": "You will be informed by mail when suppliers respond to your enquiry. It is your obligation to only order products fit for use based on your original equipment manufacturer specifications.",
    "alert.orderconfirmcreate.includemessage": "In addition to your selected suppliers, your enquiry will be forwarded to all other suppliers registered in Closelink with a potential availability in your port of choice.",
    "alert.orderconfirmcreate.excludemessage": "Your enquiry will be forwarded to all suppliers registered in Closelink with a potential availability in your port of choice, with the exception of your contracting partners.",
    "alert.orderconfirmcreate.btnok": "Send enquiry",
    "alert.orderconfirmcreate.btncancel": "Cancel",
    "alert.spotconfirmcreateorder.title": "Create order",
    "alert.spotconfirmcreateorder.message": "By confirming you accept the offer from <strong>{{supplierGroupName}}</strong> for <strong>{{vessel}}</strong> <strong>({{imo}})</strong> at <strong>{{port}}</strong> on <strong>{{date}}</strong>.",
    "alert.spotconfirmcreateorder.message2": "Unless individual agreements, which have precedence, are in place, please confirm that you have read and accept the <strong><a href='{{supplierGroupGTCUrl}}' target='_blank'>terms & conditions</a></strong> of <strong>{{supplierGroupName}}</strong>. <br /> <br />All remaining offers expire. The suppliers will be informed accordingly.",
    "alert.spotconfirmcreateorder.message3": "You can change details after creating the order.",
    "alert.spotconfirmcreateorder.btnok": "Create order",
    "alert.spotconfirmcreateorder.btncancel": "Adjust",
    "alert.spotconfirmcreateorder.success.title": "Success",
    "alert.spotconfirmcreateorder.success.message": "The order has been placed.",
    "alert.invite.title": "Success",
    "alert.invite.message": "Supplier invitation sent to {{email}}.",
    "alert.state.ORDER.title": "Order forwarded to supplier",
    "alert.state.ENQUIRY.title": "Enquiry forwarded to supplier",
    "alert.state.DELIVERED.title": "Marked as delivered",
    "alert.state.ADJUSTED.title": "Order adjusted",
    "alert.state.QUOTED.title": "Enquiry quoted",
    "alert.state.SPOTQUOTED.title": "Offer submitted",
    "alert.state.ACKNOWLEDGED.title": "Order acknowledged",
    "alert.state.CONFIRMED.title": "Order confirmed",
    "alert.state.LUBES.ORDER.title": "Order forwarded to supplier",
    "alert.state.LUBES.ENQUIRY.title": "Enquiry forwarded to supplier",
    "alert.state.LUBES.DELIVERED.title": "Order marked as delivered",
    "alert.state.LUBES.ADJUSTED.title": "Order adjusted",
    "alert.state.LUBES.QUOTED.title": "Enquiry quoted",
    "alert.state.LUBES.SPOTQUOTED.title": "Offer submitted",
    "alert.state.LUBES.ACKNOWLEDGED.title": "Order acknowledged",
    "alert.state.LUBES.CONFIRMED.title": "Order confirmed",
    "alert.state.LUBES.CANCELED.title": "Order canceled",
    "alert.state.LUBES.DELIVERY_CONFIRMED.title": "Delivery confirmed",
    "alert.duplicatebuyerref.title": "Duplicate buyer reference",
    "alert.directordernotallowed.title": "Not allowed",
    "alert.directordernotallowed.message": "The vessel {{name}} is not activated for direct ordering. Please contact us for further information.",
    "surcharges.headline": "Lubricants",
    "surcharges.create": "Create surcharge",
    "surcharges.createtitle": "Create surcharge",
    "surcharges.createbtn": "Create surcharge",
    "surcharges.alreadyexist": "Sorry, but the selected surcharge already exists.",
    "surcharges.customer": "Customer",
    "surcharges.packtype": "Packtype",
    "surcharges.group": "Product group",
    "surcharges.value": "Value",
    "surcharges.emptylist": "No surcharges yet.",
    "surcharges.placeholder.value": "e.g. 0.725",
    "surcharges.packTypeRequired": "Please select a packtype",
    "surcharges.valueRequired": "Please enter a value",
    "surcharges.action": "Action",
    "surcharges.toasts.deleteSurchargeError": "Failed to delete surcharge",
    "surcharges.toasts.createSurchargeError": "Failed to create surcharge",
    "surcharges.formLabels.customer": "Customer",
    "surcharges.formLabels.packtype": "Packtype",
    "surcharges.formLabels.productGroup": "Product group",
    "surcharges.formLabels.value": "Value",
    "offer.openOffers": "Open offers",
    "offer.customer": "Customer",
    "offer.supplier": "Supplier",
    "offer.company": "Company",
    "offer.multipleOffers": "Multiple offers",
    "offer.overviewPageTitle": "Offers",
    "offer.searchInputPlaceholder": "Search offers",
    "offer.priceAvailability.requestButton": "Request availability check",
    "offer.priceAvailability.createSuccess": "Availability check requested successfully",
    "offer.priceAvailability.createError": "Failed to request availability check",
    "offer.priceAvailability.statusChecked": "Availability checked by supplier",
    "offer.priceAvailability.statusPending": "Product availability check requested",
    "supplierOnboarding.requestSuccess": "KYC request sent to the supplier",
    "supplierOnboarding.requestError": "Failed to request KYC",
    "supplierOnboarding.submitSuccess": "KYC documents submitted",
    "supplierOnboarding.submitError": "Failed to submit KYC documents",
    "supplierOnboarding.cancelSuccess": "KYC request canceled",
    "supplierOnboarding.cancelError": "Failed to cancel the KYC request",
    "supplierOnboarding.cancelConfirm.headline": "Cancel KYC request?",
    "supplierOnboarding.cancelConfirm.text": "This cancels the onboarding request for this supplier. You can start a new request afterwards.",
    "supplierOnboarding.downloadError": "Failed to download the KYC documents",
    "supplierOnboarding.saveError": "Failed to save the documents",
    "supplierOnboarding.modal.requestTitle": "Request KYC",
    "supplierOnboarding.modal.requestSubmit": "Send request",
    "supplierOnboarding.modal.request.emptyTitle": "Upload KYC documents to get started",
    "supplierOnboarding.modal.request.emptyDescription": "Drag and drop KYC documents for the supplier to complete and return.",
    "supplierOnboarding.modal.uploadTitle": "Upload completed documents",
    "supplierOnboarding.modal.uploadSubmit": "Send to buyer",
    "supplierOnboarding.modal.upload.emptyTitle": "Upload documents to get started",
    "supplierOnboarding.modal.upload.emptyDescription": "Drag and drop completed documents here.",
    "supplierOnboarding.modal.uploadDocuments": "Upload documents",
    "supplierOnboarding.modal.uploadedAt": "uploaded at {{date}}",
    "supplierOnboarding.attachment.fileName": "KYC documents.zip",
    "supplierOnboarding.attachment.kycTag": "KYC",
    "supplierOnboarding.tag.requested": "KYC requested",
    "supplierOnboarding.tag.inProgress": "KYC in progress",
    "supplierOnboarding.tag.submitted": "KYC documents received",
    "supplierOnboarding.tag.cancelled": "KYC request cancelled",
    "supplierOnboarding.callout.requested.title": "KYC requested",
    "supplierOnboarding.callout.requested.description": "Download the KYC package, complete the requested documents, and upload them when ready.",
    "supplierOnboarding.callout.inProgress.title": "KYC in progress",
    "supplierOnboarding.callout.inProgress.description": "Complete the requested documents and upload them when completed.",
    "supplierOnboarding.callout.submitted.title": "KYC documents submitted",
    "supplierOnboarding.callout.submitted.description": "The buyer has received your completed KYC documents.",
    "supplierOnboarding.callout.cancelled.title": "KYC cancelled",
    "supplierOnboarding.callout.cancelled.description": "The buyer cancelled this KYC request.",
    "supplierOnboarding.callout.downloadAction": "Download KYC documents",
    "supplierOnboarding.callout.uploadAction": "Upload completed documents",
    "supplierOnboarding.callout.addDocumentsAction": "Add more documents",
    "offer.edit.lubes.generalInformation": "General information",
    "offer.edit.lubes.productUnavailable.title": "Product unavailable",
    "offer.edit.lubes.productUnavailable.description": "This product is unavailable for the current port and estimated delivery date. Changing either will automatically restore it.",
    "offer.edit.lubes.offer": "Offer {{number}}",
    "offer.edit.lubes.order": "Order {{number}}",
    "offer.edit.lubes.offerHeadline": "Edit offer {{number}}",
    "offer.edit.lubes.orderHeadline": "Edit order {{number}}",
    "offer.edit.lubes.editHeadline": "Edit",
    "offer.edit.lubes.deliveryDate": "Estimated delivery",
    "offer.edit.lubes.vessel": "Vessel",
    "offer.edit.lubes.port": "Port",
    "offer.edit.lubes.customer": "Customer",
    "offer.edit.lubes.agent": "Agent",
    "offer.edit.lubes.supplier": "Supplier",
    "offer.edit.lubes.noticeDays": "Notice days",
    "offer.edit.lubes.supplyMode": "Supply mode",
    "offer.edit.lubes.paymentTerms": "Payment terms",
    "offer.edit.lubes.paymentTermsDays": "Days",
    "offer.edit.lubes.vendorReference": "Vendor reference",
    "offer.edit.lubes.buyerReference": "Buyer reference",
    "offer.edit.lubes.buyerReferenceAlreadyUsed": "Buyer reference already used. Please use a different one.",
    "offer.edit.lubes.deliveryDateRequired": "Please select a delivery date",
    "offer.edit.lubes.supplyModeRequired": "Please select a supply mode",
    "offer.edit.lubes.paymentTermReferenceRequired": "Please select a payment term",
    "offer.edit.lubes.paymentTermReferenceDaysRequired": "Please enter days",
    "offer.edit.lubes.addProduct": "Add product",
    "offer.edit.lubes.addOilSampleKit": "Add oil sample kit",
    "offer.edit.lubes.buyerReferenceErrorToast": "Unable to save. Check your inputs and try again.",
    "offer.edit.lubes.errorToast": "Unable to save changes. Retry later.",
    "offer.edit.lubes.oilSampleKit.packet": "Packet",
    "offer.edit.lubes.oilSampleKit.usedOilSampleKit": "Used oil sample kit",
    "offer.edit.lubes.oilSampleKit.title": "Add oil sample kit",
    "offer.edit.lubes.oilSampleKit.name": "Name",
    "offer.edit.lubes.oilSampleKit.quantity": "Package quantity",
    "offer.edit.lubes.oilSampleKit.nameRequired": "Please enter a name",
    "offer.edit.lubes.oilSampleKit.quantityRequired": "Please enter a package quantity",
    "offer.edit.lubes.requestedProduct": "REQ: {{product}}",
    "offer.edit.headline": "Edit",
    "offer.edit.coreData.port": "Port",
    "offer.edit.coreData.dateDelivery": "Delivery date",
    "offer.edit.coreData.paymentTerms": "Payment terms",
    "offer.edit.coreData.agent": "Agent",
    "offer.edit.coreData.agentPhoneNumber": "Agent phone",
    "offer.edit.coreData.agentEmailAddress": "Agent mail",
    "offer.edit.coreData.noticeDays": "Notice days",
    "offer.edit.coreData.supplyMode": "Supply mode",
    "offer.edit.coreData.vendorReference": "Vendor reference",
    "offer.edit.coreData.headline": "Port & general information",
    "offer.edit.products.headline": "Products",
    "offer.detail.products": "Products",
    "offer.detail.position": "Position",
    "offer.detail.details": "Details",
    "offer.detail.chat": "Chat",
    "offer.detail.attachments": "Attachments",
    "offer.detail.activity": "Activity",
    "activityLog.showEvents": "Show {{count}} events: {{events}}",
    "offer.detail.attachments.info.header": "Shared vs. Internal",
    "offer.detail.attachments.info.customer": "Shared files are visible to you and the supplier. Internal files are visible only to your company.",
    "offer.detail.attachments.info.supplier": "Shared files are visible to you and the customer. Internal files are visible only to your company.",
    "offer.detail.attachments.info.admin": "Shared files are visible to both customer and supplier. Internal files are visible only to the company that uploaded them.",
    "offer.detail.header.headlineEnquiry": "Enquiry",
    "offer.detail.header.headlineOrder": "Order",
    "offer.detail.header.headlineOffer": "Offer",
    "offer.detail.header.actions.copy": "Copy order to new enquiry",
    "offer.detail.header.actions.editProducts": "Edit",
    "offer.detail.header.actions.initialOrder": "View initial enquiry",
    "offer.detail.header.actions.history": "View history",
    "offer.detail.header.actions.spotOverview": "View all offers",
    "offer.detail.header.actions.share": "Share",
    "offer.detail.header.actions.exportTooltip": "Export…",
    "offer.detail.header.actions.cancel": "Cancel order",
    "offer.detail.header.actions.decline": "Decline",
    "offer.detail.header.actions.reopenEnquiry": "Reopen enquiry",
    "offer.detail.header.actions.reopenEnquiryPopup.headline": "Reopen enquiry?",
    "offer.detail.header.actions.reopenEnquiryPopup.description": "This reopens the enquiry and makes it active again. No customer or supplier notifications are sent.",
    "offer.detail.header.actions.reopenEnquiryPopup.button": "Reopen enquiry",
    "offer.detail.header.actions.export.pdf.enquiry": "Download enquiry as PDF",
    "offer.detail.header.actions.export.pdf.offer": "Download offer as PDF",
    "offer.detail.header.actions.export.pdf.order": "Download order as PDF",
    "offer.detail.header.actions.export.share": "Share order",
    "offer.detail.header.actions.export.messages": "Download chat as TXT",
    "offer.detail.header.actions.export.downloadingPdf": "Downloading document",
    "offer.detail.header.actions.export.success": "Success",
    "offer.detail.header.actions.cancelPopup.enquiry.headline": "Decline enquiry?",
    "offer.detail.header.actions.cancelPopup.enquiry.description": "You must provide a reason for the decline. This reason will also be shown to the customer.",
    "offer.detail.header.actions.cancelPopup.enquiry.optionalReasonDescription": "You can provide a reason for the decline. This reason will also be shown to the customer.",
    "offer.detail.header.actions.cancelPopup.enquiry.button": "Decline enquiry",
    "offer.detail.header.actions.cancelPopup.quoted.headline": "Cancel offer?",
    "offer.detail.header.actions.cancelPopup.quoted.description": "You have to state a reason for the cancellation. The reason will also be displayed to the customer.",
    "offer.detail.header.actions.cancelPopup.quoted.optionalReasonDescription": "You can provide a reason for the cancellation. This reason will also be shown to the customer.",
    "offer.detail.header.actions.cancelPopup.quoted.button": "Cancel offer",
    "offer.detail.header.actions.cancelPopup.order.headline": "Decline order?",
    "offer.detail.header.actions.cancelPopup.order.description": "You have to state a reason for the decline. The reason will also be displayed to the customer.",
    "offer.detail.header.actions.cancelPopup.order.button": "Decline order",
    "offer.detail.header.actions.cancelPopup.customer.headline": "Cancel order?",
    "offer.detail.header.actions.cancelPopup.customer.description": "Provide a reason for the cancellation. It will be shared with the supplier.",
    "offer.detail.header.actions.cancelPopup.customer.button": "Cancel order",
    "offer.detail.header.actions.cancelPopup.customer.confirmed.headline": "Cancel confirmed order?",
    "offer.detail.header.actions.cancelPopup.customer.confirmed.description": "The supplier has already confirmed this order, so cancellation fees may apply. Provide a reason for the cancellation, which will be shared with the supplier.",
    "offer.detail.header.actions.cancelPopup.customer.confirmed.button": "Cancel confirmed order",
    "offer.detail.header.actions.cancelPopup.customer.confirmed.acknowledgement": "I understand that the supplier may charge cancellation fees.",
    "offer.history.drawerTitle": "Offer history",
    "offer.history.drawerDescription": "Review the revisions that led to the current offer and compare each change side by side.",
    "offer.history.empty.title": "No offer history yet",
    "offer.history.empty.description": "This offer does not have any recorded revisions yet.",
    "offer.history.actorUnknown": "Unknown actor",
    "offer.history.selectedRevisionTitle": "Before and after",
    "offer.history.selectedRevisionDescription": "{{actor}} updated this offer on {{timestamp}}.",
    "offer.history.mode.summary": "Summary",
    "offer.history.action.viewBefore": "View before",
    "offer.history.action.viewAfter": "View after",
    "offer.history.compare.before": "Before",
    "offer.history.compare.after": "After",
    "offer.history.snapshot.beforeTitle": "Before snapshot",
    "offer.history.snapshot.afterTitle": "After snapshot",
    "offer.history.snapshot.identifier": "{{entity}} {{offerNumber}}",
    "offer.history.snapshot.beforeDescription": "This is the offer revision from before {{actor}} updated the offer on {{timestamp}}.",
    "offer.history.snapshot.afterDescription": "This is the offer revision from after {{actor}} updated the offer on {{timestamp}}.",
    "offer.history.section.state": "State",
    "offer.history.section.coreData": "Core data",
    "offer.history.section.commercial": "Commercial",
    "offer.history.section.products": "Products",
    "offer.history.field.state": "State",
    "offer.history.field.actor": "Actor",
    "offer.history.field.change": "Change",
    "offer.history.field.volume": "Volume",
    "offer.history.field.ppl": "PPL",
    "offer.history.field.total": "Total",
    "offer.history.productType.item": "Product",
    "offer.history.productType.surcharge": "Surcharge",
    "offer.history.productType.samplekit": "Sample kit",
    "offer.history.productChange.added": "Added",
    "offer.history.productChange.removed": "Removed",
    "offer.history.productChange.changed": "Changed",
    "offer.history.itemStatus.deleted": "Deleted",
    "offer.detail.coreData.paymentTermsLabel": "Payment terms",
    "offer.detail.coreData.vessel": "Vessel",
    "offer.detail.coreData.company": "Company",
    "offer.detail.coreData.vesselPopup.button": "Info",
    "offer.detail.coreData.vesselPopup.headline": "Vessel details",
    "offer.detail.coreData.vesselPopup.name": "Name",
    "offer.detail.coreData.vesselPopup.imo": "IMO",
    "offer.detail.coreData.vesselPopup.mmsi": "MMSI",
    "offer.detail.coreData.vesselPopup.type": "Type",
    "offer.detail.coreData.vesselPopup.types": "Types",
    "offer.detail.coreData.vesselPopup.services": "Services",
    "offer.detail.coreData.vesselPopup.registrationPlace": "Place of registration",
    "offer.detail.coreData.vesselPopup.deadweight": "Deadweight",
    "offer.detail.coreData.vesselPopup.grossTonnage": "Gross tonnage",
    "offer.detail.coreData.vesselPopup.invoiceAddress": "Invoice address",
    "offer.detail.coreData.vesselPopup.postalAddress": "Postal address",
    "offer.detail.coreData.vesselPopup.invoiceVAT": "Invoice VAT",
    "offer.detail.coreData.vesselPopup.invoiceEmailAddress": "Invoice email address",
    "offer.detail.coreData.vesselPopup.viewVesselInfo": "View details",
    "offer.detail.coreData.customer": "Customer",
    "offer.detail.coreData.customerPopup.button": "Info",
    "offer.detail.coreData.customerPopup.headline": "Customer details",
    "offer.detail.coreData.customerPopup.name": "Name",
    "offer.detail.coreData.customerPopup.emailAddress": "Email Address",
    "offer.detail.coreData.customerPopup.phoneNumber": "Phone number",
    "offer.detail.coreData.customerPopup.address": "Address",
    "offer.detail.coreData.customerPopup.emailAddressNotAvailableSpot": "Will be shown after offer was selected",
    "offer.detail.coreData.customerPopup.emailAddressNotAvailableContracted": "Will be shown after quote was confirmed",
    "offer.detail.coreData.customerPopup.viewCustomerInfo": "View details",
    "offer.detail.coreData.supplier": "Supplier",
    "offer.detail.coreData.supplierPopup.button": "Info",
    "offer.detail.coreData.supplierPopup.viewSupplierInfo": "View details",
    "offer.detail.coreData.supplierPopup.headline": "Supplier details",
    "offer.detail.coreData.supplierPopup.name": "Name",
    "offer.detail.coreData.supplierPopup.emailAddress": "Email address",
    "offer.detail.coreData.supplierPopup.phoneNumber": "Phone number",
    "offer.detail.coreData.supplierPopup.address": "Address",
    "offer.detail.coreData.supplierPopup.emailAddressNotAvailableSpot": "Will be shown after offer was selected",
    "offer.detail.coreData.supplierPopup.emailAddressNotAvailableContracted": "Will be shown after quote was confirmed",
    "offer.detail.coreData.agentPopup.headline": "Agent details",
    "offer.detail.coreData.agentPopup.button": "View details",
    "offer.detail.coreData.agentPopup.generalData": "General data",
    "offer.detail.coreData.agentPopup.mainContactData": "Main contact data",
    "offer.detail.coreData.agentPopup.name": "Agent name",
    "offer.detail.coreData.agentPopup.ports": "Ports",
    "offer.detail.coreData.agentPopup.address": "Address",
    "offer.detail.coreData.agentPopup.remarks": "Remarks",
    "offer.detail.coreData.agentPopup.contact.name": "Contact name",
    "offer.detail.coreData.agentPopup.contact.phoneNumber": "Contact phone number",
    "offer.detail.coreData.agentPopup.contact.address": "Contact address",
    "offer.detail.coreData.agentPopup.contact.emailAddress": "Contact email address",
    "offer.detail.coreData.agentPopup.contact.faxNumber": "Fax",
    "offer.detail.coreData.port": "Port",
    "offer.detail.coreData.dateDelivery": "Estimated delivery",
    "offer.detail.coreData.status": "Status",
    "offer.detail.coreData.agent": "Agent",
    "offer.detail.coreData.contract": "Contract",
    "offer.detail.coreData.noAgent": "No agent added",
    "offer.detail.coreData.supplyMode": "Supply mode",
    "offer.detail.coreData.noticeDays": "Notice days",
    "offer.detail.coreData.dateCreated": "Date created",
    "offer.detail.coreData.buyerReference": "Buyer reference",
    "offer.detail.coreData.vendorReference": "Vendor reference",
    "offer.detail.coreData.offerNumber": "Offer number",
    "offer.detail.coreData.transactionFee": "Transaction fee",
    "offer.detail.vesselExportPopup.headline": "Notify vessel",
    "offer.detail.vesselExportPopup.description": "In order to send the file we need you to enter a valid email address of the receiving vessel.",
    "offer.detail.vesselExportPopup.saveButton": "Send",
    "offer.detail.vesselExportSuccessToast.headline": "Email sent",
    "offer.quotationProcess.header.createOffer": "Create offer",
    "offer.quotationProcess.header.createQuote": "Create quote",
    "offer.quotationProcess.labels.vessel": "Vessel",
    "offer.quotationProcess.labels.customer": "Customer",
    "offer.quotationProcess.labels.deliveryDate": "Delivery date",
    "offer.quotationProcess.labels.port": "Port",
    "offer.quotationProcess.labels.noticeDays": "Notice days",
    "offer.quotationProcess.labels.supplyType": "Supply type",
    "offer.quotationProcess.labels.paymentTerms": "Payment terms",
    "offer.quotationProcess.labels.vendorReference": "Vendor reference",
    "offer.quotationProcess.navigationButtons.cancel": "Cancel",
    "offer.quotationProcess.navigationButtons.back": "Back",
    "offer.quotationProcess.navigationButtons.spot.send": "Send offer",
    "offer.quotationProcess.navigationButtons.contracted.send": "Send quote",
    "offer.quotationProcess.navigationButtons.next": "Next",
    "offer.quotationProcess.agreeToTermsAndConditions": "I agree to the terms & conditions",
    "offer.quotationProcess.messageToCustomer": "Message to customer",
    "offer.quotationProcess.products.banner.headline": "Products",
    "offer.quotationProcess.products.banner.subHeadline": "Please fill the correct price. Furthermore you can add, change or delete any product and its preferences.",
    "offer.quotationProcess.coreData.banner.headline": "Details",
    "offer.quotationProcess.coreData.banner.subHeadline": "Please fill in all required fields and add your optional vendor reference.",
    "offer.quotationProcess.confirm.banner.spot.headline": "Check your offer",
    "offer.quotationProcess.confirm.banner.spot.subHeadline": "Please check provided information, accept the terms and conditions and send your offer to the customer.",
    "offer.quotationProcess.confirm.banner.contracted.headline": "Check your quote",
    "offer.quotationProcess.confirm.banner.contracted.subHeadline": "Please check provided information and send your quote to the customer.",
    "offer.quotationProcess.confirm.gtcLabel": "You will place a binding offer and accept our <a href='https://www.closelink.com/terms-conditions' target='_blank'><span style=\"font-weight: 600; color: #0056D5;\">Terms&nbsp;&&nbsp;Conditions</span></a>. By proceeding, Closelink will charge a transaction fee of <span style=\"font-weight: 600; color: #193643;\">{{value}}</span>.",
    "offer.quotationProcess.confirm.acceptTermsAndConditions": "Accept terms & conditions",
    "offer.quotationProcess.sentSuccessfully": "Quoted successfully",
    "offer.quotationProcess.failedToSend": "Failed to send. Please try again later.",
    "paymentTermDays.label": "Payment terms",
    "paymentTermDays.tooltip": "Payment terms",
    "paymentTermDays.editBox.daysInput.placeholder": "e.g. 21",
    "sortOptions.latest": "Recently updated",
    "sortOptions.deliveryDate": "Est. delivery date",
    "sortOptions.dateCreated": "Date created",
    "actionListLabel.markAsRead": "Mark as read",
    "actionListLabel.copyTo": "Copy order to new enquiry",
    "actionListLabel.copyEnquiryTo": "Copy enquiry to new enquiry",
    "actionListLabel.copyDraftTo": "Copy draft to new enquiry",
    "actionListLabel.markAsUnread": "Mark as unread",
    "actionListLabel.delete": "Delete draft",
    "labelList.contracted": "Contracted",
    "labelList.forwarded": "Limited platform access",
    "labelList.default": "Default",
    "labelList.manufacturer": "Manufacturer",
    "labelList.distributor": "Distributor",
    "labelList.trader": "Trader",
    "labelList.broker": "Broker",
    "passwordMeter.strength.danger": "Weak",
    "passwordMeter.strength.warning": "So-So",
    "passwordMeter.strength.success": "Great!",
    "approvalSettings.order": "Order",
    "approvalSettings.edit": "Edit settings",
    "approvalSettings.editApprovalSettings": "Edit approval settings",
    "approvalSettings.headerLabel": "Approval settings",
    "approvalSettings.updateApprovalSettings": "Update approval settings",
    "approvalSettings.activatedLabel": "Enable approval process",
    "approvalSettings.activatedText": "Activating this feature will require the procurement manager to send an approval request to the controller entered below. The request will be obligatory for one or multiple received offers before proceeding with the final ordering process.",
    "approvalSettings.requiredLabel": "Permit ordering without approval",
    "approvalSettings.requiredText": "Activating the feature will allow the purchaser to continue the ordering process without an approval.",
    "approvalSettings.emailInfoLabel": "Who should receive the request?",
    "approvalSettings.emailInfoText": "Please enter the default approval email address. It can be changed by the buyer before sending an approval request.",
    "approvalSettings.emailLabel": "Default approval email address",
    "approvalSettings.emailInputPlaceholder": "e.g. example@example.com",
    "multipleApproverSettings.thresholdForOrderingWithoutApproval": "Threshold for ordering without approval",
    "multipleApproverSettings.hide": "Hide",
    "multipleApproverSettings.show": "Show",
    "multipleApproverSettings.minimumApprovalThresholdExplanation": "By default, each buyer must request an approval for each order. Set an amount up to which orders can be placed without approval.",
    "multipleApproverSettings.minimumThresholdLabel": "Threshold",
    "multipleApproverSettings.allOrdersRequireApproval": "All orders need approval",
    "multipleApproverSettings.toConfigureThresholdTheTopLevelApproverMustBeSet": "To set a threshold, you must first specify the top approver.",
    "multipleApproverSettings.ordersUnderXDoNotRequireApproval": "Orders under {{minimumThreshold}} do not require approval",
    "multipleApproverSettings.topLevelApproverEmailAddressLabel": "Email address",
    "multipleApproverSettings.multipleApproverSettingsExplanation": "Enabling mandatory approval requests requires you to set a person as the top level approver. This person can approve any amount.",
    "multipleApproverSettings.approversAndApprovalLimits": "Approvers and approval limit",
    "multipleApproverSettings.topLevelApproverSpecified": "Top level approver specified",
    "multipleApproverSettings.noApproverSpecified": "No approver specified",
    "multipleApproverSettings.noApprovalLimitSpecified": "No approval limit specified",
    "multipleApproverSettings.setTopLevelApprover": "Set top level approver",
    "multipleApproverSettings.setLimitsAndApprovers": "Set limits and approvers",
    "multipleApproverSettings.additionalApproversDescription": "To approve orders up to a certain amount, you must first set an approval limit. Then you can add approvers who have the corresponding approval limit.",
    "multipleApproverSettings.approvalLimit": "Approval limit",
    "multipleApproverSettings.approvalLimitPlaceholder": "e.g. 10,000",
    "multipleApproverSettings.emailAddress": "Email address",
    "multipleApproverSettings.emailAddressPlaceholder": "Add an email address",
    "multipleApproverSettings.preventMultipleApprovers": "Limit sending requests to one approver",
    "multipleApproverSettings.singleApprovalLimitSpecified": "{{approvalLimitCount}} approval limit specified",
    "multipleApproverSettings.multipleApprovalLimitsSpecified": "{{approvalLimitCount}} approval limits specified",
    "multipleApproverSettings.topLevelApproverAndSingleAdditionalApproverSpecified": "Top level + {{additionalApproversCount}} additional approver specified",
    "multipleApproverSettings.topLevelApproverAndMultipleAdditionalApproversSpecified": "Top level + {{additionalApproversCount}} additional approvers specified",
    "multipleApproverSettings.approvalThresholdPlaceholder": "e.g. 4,000",
    "multipleApproverSettings.errors.topLevelEmailAddressRequired": "The top level approver email address is required",
    "multipleApproverSettings.errors.approvalLimitAlreadyExists": "This limit already exists",
    "multipleApproverSettings.errors.limitLowerThanThreshold": "The approval limit cannot be lower than the current threshold",
    "multipleApproverSettings.errors.minimumThresholdHigherThanLimit": "The threshold cannot be higher than the lowest approval limit",
    "multipleApproverSettings.errors.duplicateApproverEmailAddress": "This email is already associated with an approval limit",
    "multipleApproverSettings.errors.emailAddressAlreadyUsedForTopLevelApprover": "This email is already assigned to the top level approver",
    "multipleApproverSettings.errors.missingApprovalLimit": "Please enter approval limit",
    "multipleApproverSettings.errors.missingEmailAddress": "Please enter email address",
    "multipleApproverSettings.errors.invalidEmailAddress": "Please use valid email address",
    "multipleApproverSettings.settingsSummary.singleApproverPerRequest": "• Single approver per request",
    "multipleApproverSettings.settingsSummary.upToAmountWithoutApproval": "• Up to {{minimumThresholdAmount}} without approval",
    "multipleApproverSettings.settingsSummary.topLevelApproverSpecifiedWithEmail": "Top level approver: {{emailAddress}}",
    "multipleApproverSettings.settingsSummary.amountSingleAdditionalApprover": "• {{additionalApproverCount}} additional approver",
    "multipleApproverSettings.settingsSummary.amountMultipleAdditionalApprover": "• {{additionalApproverCount}} additional approvers",
    "multipleApproverSettings.settingsSummary.singleApprovalLimitSpecified": "• {{approvalLimitCount}} approval limit specified",
    "multipleApproverSettings.settingsSummary.multipleApprovalLimitsSpecified": "• {{approvalLimitCount}} approval limits specified",
    "approvalRequest.pageTitle": "Offer: {{vesselName}} - {{portName}} | Closelink",
    "approvalRequest.buttons.approve": "Approve",
    "approvalRequest.buttons.decline": "Decline",
    "approvalRequest.buttons.requestApproval": "Request approval",
    "approvalRequest.buttons.reRequestApproval": "Re-request approval",
    "approvalRequest.buttons.changesMadeWithdrawn": "Changes made. Approval withdrawn.",
    "approvalRequest.buttons.waitingForApproval": "Waiting for approval",
    "approvalRequest.buttons.orderNow": "Place order",
    "approvalRequest.buttons.orderNowDisabledTooltip": "Orders require a supplier quote. Direct ordering isn't available for this vessel.",
    "approvalRequest.buttons.requestApproved": "Request was approved",
    "approvalRequest.buttons.requestDeclined": "Your request was declined",
    "approvalRequest.buttons.sendRequestAgain": "Send request again",
    "approvalRequest.buttons.orderAnyhow": "Order anyhow",
    "approvalRequest.buttons.requestExpiredLong": "Approval request expired",
    "approvalRequest.requestApprovalPopup.headline": "Request approval",
    "approvalRequest.requestApprovalPopup.descriptionNoEmailAddress": "Please enter an email address your request should be sent to.",
    "approvalRequest.requestApprovalPopup.descriptionEmailAddress": "Your request will be send to the email address written below. You can change the recipient by overwriting the Email address and confirm the request.",
    "approvalRequest.requestApprovalPopup.emailAddressInput.label": "Email address",
    "approvalRequest.requestApprovalPopup.emailAddressInput.placeholder": "test@example.com",
    "approvalRequest.requestApprovalPopup.commentInput.label": "Add a comment",
    "approvalRequest.requestApprovalPopup.commentInput.placeholder": "e.g. Additional information",
    "approvalRequest.requestApprovalPopup.submitButton": "Send request",
    "approvalRequest.multipleApproversPopup.headline": "Request approval",
    "approvalRequest.multipleApproversPopup.hint": "Please select one or more approvers to whom you would like to send your approval request.",
    "approvalRequest.multipleApproversPopup.hintSingleApprover": "Please select one approver to whom you would like to send your approval request.",
    "approvalRequest.multipleApproversPopup.hintTopLevelApprover": "You must contact the top level approver to accept or reject your request.",
    "approvalRequest.multipleApproversPopup.qualifiedApproversHeadline": "Qualified approvers",
    "approvalRequest.multipleApproversPopup.approverLimit": "up to {{amount}}",
    "approvalRequest.multipleApproversPopup.topLevelApprover": "Top level approver",
    "approvalRequest.multipleApproversPopup.remark": "Remark",
    "approvalRequest.multipleApproversPopup.cancel": "Cancel",
    "approvalRequest.multipleApproversPopup.submit": "Submit",
    "approvalRequest.multipleApproversPopup.showOtherApprovers": "Show other approvers",
    "approvalRequest.multipleApproversPopup.hideOtherApprovers": "Hide other approvers",
    "approvalRequest.header.title": "Offer",
    "approvalRequest.dropdown.total": "Total: {{value}}",
    "approvalRequest.dropdown.withdrawnTotal": "Previously approved total: {{value}}",
    "approvalRequest.dropdown.latestActivity": "Approval status on {{date}}",
    "approvalRequest.dropdown.createdHeadlineComment": "Request created: “{{requestMessage}}“",
    "approvalRequest.dropdown.createdHeadlineNoComment": "Request created",
    "approvalRequest.dropdown.changeInformation": "{{date}} · by {{author}}",
    "approvalRequest.dropdown.approved.responseComment": "Request approved: “{{responseMessage}}“",
    "approvalRequest.dropdown.approved.responseNoComment": "Request approved",
    "approvalRequest.dropdown.declined.responseNoComment": "Request declined",
    "approvalRequest.dropdown.declined.responseComment": "Request declined: “{{responseMessage}}“",
    "approvalRequest.dropdown.withdrawn.headline": "Withdrawn due to updated offer details",
    "approvalRequest.dropdown.withdrawn.subHeadline": "{{date}} · by system",
    "approvalRequest.dropdown.expiredUser.headline": "Purchaser re-requested approval",
    "approvalRequest.dropdown.expiredSystem.headline": "Request expired",
    "approvalRequest.dropdown.expiredSystem.subHeadline": "{{date}} · by system",
    "approvalRequest.statusBar.approved.headline": "Request was approved",
    "approvalRequest.statusBar.approved.subHeadline": "Approved on {{date}} by {{author}} with a comment: “{{responseMessage}}”",
    "approvalRequest.statusBar.approvedNoComment.headline": "Request was approved",
    "approvalRequest.statusBar.approvedNoComment.subHeadline": "Approved on {{date}} by {{author}}",
    "approvalRequest.statusBar.declined.headline": "Declined",
    "approvalRequest.statusBar.declined.subHeadline": "You declined this offer on {{date}}. Decline Reason: “{{responseMessage}}”",
    "approvalRequest.statusBar.declinedNoReason.headline": "Declined",
    "approvalRequest.statusBar.declinedNoReason.subHeadline": "You declined this offer on {{date}}, no given decline reason.",
    "approvalRequest.statusBar.pending.headline": "Request in review",
    "approvalRequest.statusBar.pending.subHeadline": "Request created on {{date}} by {{author}} with a comment: “{{requestMessage}}”",
    "approvalRequest.statusBar.pendingNoComment.headline": "Request in review",
    "approvalRequest.statusBar.pendingNoComment.subHeadline": "Request created on {{date}} by {{author}}",
    "approvalRequest.statusBar.expired.headline": "Expired",
    "approvalRequest.statusBar.expired.subHeadline": "Unfortunately the request for approval is expired.",
    "approvalRequest.statusBar.generalError.headline": "Something went wrong.",
    "approvalRequest.statusBar.generalError.subHeadline": "We’re sorry for any issues you encountered. Please try again later.",
    "approvalRequest.statusBar.unauthorizedError.headline": "Unauthorized",
    "approvalRequest.statusBar.unauthorizedError.subHeadline": "The request can’t be viewed because either the request has been resent to a different approver or the request is older than one month.",
    "approvalRequest.declinePopup.headline": "Decline request",
    "approvalRequest.declinePopup.description": "You are about to decline the request. Please enter a reason below to inform the purchaser about your decision.",
    "approvalRequest.declinePopup.reasonInput.label": "Reason",
    "approvalRequest.declinePopup.submitButton": "Submit",
    "approvalRequest.approvePopup.headline": "Approve request",
    "approvalRequest.approvePopup.description": "You are about to approve the request. If you want to, you can add a comment.",
    "approvalRequest.approvePopup.commentInput.label": "Comment",
    "approvalRequest.approvePopup.submitButton": "Submit",
    "approvalRequest.commentInputPlaceholder": "Start typing here..",
    "approvalRequest.toasts.approvalRequestDeclinedSuccess": "Request declined",
    "approvalRequest.toasts.approvalRequestApprovedSuccess": "Request approved",
    "approvalRequest.toasts.approvalRequestUpdateError": "Update failed",
    "drawer.closeTitle": "Close top layer",
    "createVesselForm.title": "Create vessel",
    "createVesselForm.createVessel": "Create vessel",
    "createVesselForm.toast.success": "New vessel created",
    "createVesselForm.toast.error": "Failed to create vessel",
    "createAgentForm.toast.success": "New agent created",
    "createAgentForm.toast.error": "Failed to create agent",
    "updateAgentForm.toast.success": "Agent updated",
    "updateAgentForm.toast.error": "Failed to update agent",
    "agentForm.agentName": "Agent name",
    "agentForm.note": "Additional information",
    "agentForm.ports": "Ports",
    "agentForm.companyHint": "You are assigned to more than one company. Select a company the agent will be assigned to.",
    "agentForm.contact.heading": "Main contact",
    "agentForm.contact.name": "Contact name",
    "agentForm.contact.emailAddress": "Email address",
    "agentForm.contact.phoneNumber": "Phone number",
    "agentForm.contact.faxNumber": "Fax",
    "agentForm.placeholder.agentName": "e.g. Agent Andrew",
    "agentForm.placeholder.emailAddress": "e.g. agent@example.com",
    "agentForm.placeholder.note": "e.g. Additional contact information",
    "agentForm.placeholder.ports": "Type to search for port…",
    "agentForm.placeholder.contact.name": "e.g. Joe Doe",
    "agentForm.placeholder.contact.emailAddress": "e.g. joe@example.com",
    "agentForm.placeholder.contact.phoneNumber": "e.g 00 49 123 456 78",
    "agentForm.placeholder.contact.faxNumber": "e.g. 00 49 123 456 789 ",
    "portSelect.label": "Port",
    "portSelect.placeholder": "Search and select ",
    "portSelect.placeholderMulti": "Select ports",
    "portSelect.scheduleSharing.tooltip": "You can choose a different port. If shown, the vessel schedule can help you make a more suitable offer.",
    "portSelect.reach.sectionHeading": "Ports below might require further product supply before reaching them.",
    "portSelect.reach.outOfReachHelper": "The vessel might require further product supply before reaching this port.",
    "portSelect.error.headline": "Something went wrong",
    "countrySelect.placeholder": "Select country",
    "productSelect.inTank": "In tank",
    "productSelect.suggested": "Suggested",
    "productSelect.placeholder": "Select product",
    "selectAgent.label": "Agent",
    "selectAgent.mandatoryFields": "You need to select a vessel & port before creating/searching an agent.",
    "selectAgent.edit": "Edit information of '{{additionalInfo}}'",
    "selectAgent.createAgent": "Create agent",
    "selectAgent.placeholder": "Search and select",
    "selectAgent.imported": "Imported",
    "selectAgent.importedLabel": "{{name}} [Imported]",
    "coreDataPopup.expandText": "Show more data",
    "coreDataPopup.collapseText": "Show less data",
    "agentInfoPopup.heading": "Agent details",
    "agentInfoPopup.generalData": "General data",
    "agentInfoPopup.agentName": "Name",
    "agentInfoPopup.port": "Ports",
    "agentInfoPopup.address": "Address",
    "agentInfoPopup.mainContactData": "Main contact data",
    "agentInfoPopup.moreContactData": "Additional contact data",
    "agentInfoPopup.expandText": "Show more contact data",
    "agentInfoPopup.collapseText": "Show less contact data",
    "agentInfoPopup.note": "Additional information",
    "agentInfoPopup.contact.name": "Name",
    "agentInfoPopup.contact.phoneNumber": "Phone number",
    "agentInfoPopup.contact.emailAddress": "Email address",
    "agentInfoPopup.contact.faxNumber": "Fax",
    "common.lubricants": "Lubricants",
    "communicationBanner": {},
    "deleteIconButton.submit": "Delete now",
    "archivePopupButton.submit": "Archive now",
    "restorePopupButton.submit": "Restore now",
    "contracts.pageTitle": "Contracts",
    "contracts.headline": "Contracts",
    "contracts.labels.name": "Name",
    "contracts.labels.evergreen": "Evergreen",
    "contracts.labels.supplier": "Supplier",
    "contracts.labels.customer": "Customers",
    "contracts.labels.company": "Companies",
    "contracts.labels.validity": "Validity",
    "contracts.labels.expiration": "Expiration",
    "contracts.validity.evergreen": "Evergreen",
    "contracts.expiration.days": "{{count}} days",
    "contracts.labels.status": "Status",
    "contracts.labels.lastModified": "Last modified",
    "contracts.status.DRAFT": "Draft",
    "contracts.status.AWARDED": "Awarded",
    "contracts.status.ACTIVE": "Active",
    "contracts.status.INACTIVE": "Inactive",
    "contracts.detail.pageTitle": "Contract {{name}}",
    "contracts.detail.pageTitleContract": "Contract",
    "contracts.detail.overview": "Overview",
    "contracts.detail.details": "Details",
    "contracts.detail.contractReference": "Contract reference",
    "contracts.detail.companies": "Companies",
    "contracts.detail.customers": "Customers",
    "contracts.detail.description": "Description",
    "contracts.detail.paymentTerms": "Payment terms",
    "contracts.detail.applyPricesBasedOn": "Prices apply on",
    "contracts.detail.deliveryDate": "Delivery date",
    "contracts.detail.orderDate": "Enquiry date",
    "contracts.detail.activationMode": "Price list activation",
    "contracts.detail.activationModeAutomatic": "Automatic",
    "contracts.detail.activationModeManual": "Manual",
    "contracts.detail.validity": "Validity",
    "contracts.detail.minimumVolume": "Minimum volume commitment",
    "contracts.detail.gtc": "GTC",
    "contracts.detail.durationLeft": "Duration left",
    "contracts.detail.created": "Created",
    "contracts.detail.contractId": "Contract ID",
    "contracts.detail.evergreen": "(Evergreen)",
    "contracts.detail.evergreenValue": "Evergreen",
    "contracts.detail.remainingDay": "{{days}} day remaining",
    "contracts.detail.remainingDays": "{{days}} days remaining",
    "contracts.detail.remainingMonth": "{{months}} month remaining",
    "contracts.detail.remainingMonths": "{{months}} months remaining",
    "contracts.detail.expiresToday": "Expires today",
    "contracts.priceLists.title": "Price list",
    "contracts.priceLists.emptyState.title": "No price lists",
    "contracts.priceLists.download": "Download price list",
    "contracts.priceLists.normalized": "Normalized",
    "contracts.priceLists.fileNameFallback": "Price list",
    "contracts.priceLists.actions.applyToPricing": "Apply to pricing",
    "contracts.priceLists.actions.stopApplying": "Stop applying",
    "contracts.priceLists.actions.cancelApplication": "Cancel application",
    "contracts.priceLists.actions.upload": "Upload",
    "contracts.priceLists.actions.reupload": "Re-upload",
    "contracts.priceLists.actions.uploadLoading": "Uploading price list...",
    "contracts.priceLists.actions.uploadSuccess": "Price list uploaded",
    "contracts.priceLists.actions.uploadError": "Could not upload price list",
    "contracts.priceLists.actions.download": "Download",
    "contracts.priceLists.actions.delete": "Delete",
    "contracts.priceLists.actions.manualModeOnlyDescription": "Price lists can only be applied or stopped in manual mode.",
    "contracts.priceLists.actions.cancelApplicationLoading": "Canceling application...",
    "contracts.priceLists.actions.cancelApplicationSuccess": "Price list application canceled",
    "contracts.priceLists.actions.cancelApplicationError": "Could not cancel price list application",
    "contracts.priceLists.actions.applyLoading": "Applying price list...",
    "contracts.priceLists.actions.applySuccess": "Price list applied",
    "contracts.priceLists.actions.applyError": "Could not apply price list",
    "contracts.priceLists.actions.deleteLoading": "Deleting price list...",
    "contracts.priceLists.actions.deleteSuccess": "Price list deleted",
    "contracts.priceLists.actions.deleteError": "Could not delete price list",
    "contracts.priceLists.actions.stopApplyingLoading": "Stopping price list application...",
    "contracts.priceLists.actions.stopApplyingSuccess": "Price list application stopped",
    "contracts.priceLists.actions.stopApplyingError": "Could not stop price list application",
    "contracts.priceLists.edit.title": "Edit price list",
    "contracts.priceLists.edit.toast.success": "Price list updated",
    "contracts.priceLists.edit.toast.error": "Could not update price list",
    "contracts.priceLists.status.active": "Applied",
    "contracts.priceLists.status.expired": "Expired",
    "contracts.priceLists.status.processing": "Processing",
    "contracts.priceLists.activation.open": "Price list activation",
    "contracts.priceLists.activation.title": "Price list activation",
    "contracts.priceLists.activation.options.auto.label": "Automatic (recommended)",
    "contracts.priceLists.activation.options.auto.description": "Applied automatically based on validity dates.",
    "contracts.priceLists.activation.options.manual.label": "Manual",
    "contracts.priceLists.activation.options.manual.description": "Apply price lists manually. Only one can be applied at a time.",
    "contracts.priceLists.activeOnApproval.disabledDescription": "Another price list is already applied. All other price lists that would be applied will stop applying first.",
    "contracts.priceLists.activation.toast.success": "Price list activation updated",
    "contracts.priceLists.activation.toast.error": "Could not update price list activation",
    "contracts.emptyState.title": "Create your first contract",
    "contracts.emptyState.description": "Define commercial terms and link them to relevant price lists to manage agreements across suppliers and vessels efficiently.",
    "contracts.noResults.title": "No contracts found",
    "contracts.noResults.description": "Try adjusting your filters to find what you're looking for.",
    "contracts.deleteSuccessToast": "Contract deleted",
    "contracts.deleteErrorToast": "Failed to delete contract",
    "contracts.actions.createNewFromContract": "Use as template",
    "contracts.actions.activate.label": "Activate",
    "contracts.actions.activate.loading": "Activating contract…",
    "contracts.actions.activate.success": "Contract activated",
    "contracts.actions.activate.error": "Failed to activate contract",
    "contracts.actions.deactivate.label": "Deactivate",
    "contracts.actions.deactivate.contractLabel": "Deactivate",
    "contracts.actions.deactivate.confirmTitle": "Deactivate",
    "contracts.actions.deactivate.confirmDescription": "This contract will no longer be available for new enquiries or direct orders and will be removed as the default contract for affected vessels. Existing orders and history will remain unchanged. You can reactivate it later.",
    "contracts.actions.deactivate.loading": "Deactivating contract…",
    "contracts.actions.deactivate.success": "Contract deactivated",
    "contracts.actions.deactivate.error": "Failed to deactivate contract",
    "contracts.actions.convertToDraft.label": "Convert to draft",
    "contracts.actions.convertToDraft.loading": "Converting contract to draft…",
    "contracts.actions.convertToDraft.success": "Contract converted to draft",
    "contracts.actions.convertToDraft.error": "Failed to convert contract to draft",
    "contracts.actions.award.loading": "Awarding contract…",
    "contracts.actions.award.disabledDescription": "Required details are missing or invalid. Complete them to award this contract.",
    "contracts.vesselAccess.title": "Manage vessel access",
    "contracts.vesselAccess.description": "Selected vessels won’t be able to access this contract.",
    "contracts.vesselAccess.excludedVessels": "Excluded vessels",
    "contracts.vesselAccess.excludedVesselsCount": "Excluded vessels ({{count}})",
    "contracts.vesselAccess.excludeVessels": "Exclude vessels",
    "contracts.vesselAccess.manageVesselAccess": "Manage vessel access",
    "contracts.vesselAccess.updateAccess": "Update access",
    "contracts.vesselAccess.noVessels": "No vessels are available for the selected companies.",
    "contracts.vesselAccess.updateSuccess": "Vessel access updated",
    "contracts.vesselAccess.updateError": "Could not update vessel access",
    "contracts.deleteConfirmTitle": "Delete contract",
    "contracts.deleteConfirmDescription": "Are you sure you want to delete this contract?",
    "contracts.filters.status": "Status",
    "contracts.filters.filterByStatus": "Filter by status",
    "contracts.filters.expiration": "Expiration",
    "contracts.filters.filterByExpiration": "Filter by expiration",
    "contracts.filters.nameReference": "Name/Reference",
    "contracts.filters.filterByNameReference": "Filter by name or reference",
    "contracts.filters.evergreen": "Evergreen",
    "contracts.filters.filterByEvergreen": "Filter by evergreen",
    "contracts.filters.supplier": "Supplier",
    "contracts.filters.filterBySupplier": "Filter by supplier",
    "contracts.filters.searchForSupplier": "Search for supplier",
    "contracts.filters.customerGroup": "Customer group",
    "contracts.filters.filterByCustomerGroup": "Filter by customer group",
    "contracts.filters.searchForCustomerGroup": "Search for customer group",
    "contracts.filters.customer": "Customers",
    "contracts.filters.filterByCustomer": "Filter by customers",
    "contracts.filters.searchForCustomer": "Search for customers",
    "contracts.filters.company": "Companies",
    "contracts.filters.filterByCompany": "Filter by companies",
    "contracts.filters.searchForCompany": "Search for companies",
    "contracts.filters.days": "days",
    "contracts.form.createAction": "Create contract",
    "contracts.form.createTitle": "Create contract",
    "contracts.form.editTitle": "Update contract",
    "contracts.form.sections.baseDetails": "Base details",
    "contracts.form.sections.supplier": "Supplier",
    "contracts.form.sections.scope": "Scope",
    "contracts.form.sections.validity": "Validity",
    "contracts.form.sections.paymentAndConditions": "Payment & conditions",
    "contracts.form.contractName": "Contract name",
    "contracts.form.contractNameDescription": "Appears in contract lists and order details.",
    "contracts.form.contractReference": "Contract reference",
    "contracts.form.contractReferenceDescription": "Supplier's own reference, if available.",
    "contracts.form.additionalInformation": "Additional information",
    "contracts.form.additionalInformationDescription": "Short internal note or context (not shared externally).",
    "contracts.form.additionalInformationPlaceholder": "Short summary for internal users only...",
    "contracts.form.assignedSupplier": "Assigned supplier",
    "contracts.form.assignedSupplierDescription": "Select the supplier this contract applies to.",
    "contracts.form.assignedSupplierPlaceholder": "Select supplier...",
    "contracts.form.assignedSupplierSupportCallout": "If your contractual supplier is unavailable, [contact support].",
    "contracts.form.company": "Company",
    "contracts.form.companyDescription": "Select the companies this contract applies to. Leave empty to apply to all companies.",
    "contracts.form.companyPlaceholder": "Select company...",
    "contracts.form.minimumVolume": "Minimum volume commitment",
    "contracts.form.minimumVolumePlaceholder": "e.g. 1,000,000",
    "contracts.form.validityDescription": "Set the contract period.",
    "contracts.form.startDate": "Start date",
    "contracts.form.endDate": "End date",
    "contracts.form.startDateDescription": "The contract becomes valid on this date.",
    "contracts.form.endDateDescription": "Leave empty for open-ended contracts.",
    "contracts.form.evergreen": "Evergreen",
    "contracts.form.evergreenDescription": "Automatically continues after end date until manually deactivated.",
    "contracts.form.paymentTerms": "Payment terms",
    "contracts.form.paymentTermsPlaceholder": "Select payment terms...",
    "contracts.form.days": "Days",
    "contracts.form.gtc": "Add supplier's GTC",
    "contracts.form.gtcDescription": "Upload a PDF or provide a link to the supplier's GTC.",
    "contracts.form.gtcPlaceholder": "https://...",
    "contracts.form.copyName": "[Copy] {{name}}",
    "contracts.form.actions.saveDraft": "Save draft",
    "contracts.form.actions.awardContract": "Award contract",
    "contracts.form.actions.saveContract": "Save contract",
    "contracts.form.actions.updateContract": "Update contract",
    "contracts.form.toast.createDraftSuccess": "Draft contract created",
    "contracts.form.toast.createDraftError": "Failed to create draft contract",
    "contracts.form.toast.publishSuccess": "Contract awarded",
    "contracts.form.toast.publishError": "Failed to award contract",
    "contracts.form.toast.editSuccess": "Contract updated",
    "contracts.form.toast.editError": "Failed to update contract",
    "contracts.form.validation.customerGroupRequired": "Customer group is required",
    "contracts.form.validation.validUntilAfterValidFrom": "End date must be on or after start date",
    "contracts.form.validation.backend.required.name": "Contract name is required",
    "contracts.form.validation.backend.required.supplierId": "Supplier is required",
    "contracts.form.validation.backend.required.gtc": "GTC is required",
    "contracts.form.validation.backend.required.paymentTermReference": "Payment terms is required",
    "contracts.form.validation.backend.required.validFrom": "Start date is required",
    "contracts.form.validation.backend.PAYMENT_TERM_DAYS_REQUIRED": "Days required",
    "contracts.form.validation.backend.PRICE_LIST_EXCEEDS_CONTRACT_VALIDITY": "A price list ends after the contract end date. Align the price list validity first.",
    "datepicker.placeholder": "Select date",
    "waiverForm.title": "Add waiver",
    "waiverForm.description.amount": "Briefly describe the waiver and enter the amount.",
    "waiverForm.description.total": "This will be deducted from the order total.",
    "waiverForm.labels.amount": "Amount",
    "waiverForm.labels.description": "Description",
    "waiverForm.button": "Add waiver",
    "waiverForm.submit": "Save",
    "waiverForm.errors.descriptionRequired": "Please add a description",
    "waiverForm.errors.amountRequired": "Please add an amount",
    "waiverForm.errors.amountZero": "The amount must be greater than 0",
    "surchargeForm.title": "Add surcharge",
    "surchargeForm.options.SHORT_NOTICE": "Short notice surcharge",
    "surchargeForm.options.BARGE_CHARGE": "Barge charge",
    "surchargeForm.options.MINIMUM_QUANTITY": "Small order surcharge",
    "surchargeForm.options.PORT_FEE": "Port Fee",
    "surchargeForm.options.CUSTOMS": "Taxes & Duties",
    "surchargeForm.options.AGENCY_FEES": "Agency Fees",
    "surchargeForm.options.FREIGHT_AND_TRANSPORTATION_CHARGE": "Freight & transportation charge",
    "surchargeForm.labels.surchargeType": "Surcharge type",
    "surchargeForm.labels.customOption": "Surcharge description",
    "surchargeForm.description.choose": "Choose a surcharge type and enter the amount.",
    "surchargeForm.description.total": "This will be added to the order total.",
    "surchargeForm.labels.amount": "Amount",
    "surchargeForm.button": "Add surcharge",
    "surchargeForm.submit": "Save",
    "surchargeForm.errors.typeRequired": "Please select a surcharge type",
    "surchargeForm.errors.amountRequired": "Please add an amount",
    "surchargeForm.errors.amountZero": "The amount must be greater than 0",
    "keyPorts.overviewPageTitle": "Key ports",
    "keyPorts.searchInputPlaceholder": "Search for port or country",
    "keyPorts.actions": "Actions",
    "keyPorts.port": "Port",
    "keyPorts.country": "Country",
    "keyPorts.region": "Region",
    "keyPorts.group": "Group",
    "keyPorts.addKeyPort": "Add key port",
    "keyPorts.emptyList": "No key ports found",
    "keyPorts.editKeyPort": "Edit key port",
    "keyPorts.update": "Update key port",
    "keyPorts.portSelectPlaceholder": "Select port",
    "keyPorts.save": "Save",
    "keyPorts.placeholder.productCategory": "Select product category",
    "keyPorts.placeholder.searchVessels": "Search and select",
    "keyPorts.vesselLimitation.headline": "Vessel limitations",
    "keyPorts.vesselLimitation.text": "If the preference is only valid for specific vessels please add all vessel which should be considered. If you don't add any vessels the port is a preference for all vessels.",
    "keyPorts.addVesselLimitation": "Add vessel",
    "keyPorts.editVesselLimitation": "Edit vessel",
    "keyPorts.updateVesselLimitation": "Update vessel",
    "keyPorts.vessel": "Vessel",
    "keyPorts.productCategoryLimitation.headline": "Product Category Limitations",
    "keyPorts.productCategoryLimitation.text": "If the preference is only valid for specific product categories please add all the product categories which should be considered. If you don’t add any product categories the port is a preference for all products.",
    "keyPorts.addProductCategory": "Add product category",
    "keyPorts.editProductCategory": "Edit product category",
    "keyPorts.productCategory": "Product category",
    "keyPorts.duplicateError": "Duplicate key port. Please select another port or edit the existing key port.",
    "keyPorts.productCategories": "Product categories",
    "keyPorts.vesselLimitations": "Vessel limitations",
    "keyPorts.context": "Context",
    "keyPorts.deleteButton.headline": "Delete key port",
    "keyPorts.deleteButton.text": "Deleted key ports can't be restored. Are you sure you want to delete this key port?",
    "keyPorts.toast.deleteKeyPort.success": "Key port deleted",
    "keyPorts.toast.deleteKeyPort.error": "Failed to delete key port",
    "keyPorts.toast.createKeyPort.success": "Key port created",
    "keyPorts.toast.createKeyPort.error": "Failed to create key port",
    "keyPorts.toast.updateKeyPort.success": "Key port updated",
    "keyPorts.toast.updateKeyPort.error": "Failed to update key port",
    "keyPorts.highlightTooltip": "Key port",
    "customerGroupSelect.label": "Customer group",
    "customerGroupSelect.placeholder": "Select customer group",
    "customerGroupSelect.filterByCustomerGroups": "Filter by customer groups",
    "supplierGroupSelect.placeholder": "Select supplier group",
    "supplierGroupSelect.filterBySupplierGroups": "Filter by supplier groups",
    "agents.overviewPageTitle": "Agents",
    "agents.searchInputPlaceholder": "Search for agent…",
    "agents.emptyList": "No agents found",
    "agents.name": "Name",
    "agents.company": "Company",
    "agents.ports": "Ports",
    "agents.email": "Email address",
    "agents.phone": "Phone number",
    "agents.dateCreated": "Date created",
    "agents.lastEdit": "Last edit",
    "agents.portsPlaceholder": "Filter by ports",
    "agents.createAgent": "Create agent",
    "agents.editAgent": "Edit agent",
    "agents.updateAgent": "Update agent",
    "agents.archiveButton.btnText": "Archive",
    "agents.archiveButton.headline": "Archive agent",
    "agents.archiveButton.text": "Archived agents can't be selected in new enquiries anymore. Are you sure you want to archive the following agent?",
    "agents.restoreButton.btnText": "Restore",
    "agents.restoreButton.headline": "Restore agent",
    "agents.restoreButton.text": "Are you sure you want to restore the following agent?",
    "agents.archiveAgentToast.success": "Agent archived",
    "agents.archiveAgentToast.error": "Failed to archive agent",
    "agents.restoreAgentToast.success": "Agent restored",
    "agents.restoreAgentToast.error": "Failed to restore agent",
    "agents.detail.headline": "Agent",
    "agents.detail.sectionHeadline": "Details",
    "agents.detail.archivedTag": "Archived",
    "agents.detail.address": "Address",
    "agents.detail.note": "Note",
    "agents.detail.dateCreated": "Date created",
    "agents.detail.lastEdit": "Last edit",
    "agents.detail.contact.headline": "Contact details",
    "agents.detail.contact.name": "Name",
    "agents.detail.contact.email": "Email address",
    "agents.detail.contact.phone": "Phone number",
    "agents.detail.contact.fax": "Fax number",
    "agents.detail.importedTag": "Imported",
    "contextSwitch.all.title": "All",
    "contextSwitch.draft.title": "Draft",
    "contextSwitch.awarded.title": "Awarded",
    "contextSwitch.tendered.title": "Tendered",
    "contextSwitch.contracted.title": "Contracted",
    "contextSwitch.concluded.title": "Concluded",
    "contextSwitch.active.title": "Active",
    "contextSwitch.archived.title": "Archived",
    "contextSwitch.inactive.title": "Inactive",
    "contextSwitch.drafted.title": "Drafts",
    "contextSwitch.enquired.title": "Enquiries",
    "contextSwitch.offered.title": "Offered",
    "contextSwitch.ordered.title": "Ordered",
    "contextSwitch.acknowledged.title": "Acknowledged",
    "contextSwitch.confirmed.title": "Confirmed",
    "contextSwitch.delivered.title": "Delivered",
    "contextSwitch.canceled.title": "Canceled",
    "contextSwitch.expired.title": "Expired",
    "contextSwitch.closed.title": "Closed",
    "contextSwitch.vessels.title": "Vessels",
    "contextSwitch.general.title": "General",
    "contextSwitch.suppliers.title": "Suppliers",
    "contextSwitch.customers.title": "Customers",
    "contextSwitch.ports.title": "Ports",
    "contextSwitch.products.title": "Products",
    "contextSwitch.productGroups.title": "Product groups",
    "contextSwitch.glsm.title": "GLSM (Maersk)",
    "contextSwitch.mariApps.title": "MariApps (Maersk)",
    "contextSwitch.onePort.title": "OnePort",
    "contextSwitch.cloudFleetManager.title": "Cloud Fleet Manager",
    "contextSwitch.bassNet.title": "BASSnet",
    "contextSwitch.overview.title": "Overview",
    "contextSwitch.schedule.title": "Schedule",
    "contextSwitch.orders.title": "Orders",
    "contextSwitch.contracts.title": "Contracts",
    "contextSwitch.details.title": "Details",
    "contextSwitch.settings.title": "Settings",
    "contextSwitch.communicationPreferences.title": "Communication preferences",
    "contextSwitch.spotPortAvailability.title": "Port availability",
    "contextSwitch.twoStepAuthentication.title": "Two-step authentication",
    "contextSwitch.singleSignOn.title": "Single sign-on (SSO)",
    "contextSwitch.developers.title": "Developers",
    "contextSwitch.surcharges.title": "Surcharges",
    "budgets.title": "Budget",
    "budgets.emptyState": "No budget defined",
    "budgets.budgetAvailable": "Budget available",
    "budgets.budgetSpent": "Budget spent*",
    "budgets.budgetSpentInfo": "*confirmed or delivered orders with an estimated delivery date after start date",
    "budgets.createBudget": "Create budget",
    "budgets.editBudget": "Edit budget",
    "budgets.updateBudget": "Update budget",
    "budgets.remove": "Delete",
    "budgets.budget": "Budget",
    "budgets.startDate": "Start date",
    "budgets.budgetAnnotation": "(in $)",
    "budgets.updateInfo": "Please note that every update overwrites your existing budget and resets your free budget.",
    "budgets.popup.headline": "Delete budget?",
    "budgets.popup.text": "Budgets can’t be restored. Are you sure to delete this budget?",
    "budgets.popup.delete": "Delete budget",
    "budgets.placeholder.budget": "Type your value",
    "budgets.placeholder.startDate": "Select the start date",
    "budgets.toast.createBudget.success": "Budget created",
    "budgets.toast.createBudget.error": "Failed to create budget",
    "budgets.toast.editBudget.success": "Budget updated",
    "budgets.toast.editBudget.error": "Failed to update budget",
    "budgets.toast.deleteBudget.success": "Budget removed",
    "budgets.toast.deleteBudget.error": "Failed to remove budget",
    "offerPositions.orderPort": "Order port",
    "offerPositions.orderAndNextPort": "Order / next port",
    "offerPositions.nextPort": "Next port",
    "offerPositions.currentPosition": "Current position",
    "offerPositions.lastPort": "Last port",
    "offerPositions.deliveryDate": "Estimated delivery date {{date}}",
    "offerPositions.eta": "ETA {{date}}",
    "offerPositions.updated": "Updated {{counter}}",
    "confirmation.warning": "Leave site? Changes that you made may not be saved.",
    "attachments.noFiles": "No files attached",
    "attachments.uploadButton": "Upload File",
    "attachments.dropFiles": "Drop file here",
    "attachments.shared": "Shared",
    "attachments.internal": "Internal",
    "attachments.tooltip.shared.customer": "Visible to you and the supplier",
    "attachments.tooltip.shared.supplier": "Visible to you and the customer",
    "attachments.tooltip.internal": "Visible only to your company",
    "attachments.tooltip.internal.admin": "Internal files visible only to the company that uploaded them",
    "attachments.companyType.customer": "Customer",
    "attachments.companyType.supplier": "Supplier",
    "attachments.failedUpload": "Something went wrong, please try again",
    "attachments.uploadNote": "uploaded at {{date}}",
    "attachments.uploadNoteWithCompany": "uploaded at {{date}} - by {{company}}",
    "attachments.fileNameFallback": "File name unknown",
    "attachments.toast.invalidFilesError.invalidFileFormat": "The provided file format was not recognised as a document or an image.",
    "attachments.toast.invalidFilesError.invalidFileSize": "The provided file exceeds the size limit of 10 MB.",
    "attachments.toast.invalidFilesError.multipleFilesNotAllowed": "Uploading multiple files is not supported.",
    "attachments.toast.invalidFilesError.unknownError": "This file is not supported.",
    "attachments.popup.deleteAttachment.headline": "Delete file?",
    "attachments.popup.deleteAttachment.text": "If you remove the file from Closelink, some people will lose access to it. Are you sure you want to delete this item permanently?",
    "attachments.popup.deleteAttachment.delete": "Delete file",
    "personalDetails.title": "Personal details",
    "personalDetails.changePassword": "Change password",
    "personalDetails.edit": "Edit",
    "personalDetails.editTitle": "Edit personal details",
    "personalDetails.update": "Update personal details",
    "personalDetails.member.title": "Member",
    "personalDetails.member.name": "Name",
    "personalDetails.role.title": "Role",
    "demand.planning": "Planning",
    "demand.demandOverview": "Demand",
    "demand.daysLeft": "{{days}} days left",
    "demand.dayLeft": "1 day left",
    "demand.daysLeftTooltip": "Days left sailing:",
    "demand.warningLimit": "Warning limit",
    "demand.onSafetyReserve": "Safety reserve",
    "demand.outOfReach": "Out of reach",
    "demand.inReach": "In reach",
    "demand.outOfReachTooltip": "Not in reach",
    "demand.onSafetyReserveTooltip": "Safety reserve:",
    "demand.warningLimitTooltip": "Warning limit:",
    "demand.ordered": "Ordered",
    "demand.multiplePorts": "Multiple delivery ports",
    "demand.showOrder": "Show order",
    "demand.planned": "Planned",
    "demand.createEnquiry": "Create enquiry",
    "demand.shareDemandWithVessel": "Share demand with vessel",
    "demand.viewSchedule": "View full schedule",
    "demand.shareDemandWithVesselLoading": "Sharing demand with vessel",
    "demand.shareDemandWithVesselSuccess": "Demand shared with vessel",
    "demand.shareDemandWithVesselError": "Failed to share demand with vessel",
    "demand.select.daysLeftSailing": "Days left sailing",
    "demand.select.nextKeyPort": "Next key port call",
    "demand.vesselDetailsButton": "View details",
    "demand.table.product": "Product",
    "demand.table.currentRob": "ROB (current)",
    "demand.table.currentRobTooltip": "Latest data received: {{lastUpdate}}",
    "demand.table.today": "Today",
    "demand.table.yesterday": "Yesterday",
    "demand.table.safetyReserve": "Safety reserve",
    "demand.table.calculatedAverage": "Calculated average",
    "demand.table.fixedAverage": "Fixed average",
    "demand.table.dailyAverage": "Daily average",
    "demand.table.days": "Days",
    "demand.table.robAtKeyPort": "ROB at key port",
    "demand.table.port": "Delivery port",
    "demand.table.dailyAveragePopover.text": "Based on provided information.",
    "demand.table.dailyAveragePopover.btn": "Edit presets",
    "demand.table.daysPopover": "Days left sailing based on current ROB.",
    "demand.table.daysPopoverLubes": "Days left sailing based on current ROB and calculated or fixed average.",
    "demand.table.editPresets": "Edit presets",
    "demand.table.fixedAveragePopoverText": "Daily fixed average consumption is defined in the presets of the product category.",
    "demand.table.calculatedAveragePopoverText": "Daily average consumption was calculated based on the ROB reports for the previous 90 days.",
    "demand.table.basedOnCalculatedAverage": "Based on calculated average",
    "demand.table.basedOnFixedAverage": "Based on fixed average",
    "demand.vesselSchedule.nextPort": "Next port",
    "demand.vesselSchedule.lastPort": "Last port",
    "demand.vesselSchedule.currentPort": "Current port",
    "demand.vesselSchedule.nextKeyPortNotInReach": "Next key port call not in reach",
    "demand.vesselSchedule.nextKeyPortDays": "Next key port call in {{days}} days ({{date}})",
    "demand.vesselSchedule.nextKeyPortDay": "Next key port call in 1 day ({{date}})",
    "demand.vesselSchedule.nextPortNotInReachDays": "Last reachable port in {{days}} days ({{date}})",
    "demand.vesselSchedule.nextPortNotInReachDay": "Last reachable port in 1 day ({{date}})",
    "demand.vesselSchedule.portInDay": "{{port}} in 1 day",
    "demand.vesselSchedule.portInDays": "{{port}} in {{days}} days",
    "demand.vesselSchedule.portNotInReach": "{{port}} not in reach",
    "demand.vesselSchedule.nextPortNotInReach": "Next port not in reach",
    "demand.filter.vesselState.state": "Status",
    "demand.filter.vesselState.filterByState": "Filter by status",
    "demand.filter.vesselState.OPEN": "Open",
    "demand.filter.vesselState.PLANNED": "Planned",
    "demand.filter.vesselState.ORDERED": "Ordered",
    "demand.filter.vessel.vessel": "Vessel",
    "demand.filter.vessel.filterByVessel": "Filter by vessel",
    "demand.filter.vessel.searchForVessel": "Search for vessel",
    "demand.filter.company.company": "Company",
    "demand.filter.company.filterByCompany": "Filter by company",
    "demand.filter.reachStatus.reachStatus": "Reach",
    "demand.filter.reachStatus.filterByReachStatus": "Filter by reach",
    "demand.reachBanner.title": "Get your reach calculated",
    "demand.reachBanner.text": "Consumption data is required to receive an overview of the fleet sorted by days left sailing or next key port call. Each vessel is displayed with an enhanced schedule preview and reach details.",
    "demand.reachBanner.setupRequired": "Setup required",
    "demand.reachBanner.contactSupport": "Contact Support",
    "demand.groupSelectPlaceholder": "Select customer group",
    "demand.demandReport.title": "Download demand report",
    "demand.demandReport.dateRangeDescription": "Select the delivery date range for orders included in the report. The lift projection always runs through the end of the current year.",
    "demand.demandReport.dateRangeLabel": "Delivery date range",
    "demand.demandReport.companiesLabel": "Company",
    "demand.demandReport.companyDescription": "If no companies are selected, all companies in the group are included.",
    "demand.demandReport.allCompanies": "All companies",
    "demand.demandReport.download": "Download report",
    "demand.demandReport.error": "Failed to download report",
    "demand.emptyPageAdmin.title": "No customer selected",
    "demand.emptyPageAdmin.subtitle": "Please select a customer from the dropdown menu above.",
    "demandDefinition.demandDefinitions": "Demand definitions",
    "demandDefinition.demandDefinitionsDescription": "Define the fleet and product scope used to understand historical lubricant demand.",
    "demandDefinition.createDemandDefinition": "Create demand definition",
    "demandDefinition.editDemandDefinition": "Edit demand definition",
    "demandDefinition.edit": "Edit",
    "demandDefinition.name": "Name",
    "demandDefinition.nameDescription": "Use a name that makes this demand definition easy to identify.",
    "demandDefinition.annualLubricantDemand2026Placeholder": "Annual lubricant demand 2026",
    "demandDefinition.reference": "Reference",
    "demandDefinition.referencePlaceholder": "TND-2026-014",
    "demandDefinition.internalNotes": "Internal notes",
    "demandDefinition.notSharedWithSuppliersDescription": "Not shared with suppliers.",
    "demandDefinition.addNotesPlaceholder": "Add notes…",
    "demandDefinition.referencePeriod": "Reference period",
    "demandDefinition.referencePeriodLockedDescription": "The reference period cannot be changed while the demand definition uses static data. To change it, switch to dynamic data in the historical demand step.",
    "demandDefinition.selectHistoricalPeriodDescription": "Select the historical period from which historical liftings will be used to estimate demand.",
    "demandDefinition.dateRange": "Date range",
    "demandDefinition.last12Months": "Last 12 months",
    "demandDefinition.last24Months": "Last 24 months",
    "demandDefinition.lastCalendarYear": "Last calendar year",
    "demandDefinition.last2CalendarYears": "Last 2 calendar years",
    "demandDefinition.from": "From",
    "demandDefinition.to": "To",
    "demandDefinition.endDateMustBeOnOrAfterStartDate": "End date must be on or after start date",
    "demandDefinition.total": "Total",
    "demandDefinition.noDemandDefinitions": "No demand definitions yet",
    "demandDefinition.noDemandDefinitionsDescription": "Create a demand definition to review historical lubricant demand across your fleet.",
    "demandDefinition.selectCustomerGroup": "Select a customer group",
    "demandDefinition.customerGroup": "Customer group",
    "demandDefinition.selectCustomerGroupForDemandDefinitionDescription": "Select the customer group for this demand definition.",
    "demandDefinition.chooseCustomerGroupAboveToViewDemandDefinitionsDescription": "Choose a customer group above to view its demand definitions.",
    "demandDefinition.demandDefinition": "Demand definition",
    "demandDefinition.adjustDemand": "Adjust demand",
    "demandDefinition.general": "General",
    "demandDefinition.defineBaseline": "Define baseline",
    "demandDefinition.reviewBaseline": "Review baseline",
    "demandDefinition.forecastDemand": "Forecast demand",
    "demandDefinition.noForecastDemand": "No forecast demand",
    "demandDefinition.finalizeTenderDemand": "Finalize tender demand",
    "demandDefinition.reviewAndExport": "Review & export",
    "demandDefinition.exportToExcel": "Export to Excel",
    "demandDefinition.exportingToExcel": "Exporting demand",
    "demandDefinition.exportToExcelSuccess": "Demand exported",
    "demandDefinition.exportToExcelError": "Failed to export demand",
    "demandDefinition.summary": "Summary",
    "demandDefinition.details": "Details",
    "demandDefinition.addedVessels": "Added vessels",
    "demandDefinition.productChanges": "Product changes",
    "demandDefinition.demandAdjustments": "Demand adjustments",
    "demandDefinition.totalVolumes": "Total volumes",
    "demandDefinition.portAllocation": "Port allocation",
    "demandDefinition.createReusableDemandDefinitionDescription": "Create a reusable demand definition for estimating lubricant demand across one or more tenders.",
    "demandDefinition.fleetScope": "Fleet scope",
    "demandDefinition.selectCompaniesForDemandCalculationDescription": "Select the companies whose fleets should be included in the demand calculation.",
    "demandDefinition.productCategories": "Product categories",
    "demandDefinition.productCategoriesSelectionDescription": "Select the lubricant categories to include in the demand calculation.",
    "demandDefinition.selectReferencePeriod": "Select a reference period",
    "demandDefinition.selectReferencePeriodToLoadDataDescription": "Choose a reference period in General to load historical demand data.",
    "demandDefinition.chooseHowToCalculateDemandForVesselsWithIncompleteHistoricalData": "Choose how to calculate demand for vessels with incomplete historical data.",
    "demandDefinition.chooseWhetherToIncludeHistoricalDemandFromDeactivatedVessels": "Choose whether to include historical demand from deactivated vessels.",
    "demandDefinition.newlyAddedVessels": "Newly added vessels",
    "demandDefinition.deactivatedVessels": "Deactivated vessels",
    "demandDefinition.noNewlyAddedVesselsToReview": "No newly added vessels to review.",
    "demandDefinition.noMatchingVessels": "No matching vessels found.",
    "demandDefinition.clearSearch": "Clear search",
    "demandDefinition.expandAll": "Expand all",
    "demandDefinition.collapseAll": "Collapse all",
    "demandDefinition.noDeactivatedVesselsToReview": "No deactivated vessels to review.",
    "demandDefinition.addedOnDate": "Added {{date}}",
    "demandDefinition.deactivatedOnDate": "Deactivated {{date}}",
    "demandDefinition.historicalDataAvailableFromTo": "Historical data available for {{from}}–{{to}}",
    "demandDefinition.useRecordedDataOnly": "Use recorded data only",
    "demandDefinition.baseVolumesOnDifferentVessel": "Base volumes on different vessel",
    "demandDefinition.excludeFromDemand": "Exclude from demand",
    "demandDefinition.includeInDemand": "Include in demand",
    "demandDefinition.selectVesselToMirror": "Select a vessel to mirror…",
    "demandDefinition.reviewNewlyAddedVesselSelectionsBeforeSaving": "Review the newly added vessel selections before saving.",
    "demandDefinition.selectValidVesselToMirror": "Select another vessel with historical data in the selected fleet.",
    "demandDefinition.noVesselsWithHistoricalDataAvailable": "No vessels with historical data available",
    "demandDefinition.noFleetChangesToReview": "No fleet changes to review",
    "demandDefinition.fleetHasNoNewlyAddedOrDeactivatedVesselsToReview": "Your fleet has no newly added or deactivated vessels to review.",
    "demandDefinition.recalculating": "Recalculating…",
    "demandDefinition.viewDetails": "View details",
    "demandDefinition.excludedFromDemandRecorded": "Excluded from demand. Recorded volume: {{volume}} L.",
    "demandDefinition.resultingDemand": "Resulting demand",
    "demandDefinition.volumesBasedOnVesselName": "Volumes based on {{vesselName}}",
    "demandDefinition.volumesBasedOnRecordedData": "Volumes based on recorded data",
    "demandDefinition.includedCompanies": "Included companies",
    "demandDefinition.totalDemand": "Total demand",
    "demandDefinition.equivalentProducts": "Equivalent products",
    "demandDefinition.exactReferencePeriodDates": "Exact reference period dates",
    "demandDefinition.clickOnAProductCategoryAboveToSeeItsEquivalentProducts": "Click on a product category above to see its equivalent products.",
    "demandDefinition.historicalDemand": "Historical demand",
    "demandDefinition.historicalDemandReviewDescription": "Review the calculated historical demand based on your selected fleet, reference period, and product categories.",
    "demandDefinition.categories": "Categories",
    "demandDefinition.company": "Company",
    "demandDefinition.historicalVolumeLitres": "Historical volume (L)",
    "demandDefinition.historicalVolume": "Historical volume",
    "demandDefinition.hideDetails": "Hide details",
    "demandDefinition.showDetails": "Show details",
    "demandDefinition.selectedCategories": "Selected categories",
    "demandDefinition.selectedCompanies": "Selected companies",
    "demandDefinition.searchCompanies": "Search companies",
    "demandDefinition.selectAllCompanies": "Select all companies",
    "demandDefinition.unselectAllCompanies": "Unselect all companies",
    "demandDefinition.companiesShownOfTotal": "{{count}} of {{total}} companies",
    "demandDefinition.noMatchingCompanies": "No matching companies",
    "demandDefinition.liftingsCount": "{{count}} liftings",
    "demandDefinition.includedProducts": "Included products",
    "demandDefinition.showProductsInCategory": "Show products in {{category}}",
    "demandDefinition.hideProductsInCategory": "Hide products in {{category}}",
    "demandDefinition.selectedVolumeLitres": "Selected volume (L)",
    "demandDefinition.selectedVolume": "Selected volume",
    "demandDefinition.includedVessels": "Included vessels",
    "demandDefinition.historicalVolumeReferencePeriodDescription": "Historical lubricant order volume recorded during the selected reference period:",
    "demandDefinition.productCategory": "Product category",
    "demandDefinition.historical": "Historical",
    "demandDefinition.delta": "Delta",
    "demandDefinition.volume": "Volume",
    "demandDefinition.vessels": "Vessels",
    "demandDefinition.percentage": "%",
    "demandDefinition.volumeLitres": "Volume (L)",
    "demandDefinition.calculationFailed": "Historical demand could not be calculated",
    "demandDefinition.calculationFailedDescription": "Change the demand scope or try again.",
    "demandDefinition.calculationFailedTechnicalTitle": "Demand calculation failed",
    "demandDefinition.calculationFailedSaveableDescription": "We couldn't calculate demand. Save your work as a draft, or retry the calculation. Closing this flow will discard unsaved changes.",
    "demandDefinition.calculationFailedUnsavableDescription": "We couldn't calculate demand. This draft cannot be saved because some details are incomplete or invalid. Keep editing to fix them, retry the calculation, or close the flow. Closing will discard unsaved changes.",
    "demandDefinition.draftSaveFailedTitle": "Draft could not be saved",
    "demandDefinition.draftSaveFailedDescription": "We couldn't save your draft. Retry saving or contact support. Closing this flow will discard unsaved changes.",
    "demandDefinition.retrySavingDraft": "Retry saving draft",
    "demandDefinition.retryCalculation": "Retry calculation",
    "demandDefinition.noHistoricalDemand": "No historical demand",
    "demandDefinition.noHistoricalDemandDescription": "Select at least one lubricant category and vessel to calculate historical demand.",
    "demandDefinition.nextStep": "Next step",
    "demandDefinition.saveAsDraft": "Save as draft",
    "demandDefinition.draftSaved": "Draft saved",
    "demandDefinition.saveDemandDefinition": "Save demand definition",
    "demandDefinition.demandDefinitionSaved": "Demand definition saved",
    "demandDefinition.demandDefinitionCouldNotBeSaved": "Demand definition could not be saved",
    "demandDefinition.dataBasis": "Data basis",
    "demandDefinition.dataBasisDescription": "Choose whether the demand follows live data or stays fixed at a date.",
    "demandDefinition.dynamicData": "Dynamic",
    "demandDefinition.dynamicDataDescription": "Includes new orders and fleet changes as they come in.",
    "demandDefinition.staticData": "Static",
    "demandDefinition.staticDataDescription": "Uses the orders, companies, vessels and products as of a fixed date.",
    "demandDefinition.staticSince": "Static since {{date}}. New orders and fleet changes are no longer included. Switching back to dynamic data may change the volumes if orders, companies, vessels or products have changed in the meantime.",
    "demandDefinition.makingDataStatic": "Switching to static data",
    "demandDefinition.dataStatic": "Switched to static data",
    "demandDefinition.makingDataDynamic": "Switching to dynamic data",
    "demandDefinition.dataCouldNotBeMadeStatic": "Failed to switch to static data",
    "demandDefinition.dataDynamic": "Switched to dynamic data",
    "demandDefinition.dataCouldNotBeMadeDynamic": "Failed to switch to dynamic data",
    "demandDefinition.lastUpdated": "Last updated",
    "demandDefinition.cylinderOil": "Cylinder oil",
    "demandDefinition.twoStrokeSystemOil": "2-stroke system oil",
    "demandDefinition.fourStrokeEngineOil": "4-stroke engine oil",
    "demandDefinition.ancillaryOil": "Ancillary oil",
    "demandDefinition.grease": "Grease",
    "demandDefinition.blendOnBoardAdditives": "Blend-on-board additives",
    "demandDefinition.fleetChanges": "Fleet changes",
    "demandDefinition.fleetChangesDescription": "Plan for upcoming fleet changes that will affect demand during the tender period. Selected vessels are excluded for the entire tender period.",
    "demandDefinition.vesselsLeavingTheFleet": "Vessels leaving the fleet",
    "demandDefinition.selectVesselToRemove": "Select vessel to remove",
    "demandDefinition.excludedVolume": "Excluded volume",
    "demandDefinition.removeLeavingVesselName": "Remove {{vesselName}} from leaving vessels",
    "integrationSettings.title": "Integrations",
    "shareOrderPopup.title": "Share order",
    "shareOrderPopup.description": "A PDF without prices will be sent to all recipients in one email.",
    "shareOrderPopup.selectRecipients": "Send email to",
    "shareOrderPopup.sendToVessel": "Vessel",
    "shareOrderPopup.sendToCompany": "Company",
    "shareOrderPopup.sendToAgent": "Send to agent",
    "shareOrderPopup.sendToOthers": "Other recipients",
    "shareOrderPopup.copyToSelf": "Send me a copy",
    "shareOrderPopup.sendEmail": "Send email",
    "shareOrderPopup.emailAddress": "Email address",
    "shareOrderPopup.noMailAddressWarning": "To continue, you must provide a valid email address of the recipient vessel.",
    "shareOrderPopup.otherRecipients": "Other recipients",
    "shareOrderPopup.emailAddressError": "Please enter a valid email address.",
    "shareOrderPopup.othersEmailAddressError": "Enter at least one email address. Press Enter after each.",
    "shareOrderPopup.placeholder.emailAddress": "email@example.com",
    "shareOrderPopup.placeholder.otherRecipients": "Enter an email address and press \"Enter\".",
    "shareOrderPopup.successToast": "The order has been shared.",
    "integrationsOverview.headline": "Integrations",
    "integrationsOverview.calloutGlsm.headline": "Only working for GLSM (Maersk) orders",
    "integrationsOverview.calloutGlsm.description": "Please be aware that this only works for GLSM (Maersk). After triggering one of the actions, please have a look into the #integration-monitoring channel for a few minutes. On this page, there will be no feedback whether actions were successful.",
    "integrationsOverview.calloutMariApps.headline": "Only working for MariApps (Maersk) orders",
    "integrationsOverview.calloutMariApps.description": "Please be aware that this only works for MariApps (Maersk). After triggering one of the actions, please have a look into the #integration-monitoring channel for a few minutes.",
    "integrationsOverview.calloutOnePort.headline": "Only working for OnePort orders",
    "integrationsOverview.calloutOnePort.description": "Please be aware that this only works for OnePort. After triggering one of the actions, please have a look into the #integration-monitoring channel for a few minutes.",
    "integrationsOverview.calloutCloudFleetManager.headline": "Only working for Cloud Fleet Manager orders",
    "integrationsOverview.calloutCloudFleetManager.description": "Please be aware that this only works for Cloud Fleet Manager. After triggering one of the actions, please have a look into the #integration-monitoring channel for a few minutes.",
    "integrationsOverview.calloutBassNet.headline": "Only working for BASSnet orders",
    "integrationsOverview.calloutBassNet.description": "Please be aware that this only works for BASSnet. After triggering one of the actions, please have a look into the #integration-monitoring channel for a few minutes.",
    "integrationsOverview.datePicker": "Start date",
    "integrationsOverview.exportTitle": "Export order",
    "integrationsOverview.exportDescription": "If it has been exported before, it triggers a full rebuild.",
    "integrationsOverview.importTitle": "Import requisition",
    "integrationsOverview.selectLabel": "Order",
    "integrationsOverview.confirmTitle": "Confirm order",
    "integrationsOverview.exportButtonText": "Export order",
    "integrationsOverview.confirmButtonText": "Confirm order",
    "integrationsOverview.importButtonText": "Import requisition",
    "integrationsOverview.exportTriggered": "Successfully triggered export",
    "integrationsOverview.confirmTriggered": "Successfully triggered confirmation",
    "integrationsOverview.importTriggered": "Successfully triggered import",
    "integrationsOverview.orderOption": "{{vesselName}} at {{portName}} for {{companyName}}",
    "integrationsOverview.orderOptionWithoutPort": "{{vesselName}} for {{companyName}}",
    "integrationsOverview.createQuote": "Create quote",
    "integrationsOverview.createOrder": "Create order",
    "integrationsOverview.rebuildMapping": "Rebuild mapping",
    "integrationsOverview.code": "Code",
    "integrationsOverview.unknownError": "Code",
    "integrationsOverview.quoteSuccessToast": "Successfully quoted",
    "integrationsOverview.orderSuccessToast": "Order successfully created in OnePort",
    "integrationsOverview.mappingSuccessToast": "Mapping successfully rebuilt",
    "integrationsOverview.quotationDocumentSuccessToast": "Quotation document successfully created",
    "integrationsOverview.orderConfirmationDocumentSuccessToast": "Order confirmation document successfully created",
    "integrationsOverview.confirmedOrderNumberLabel": "Confirmed order number",
    "integrationsOverview.productCatalogue.title": "Chevron product catalogue",
    "integrationsOverview.productCatalogue.metadata": "Last updated {{updatedAt}} · {{productCount}} products",
    "integrationsOverview.productCatalogue.productId": "Product ID",
    "integrationsOverview.productCatalogue.productName": "Product name",
    "integrationsOverview.productCatalogue.mpId": "Marine product ID",
    "integrationsOverview.productCatalogue.mpName": "Marine product name",
    "integrationsOverview.productCatalogue.filterByProductId": "Filter by product ID",
    "integrationsOverview.productCatalogue.filterByProductName": "Filter by product name",
    "integrationsOverview.productCatalogue.filterByMpId": "Filter by marine product ID",
    "integrationsOverview.productCatalogue.filterByMpName": "Filter by marine product name",
    "integrationsOverview.productCatalogue.noResults": "No products match the selected filters.",
    "integrationsOverview.productCatalogue.missing.title": "No product catalogue available",
    "integrationsOverview.productCatalogue.missing.description": "No product catalogue snapshot is available yet.",
    "integrationsOverview.productCatalogue.error.title": "Could not load the product catalogue",
    "integrationsOverview.productCatalogue.error.description": "Please try again later.",
    "integrationsOverview.reimportRequisition": "Reimport requisition",
    "integrationsOverview.reimportRequisitionSelectLabel": "Select draft enquiry",
    "integrationsOverview.reimportRequisitionSubtitle": "Triggering a reimport initiates a complete reimport from Cloud Fleet Manager for draft enquiries. The current enquiry will be deleted and a new draft enquiry will be imported from Cloud Fleet Manager. This can be used if the requisition has changed in Cloud Fleet Manager after the first import.",
    "integrationsOverview.bassNetQuotationDocumentHeadline": "Create quotation document",
    "integrationsOverview.bassNetOrderConfirmationDocumentHeadline": "Create order confirmation document",
    "integrationsOverview.createDocumentButton": "Create document",
    "integrationsOverview.placePurchaseOrderTitle": "Place purchase order",
    "integrationsOverview.placePurchaseOrderButton": "Place purchase order",
    "integrationsOverview.placePurchaseOrderTriggered": "Successfully triggered purchase order placement",
    "integrationsOverview.linkPurchaseOrderTitle": "Link purchase order",
    "integrationsOverview.linkPurchaseOrderDescription": "Use this when the customer confirmed that a PO exists in MariApps but Closelink did not link it; the entered PO number will be linked to the selected offer and mark the failed delayed PO-create flow as resolved.",
    "integrationsOverview.linkPurchaseOrderOfferLabel": "Offer",
    "integrationsOverview.linkPurchaseOrderPoNumberLabel": "PO number",
    "integrationsOverview.linkPurchaseOrderButton": "Link purchase order",
    "integrationsOverview.linkPurchaseOrderUnknownError": "The purchase order could not be linked. Please try again.",
    "integrationsOverview.skipMariAppsVesselValidationLabel": "Skip MariApps vessel validation",
    "integrationsOverview.skipMariAppsVesselValidationDescription": "Use this manual override to export the purchase order to GLSM even when the vessel is configured for MariApps. This is usually needed for older orders that originally ran through GLSM before the vessel was migrated to MariApps. This only affects the manual purchase order export.",
    "integrationsOverview.updatePurchaseOrderTitle": "Update purchase order",
    "integrationsOverview.updatePurchaseOrderButton": "Update purchase order",
    "integrationsOverview.updatePurchaseOrderTriggered": "Successfully triggered purchase order update",
    "integrationsOverview.importRequisitionTitle": "Import requisition",
    "integrationsOverview.groupLabel": "Group",
    "integrationsOverview.requisitionNumberLabel": "Requisition number",
    "integrationsOverview.importRequisitionButton": "Import requisition",
    "integrationsOverview.importRequisitionTriggered": "Successfully triggered requisition import",
    "integrationsOverview.cancelRequisitionTitle": "Cancel requisition",
    "integrationsOverview.userLabel": "User",
    "integrationsOverview.dateCanceledLabel": "Date canceled",
    "integrationsOverview.cancelRequisitionButton": "Cancel requisition",
    "integrationsOverview.cancelRequisitionTriggered": "Successfully triggered requisition cancellation",
    "integrationsOverview.failedRequisitionsTitle": "Failed requisition imports",
    "integrationsOverview.noFailedRequisitions": "No failed requisition imports",
    "integrationsOverview.failureReasonLabel": "Failure Reason",
    "integrationsOverview.errorMessageLabel": "Error Message",
    "integrationsOverview.retryCountLabel": "Retry Count",
    "integrationsOverview.actionsLabel": "Actions",
    "integrationsOverview.retryButton": "Retry",
    "integrationsOverview.retryButtonTooltip": "Trigger a manual re-import of this requisition using the existing import endpoint. If successful, this record will be automatically deleted.",
    "integrationsOverview.markNonRetryableButton": "Mark Non-Retryable",
    "integrationsOverview.markNonRetryableButtonTooltip": "Mark this requisition as non-retryable to prevent any future automatic import attempts. The record will remain in the list for reference.",
    "integrationsOverview.deleteButton": "Delete",
    "integrationsOverview.deleteButtonTooltip": "Permanently delete this failed requisition record from the system. Note: The import will likely be retried on the next task run after deletion unless the requisition has been deleted in MariApps itself.",
    "integrationsOverview.retryTriggered": "Successfully triggered retry for requisition import",
    "integrationsOverview.failedRequisitionDeleted": "Failed requisition deleted",
    "integrationsOverview.failedRequisitionMarkedNonRetryable": "Failed requisition marked as non-retryable",
    "productsOverview.headline": "Products",
    "productsOverview.create": "Create product",
    "productsOverview.searchPlaceholder": "Search for product",
    "productsOverview.labels.name": "Name",
    "productsOverview.labels.supplier": "Supplier",
    "productsOverview.labels.group": "Group",
    "productsOverview.labels.packType": "Pack type",
    "productsOverview.labels.unitDefault": "Unit default",
    "productsOverview.labels.publicId": "Public ID",
    "productsOverview.labels.internalId": "Internal ID: {{internalId}}",
    "productsOverview.labels.state": "State",
    "productsOverview.labels.archived": "Archived",
    "productsOverview.labels.active": "Active",
    "productsOverview.labels.dateCreated": "Created",
    "productsOverview.labels.lastEdit": "Last edited",
    "productsOverview.labels.successor": "Successor product",
    "productsOverview.createDrawerTitle": "Create product",
    "productsOverview.createProduct": "Create product",
    "productsOverview.editProduct": "Edit product",
    "productsOverview.updateProduct": "Update product",
    "productsOverview.createSuccessToast": "Product created",
    "productsOverview.createErrorToast": "Failed to create product",
    "productsOverview.updateSuccessToast": "Product updated",
    "productsOverview.updateErrorToast": "Failed to update product",
    "productsOverview.archiveSuccessToast": "Product archived",
    "productsOverview.archiveErrorToast": "Failed to archive product",
    "productsOverview.archiveConfirmPrompt": "Are you sure you want to archive this product?",
    "productsOverview.archiveTooltip": "Archive",
    "productsOverview.restoreSuccessToast": "Product restored",
    "productsOverview.restoreErrorToast": "Failed to restore product",
    "productsOverview.restoreConfirmPrompt": "Are you sure you want to restore this product?",
    "productsOverview.restoreTooltip": "Restore",
    "productsOverview.formErrors.name": "Name is required",
    "productsOverview.formErrors.supplier": "Supplier is required",
    "productsOverview.formErrors.group": "Group is required",
    "productsOverview.formErrors.packType": "Pack type is required",
    "productsOverview.formErrors.unitDefault": "Unit default is required",
    "productsOverview.equivalents.title": "Equivalents",
    "productsOverview.equivalents.description": "Link comparable products across suppliers. Closelink automatically matches the equivalent supplier-specific product when a customer selects another brand.",
    "productsOverview.equivalents.manage": "Manage equivalents",
    "productsOverview.equivalents.drawerTitle": "Manage equivalents",
    "productsOverview.equivalents.save": "Save equivalents",
    "productsOverview.equivalents.newEquivalent": "New equivalent",
    "productsOverview.equivalents.addEquivalent": "Add equivalent",
    "productsOverview.equivalents.supplierGroupPlaceholder": "Select a supplier product group...",
    "productsOverview.equivalents.productPlaceholder": "Select a product...",
    "productsOverview.equivalents.linkBidirectional": "Link bidirectional",
    "productsOverview.equivalents.successToast": "Equivalents updated",
    "productsOverview.equivalents.errorToast": "Failed to update equivalents",
    "productsOverview.equivalents.conflictToast": "Product is already linked",
    "productsOverview.equivalents.conflictCalloutHeading": "Link conflict",
    "productsOverview.equivalents.conflictCalloutDescription": "{{refProduct}} is already linked to {{existingProduct}} for {{supplierGroup}} — remove that link first to continue.",
    "productsOverview.filters.supplier": "Supplier",
    "productsOverview.filters.filterBySupplier": "Filter by supplier",
    "devTools.featureFlags.headline": "Feature flags",
    "devTools.featureFlags.description": "Override feature flags to test different configurations.",
    "devTools.featureFlags.empty": "No feature flags available",
    "devTools.featureFlags.save": "Save",
    "devTools.featureFlags.reset": "Reset overrides",
    "devTools.featureFlags.overrideSelectLabel": "{{name}} (LD value: {{launchDarklyValue}})",
    "devTools.shortcuts.headline": "Shortcuts",
    "devTools.shortcuts.throwError": "Throw error",
    "devTools.devFlags.headline": "Developer flags",
    "devTools.devFlags.formikDebugTools.description": "Display Formik state and validation errors beneath supported forms.",
    "devTools.devFlags.avgConsumptionConfigControls.label": "Avg. consumption config controls",
    "devTools.devFlags.avgConsumptionConfigControls.description": "Show controls for overriding the number of data points under the average consumption graphs.",
    "devTools.tanStackDevtools.headline": "Tanstack developer tools",
    "devTools.tanStackDevtools.reactQuery": "React query",
    "devTools.tanStackDevtools.router": "Router",
    "devTools.title": "Developer tools",
    "devTools.devFlags.formikDebugTools.label": "Formik debug tools",
    "devTools.featureFlags.override": "Override",
    "devTools.featureFlags.launchDarkly": "LaunchDarkly",
    "devTools.featureFlags.launchDarklyWithValue": "LaunchDarkly ({{value}})",
    "devTools.featureFlags.true": "True",
    "devTools.featureFlags.false": "False",
    "devTools.formikDebug.values": "Values",
    "devTools.formikDebug.errors": "Errors",
    "consumption.editPresets.title": "Edit presets",
    "consumption.editPresets.description": "Add, edit, and delete product categories and their presets.",
    "consumption.editPresets.category": "Category",
    "consumption.editPresets.inTank": "In tank",
    "consumption.editPresets.tankPrefillNotice": "Presets are automatically added based on the vessel’s tanks. Complete and save to enable calculation of consumption and reach.",
    "consumption.editPresets.categoryPlaceholder": "Category",
    "consumption.editPresets.addCategory": "Add another preset",
    "consumption.editPresets.excluded": "Excluded",
    "consumption.editPresets.calculationBase.STATIC": "Static",
    "consumption.editPresets.calculationBase.DYNAMIC": "Dynamic",
    "consumption.editPresets.fixedDailyAverageConsumption": "Fixed daily average consumption",
    "consumption.editPresets.excludePortCalls.label": "Category not used in ports",
    "consumption.editPresets.excludePortCalls.description": "If selected, the days spent in port are excluded from the calculation in order to prevent any distortion of the results",
    "consumption.editPresets.consumptionCalculationBase.label": "Reach calculation",
    "consumption.editPresets.consumptionCalculationBase.DYNAMIC.label": "Dynamic",
    "consumption.editPresets.consumptionCalculationBase.DYNAMIC.description": "based on calculated daily average consumption",
    "consumption.editPresets.consumptionCalculationBase.STATIC.label": "Static",
    "consumption.editPresets.consumptionCalculationBase.STATIC.description": "based on fixed daily average consumption",
    "consumption.editPresets.validation.category.required": "Please select a category.",
    "consumption.editPresets.validation.category.duplicate": "This category is already used by another preset.",
    "consumption.editPresets.validation.fixed.required": "Please enter a value for static reach calculation.",
    "consumption.editPresets.validation.consumptionCalculationBase.required": "Consumption calculation base is required.",
    "consumption.editPresets.presetsUpdateSuccessToast": "Successfully saved presets.",
    "consumption.editPresets.presetsUpdateErrorToast": "Failed to save presets.",
    "shortcutMenu.offer": "Offer",
    "shortcutMenu.order": "Order",
    "shortcutMenu.vessel": "Vessel",
    "shortcutMenu.customer": "Customer",
    "shortcutMenu.supplier": "Supplier",
    "shortcutMenu.agent": "Agent",
    "shortcutMenu.port": "Port",
    "shortcutMenu.user": "Member",
    "shortcutMenu.product": "Product",
    "shortcutMenu.logout": "Log out",
    "shortcutMenu.dashboard": "Go to dashboard",
    "shortcutMenu.searchPlaceholder": "Type to search",
    "shortcutMenu.actions": "Actions",
    "shortcutMenu.contextActions": "Context actions",
    "shortcutMenu.changeGroupContext": "Change group context",
    "shortcutMenu.navigateTo": "Go to",
    "shortcutMenu.create": "Create",
    "shortcutMenu.customerGroup": "Customer group",
    "shortcutMenu.supplierGroup": "Supplier group",
    "shortcutMenu.assignment": "Assignment",
    "shortcutMenu.keyPort": "Key port",
    "shortcutMenu.createEnquiry": "Create enquiry",
    "shortcutMenu.openSettings": "Open settings",
    "shortcutMenu.showSidebar": "Show sidebar",
    "shortcutMenu.collapseSidebar": "Collapse sidebar",
    "shortcutMenu.searchInOrders": "Search \"{{query}}\" in orders",
    "shortcutMenu.searchInOrdersAndOffers": "Search \"{{query}}\" in orders and offers",
    "shortcutMenu.searchInEnquiries": "Search \"{{query}}\" in enquiries",
    "shortcutMenu.context": "Context",
    "shortcutMenu.removeContext": "Remove context",
    "shortcutMenu.selectGroup": "Select group",
    "shortcutMenu.error.title": "Something went wrong",
    "shortcutMenu.error.description": "Please try again",
    "shortcutMenu.invalidState.title": "Shortcut menu is out of sync",
    "shortcutMenu.invalidState.description": "Close and reopen it with Cmd/Ctrl + K.",
    "shortcutMenu.navigation": "Navigation",
    "shortcutMenu.open": "Open",
    "shortcutMenu.groups": "Groups",
    "shortcutMenu.companies": "Companies",
    "shortcutMenu.toReturn": "to return",
    "shortcutMenu.toClear": "to clear",
    "shortcutMenu.toNaviagte": "to navigate",
    "shortcutMenu.toSelect": "to select",
    "shortcutMenu.toClose": "to close",
    "shortcutMenu.or": "or",
    "shortcutMenu.darkMode": "Switch to dark mode",
    "shortcutMenu.lightMode": "Switch to light mode",
    "creationComment.headline": "Imported information",
    "creationComment.showLess": "Show less",
    "creationComment.showMore": "Show more",
    "errorView.title": "Something isn't stacking up.",
    "errorView.description": "We've had a little hiccup. We're on it! In the meantime, try reloading the page. If you need further assistance, please contact our support team.",
    "errorView.errorMessage": "Error message",
    "errorView.reloadPage": "Reload page",
    "errorView.getHelp": "Get help from support",
    "errorView.copy": "Copy",
    "copyToClipboard.error": "Failed to copy",
    "copyToClipboard.success": "Copied to clipboard",
    "webhooks.title": "Webhooks",
    "webhooks.description": "Webhooks let you receive real-time updates when certain events happen in Closelink. Add your own endpoint to get notified automatically and keep your systems in sync. For more information, feel free to [contact us].",
    "webhooks.destination": "Destination",
    "webhooks.events": "Events",
    "webhooks.companies": "Companies",
    "webhooks.signingSecret": "Signing secret",
    "webhooks.status": "Status",
    "webhooks.status.active": "Active",
    "webhooks.status.disabled": "Disabled",
    "webhooks.emptyState.title": "Subscribe to Closelink events",
    "webhooks.emptyState.description": "Add a webhook endpoint to receive real-time updates from your Closelink account and trigger actions in your integration.",
    "webhooks.addDestination": "Add destination",
    "webhooks.selectEvents.title": "Select which events you want to listen to",
    "webhooks.selectEvents.description": "Closelink will send these events to your destination.",
    "webhooks.selectEvents.allEvents": "Select all events",
    "webhooks.selectEvents.allEvents.popover": "Your endpoint will listen for all event that currently exist, but will not automatically listen for new event groups added in the future.",
    "webhooks.selectEvents.eventGroups": "Event groups",
    "webhooks.selectEvents.draftEnquiry.title": "Draft enquiries",
    "webhooks.selectEvents.draftEnquiry.description": "Receive events when a new enquiry draft is created or updated.",
    "webhooks.selectEvents.enquiry.title": "Enquiries",
    "webhooks.selectEvents.enquiry.description": "Receive events when an enquiry is submitted, updated, or deleted.",
    "webhooks.selectEvents.offer.title": "Offers",
    "webhooks.selectEvents.offer.description": "Receive events when a supplier submits or updates an offer.",
    "webhooks.selectEvents.approvalRequest.title": "Approval requests",
    "webhooks.selectEvents.approvalRequest.description": "Receive events when an approval request is created or updated.",
    "webhooks.decideTrigger.title": "Decide which companies trigger events",
    "webhooks.decideTrigger.description": "Receive events only from selected companies. Update your selection anytime to change which events are sent to your webhook.",
    "webhooks.configureDestination.title": "Configure your destination",
    "webhooks.configureDestination.description": "Enter the destination URL for your webhook and provide a concise name to keep things organized.",
    "webhooks.configureDestination.destinationName": "Destination name",
    "webhooks.configureDestination.endpointUrl": "Endpoint URL",
    "webhooks.configureDestination.endpointUrlCaption": "Webhooks require a URL to send events to.",
    "webhooks.configureDestination.httpsUrl": "https://",
    "webhooks.validation.destinationNameRequired": "Please provide a destination name",
    "webhooks.validation.endpointUrlRequired": "Please provide a URL.",
    "webhooks.validation.endpointUrlInvalid": "Please provide a valid HTTPS URL for your destination",
    "webhooks.signingSecret.title": "Your signing secret",
    "webhooks.signingSecret.description": "Use this secret to verify that events come from Closelink. You can always view it in the webhooks section within your company settings.",
    "webhooks.creationError": "Failed to create signing secret, please try again",
    "webhooks.edit": "Edit",
    "webhooks.enable": "Enable",
    "webhooks.disable": "Disable",
    "webhooks.delete": "Delete",
    "webhooks.deleteConfirmPopup.deleteDestination": "Delete destination",
    "webhooks.deleteConfirmPopup.text": "Events will no longer be sent to this destination.",
    "webhooks.disableConfirmPopup.disableDestination": "Disable destination",
    "webhooks.disableConfirmPopup.text": "Events will no longer be sent to this destination, but you'll still be able to make edits to it.",
    "webhooks.edit.title": "Edit destination",
    "webhooks.edit.save": "Save destination",
    "webhooks.editSuccess": "Webhook destination updated successfully",
    "webhooks.editError": "Failed to update webhook destination",
    "authentication.error.message": "This might be due to an expired session, network issues, or a temporary service problem. Please try signing in again.",
    "authentication.error.headline": "We couldn't authenticate your session.",
    "authentication.error.button": "Go to sign in",
    "authentication.inactiveUser.headline": "Account not active",
    "authentication.inactiveUser.message": "This account is currently not active. Please contact your account owner or reach out to our support for assistance.",
    "authentication.inactiveUser.signInAgain": "Once it’s activated again, you’ll need to sign in.",
    "authentication.inactiveUser.contactSupport": "Contact support",
    "authentication.inactiveUser.backToSignIn": "Back to sign in",
    "settings.title": "Settings",
    "settings.personalSettings.title": "Personal settings",
    "settings.personalDetails.title": "Personal details",
    "settings.personalDetails.description": "Manage profile, communication preferences, and two-step authentication.",
    "settings.accountSettings.title": "Account settings",
    "settings.groupSettings.title": "Group settings",
    "settings.groupManagement.title": "Group management",
    "settings.groupManagement.description": "Manage group information, companies, and security policies.",
    "settings.members.title": "Members",
    "settings.members.description": "Manage members, set roles, and access.",
    "settings.developers.title": "Developers",
    "settings.developers.customers.description": "Manage API keys and webhooks.",
    "settings.developers.suppliers.description": "Manage API keys.",
    "settings.companyManagement.title": "Company management",
    "settings.companyManagement.description": "View and manage your companies.",
    "developers.title": "Developers",
    "developers.description": "Set up and manage your API keys and webhooks to connect your system with ours.",
    "developers.tooltip.manageDeveloperSettings": "Manage developer settings",
    "members.searchMembersPlaceholder": "Search members",
    "members": "Members",
    "members.title": "Members",
    "members.filters.allMembers": "All",
    "members.filters.filterByRole": "Filter by role",
    "members.filters.filterByName": "Filter by name",
    "members.filters.filterByEmail": "Filter by email",
    "members.results": "results",
    "members.addMembers.title": "Invite members",
    "members.addMembers.description": "Invite people to join this group. They'll get access to the roles and permissions assigned here.",
    "members.noResults.title": "No results found",
    "members.noResults.description": "There aren't any results for that query. Try using different filters.",
    "closelinkInsights.title": "Closelink insights",
    "closelinkInsights.reviewDraft": "Review draft",
    "closelinkInsights.tryAgain": "Try again",
    "closelinkInsights.gatheringInformation": "Collecting system information",
    "closelinkInsights.gatheringInformation.description": "The system collects tank refill thresholds, scheduled port calls of the vessel and category prices.",
    "closelinkInsights.reviewingOptions": "Reviewing options",
    "closelinkInsights.reviewingOptions.description": "Our AI analyzes all available ports and matches them against your vessel's requirements and constraints.",
    "closelinkInsights.generatingRecommendation": "Generating your recommendation",
    "closelinkInsights.reviewInProgress": "Review in progress",
    "closelinkInsights.noSuitablePort": "Unfortunately, no suitable port for delivery was found.",
    "closelinkInsights.noSuitablePort.description": "AI failed to process port suggestion",
    "closelinkInsights.sendEnquiry": "Send enquiry",
    "closelinkInsights.saveDraft": "Save draft",
    "closelinkInsights.supplierSelection": "Supplier selection",
    "closelinkInsights.supplierSelection.defaultSupplierOnly": "Default supplier only",
    "closelinkInsights.reviewOffers": "Review offers",
    "closelinkInsights.reviewOffer": "Review offer",
    "closelinkInsights.reviewComplete": "Review complete",
    "closelinkInsights.noSuitableOffer": "Unfortunately, no suitable offer was found.",
    "closelinkInsights.noSuitableOffer.description": "AI failed to process offer suggestion",
    "closelinkInsights.offerReview.title": "Offer review",
    "closelinkInsights.offerReview.qualifiedApprovers": "Qualified approvers",
    "closelinkInsights.offerReview.selectApprovers": "Select the approvers who should review the recommended offer.",
    "closelinkInsights.offerReview.requestApproval": "Request approval",
    "closelinkInsights.offerReview.approvalRequestSent": "Approval request sent successfully",
    "closelinkInsights.offerReview.approvalRequestError": "Failed to send approval request",
    "closelinkInsights.offerReview.gatheringInformation": "Collecting offer information",
    "closelinkInsights.offerReview.gatheringInformation.description": "The system collects offer details, pricing, and supplier information.",
    "closelinkInsights.offerReview.reviewingOffers": "Analyzing offers",
    "closelinkInsights.offerReview.reviewingOffers.description": "Our AI analyzes all available offers and compares them against your requirements.",
    "closelinkInsights.offerReview.generatingRecommendation": "Generating recommendation",
    "closelinkInsights.supplierSelection.allContractedSuppliers": "All contracted suppliers",
    "closelinkInsights.supplierSelection.allSuppliersInclSpot": "All suppliers (incl. spot market)",
    "notFound.errorCode": "Error number 404 - Page not found",
    "notFound.title": "Hold steady, sailor,\nlooks like you've run aground!",
    "notFound.description": "This page couldn’t be found. It may have been moved, deleted, or never existed.",
    "notFound.goToDashboard": "Go to dashboard",
    "notFound.contactSupport": "Contact support",
    "resourceNotFound.errorCode": "Error number 404 - Resource not found",
    "resourceNotFound.title": "No luck, sailor.\nScoured from bow to stern,\nbut nothing here.",
    "resourceNotFound.description": "The resource you’re trying to access couldn’t be found.\nIt may have been removed or never existed.",
    "resourceNotFound.goToDashboard": "Go to dashboard",
    "resourceNotFound.contactSupport": "Contact support",
    "forbidden.errorCode": "Error number 403 - Forbidden",
    "forbidden.title": "Access denied, sailor!\nYou've entered restricted waters.",
    "forbidden.description": "This page isn't available to your account.\nIf you believe you should have access, contact your admin.",
    "rfq.detail.headline": "Enquiry",
    "rfq.detail.offer": "Offer",
    "rfq.detail.offers": "Offers",
    "rfq.detail.additionalOfferUnavailableForCustomer": "Additional quotes are not available for this enquiry.",
    "rfq.detail.additionalOfferUnavailableToast": "Additional quotes are not available for this enquiry.",
    "rfq.detail.noQuotes.title": "No quotes yet",
    "rfq.detail.noQuotes.description": "When you create your quote, it will appear here.",
    "rfq.detail.noQuotes.multipleOffersDescription": "When you add quotes to this enquiry, they will appear here.",
    "rfq.detail.offerCard.quoteDeclined": "Declined - competitor chosen",
    "rfq.detail.competitorSelected.heading": "Competitor selected",
    "rfq.detail.competitorSelected.description": "The customer selected an offer from another supplier.",
    "rfq.detail.competitorSelectedBeforeQuote.description": "The customer selected an offer from another supplier before your quote was submitted.",
    "rfq.detail.enquiryCanceled.heading": "Enquiry canceled",
    "rfq.detail.enquiryCanceled.description": "The customer canceled this enquiry before a supplier was selected.",
    "rfq.detail.orderAwaitingConfirmation.heading": "Order awaiting confirmation",
    "rfq.detail.orderAwaitingConfirmation.description": "The customer selected your offer and created an order. Open the order to acknowledge receipt or confirm processing.",
    "rfq.detail.canceledOffer.heading": "Enquiry canceled",
    "rfq.detail.canceledOffer.description": "The customer canceled this enquiry and your offer was not selected.",
    "rfq.detail.offerCard.spotQuoteDeclined": "Not selected",
    "rfq.detail.offerCard.quoteCanceled": "Offer canceled",
    "rfq.detail.offerCard.enquiryDeclined": "Enquiry declined",
    "rfq.detail.offerCard.canceled": "Canceled",
    "rfq.detail.offerCard.enquiryCanceled": "Request canceled",
    "rfq.detail.offerCard.enquiryExpired": "Enquiry closed",
    "rfq.detail.offerCard.spotEnquiryExpired": "Enquiry expired",
    "rfq.detail.showOrder": "Show order",
    "rfq.detail.updateQuote": "Update quote",
    "rfq.detail.edit": "Edit",
    "rfq.detail.offerCard.supplyMode": "Supply mode",
    "rfq.detail.offerCard.vendorReference": "Vendor reference",
    "rfq.detail.offerCard.noticeDays": "Notice days",
    "rfq.detail.declineReasonShownToTheCustomer": "Decline reason shown to the customer",
    "rfq.detail.cancelPopup.cancelAllOffers.headline": "Cancel all offers?",
    "rfq.detail.cancelPopup.cancelAllOffers.description": "You have to state a reason for the cancellation. The reason will also be displayed to the customer.",
    "rfq.detail.cancelPopup.cancelAllOffers.optionalReasonDescription": "You can provide a reason for the cancellation. This reason will also be shown to the customer.",
    "rfq.detail.cancelPopup.cancelAllOffers.button": "Cancel all offers",
    "rfq.detail.viewOffer": "View offer",
    "rfq.detail.actions.export.pdf": "Download enquiry as PDF",
    "anonymousQuotation.createOffer": "Create offer",
    "anonymousQuotation.updateOffer": "Update offer",
    "anonymousQuotation.order": "Order",
    "anonymousQuotation.cancelOffer": "Decline enquiry",
    "anonymousQuotation.invalidAccessToken": "Access denied",
    "anonymousQuotation.accessToQuotationIsInvalidOrExpired": "Unfortunately your access is invalid or expired.",
    "anonymousQuotation.offerStatus.enquirycanceled.label": "Enquiry canceled",
    "anonymousQuotation.offerStatus.enquirycanceled.subtitle": "The enquiry was canceled by the customer.",
    "anonymousQuotation.offerStatus.qoutedeclined.label": "Enquiry closed",
    "anonymousQuotation.offerStatus.qoutedeclined.subtitle": "Unfortunately your offer was not selected by the customer.",
    "anonymousQuotation.offerStatus.enquiryexpired.label": "Enquiry closed",
    "anonymousQuotation.offerStatus.enquiryexpired.subtitle": "You cannot place an offer anymore.",
    "anonymousQuotation.offerStatus.quoted.label": "Offer created",
    "anonymousQuotation.offerStatus.quoted.subtitle": "The customer has received your offer. You can still update the offer or decline the enquiry below.",
    "anonymousQuotation.offerStatus.offerDeclined.label": "Enquiry declined",
    "anonymousQuotation.offerStatus.offerDeclined.subtitle": "The enquiry was declined.",
    "anonymousQuotation.offerStatus.ordered.label": "Offer chosen",
    "anonymousQuotation.offerStatus.ordered.subtitle": "The customer accepted your offer and you received an email with further details.",
    "anonymousQuotation.offerStatus.enquiry.label": "Create offer",
    "anonymousQuotation.offerStatus.enquiry.subtitle": "Please fill in all required fields and add your optional vendor reference.",
    "anonymousQuotation.offerCreated": "Offer created",
    "anonymousQuotation.failedToUpdateOffer": "Failed to update the offer",
    "anonymousQuotation.offerSuccessfullyUpdated": "Offer updated",
    "anonymousQuotation.createOrUpdateAgreesWithTerms": "By creating or updating an offer you agree to the <a href=\"//www.closelink.com/gtc-supplier\"target=\"_blank\"rel=\"noreferrer\">terms & conditions</a> for using the Closelink platform solution for vendors.",
    "anonymousQuotation.toast.error": "Update failed",
    "contracts.actions": "Actions",
    "contracts.edit": "Edit contract",
    "contracts.editAction": "Edit",
    "contracts.delete": "Delete",
    "contracts.priceLists.priceList": "Price list",
    "contracts.priceLists.acceptedFileTypes": "Preferred: CSV or XLSX",
    "contracts.priceLists.upload": "Upload",
    "contracts.priceLists.duration": "Duration",
    "contracts.priceLists.startDate": "Start date",
    "contracts.priceLists.startDateCaption": "The price list becomes valid on this date.",
    "contracts.priceLists.startDatePlaceholder": "Select start date",
    "contracts.priceLists.endDate": "End date",
    "contracts.priceLists.endDateCaption": "Leave empty for open-ended price lists.",
    "contracts.priceLists.save": "Save",
    "contracts.priceLists.cancel": "Cancel",
    "contracts.priceLists.delete": "Delete",
    "contracts.priceLists.deleteFile": "Delete file",
    "contracts.priceLists.edit": "Edit",
    "contracts.priceLists.endOfContract": "End of contract",
    "contracts.priceLists.addPriceList": "Add price list",
    "contracts.priceLists.endDateRequiredForNew": "To add another price list in automatic mode, the current one must have an end date.",
    "contracts.priceLists.title": "Price lists",
    "contracts.priceLists.description": "Upload price lists. Each file defines its own validity period (for example quarterly). Only one price list can be active at a time.",
    "contracts.priceLists.activatePriceList": "Apply price list",
    "contracts.priceLists.activatePriceListDescription": "If enabled these prices will be applied during enquiry",
    "contracts.priceLists.activationMode": "Activation mode",
    "contracts.priceLists.activationMode.automatic": "Automatic (recommended)",
    "contracts.priceLists.activationMode.automaticDescription": "Applied automatically based on validity dates.",
    "contracts.priceLists.activationMode.manual": "Manual",
    "contracts.priceLists.activationMode.manualDescription": "Apply price lists manually. Only one can be applied at a time.",
    "contracts.priceLists.effectiveDateMode": "Apply prices based on",
    "contracts.priceLists.effectiveDateMode.deliveryDate": "Delivery date",
    "contracts.priceLists.effectiveDateMode.deliveryDateDescription": "Use the price list valid on the estimated delivery date. Prices may change when a new price list becomes valid.",
    "contracts.priceLists.effectiveDateMode.orderDate": "Enquiry date",
    "contracts.priceLists.effectiveDateMode.orderDateDescription": "Use the price list valid on the enquiry date. Draft enquiries use today's date.",
    "contracts.priceLists.validation.dateOverlap": "Price list date ranges must not overlap.",
    "contracts.priceLists.validation.contractStartDateRequired": "Set a contract start date before saving a price list.",
    "contracts.priceLists.validation.invalidDate": "One or more price lists have an invalid date.",
    "contracts.priceLists.validation.invalidDateRange": "The end date must be after the start date.",
    "contracts.priceLists.validation.startDateBeforeToday": "Start date must be today or later.",
    "contracts.priceLists.validation.startDateBeforeContractStart": "Start date must be on or after the contract start date.",
    "contracts.priceLists.validation.endDateAfterContractEnd": "End date must be on or before the contract end date.",
    "contracts.priceLists.validation.required": "Required price list fields are missing.",
    "contracts.priceLists.validation.required.validFrom": "Start date is required.",
    "contracts.priceLists.validation.required.validUntil": "End date is required.",
    "contracts.priceLists.validation.unknown": "Price list validation failed.",
    "comboBox.searchPlaceholder": "Search...",
    "comboBox.noOptions": "No options",
    "comboBox.noOptionsMatchYourSearch": "No options match your search",
    "comboBox.allOptionsAreAlreadySelected": "All options are already selected",
    "comboBox.allMatchingOptionsAreAlreadySelected": "All matching options are already selected",
    "comboBox.couldNotLoadOptions": "Could not load options",
    "comboBox.couldNotLoadSelection": "Could not load selection",
    "comboBox.toSelect": "to select",
    "requisition.customize.vesselEmail": "Vessel email address",
    "requisition.customize.noSavedEmail": "No email address is saved for this vessel",
    "requisition.customize.custom": "Custom",
    "requisition.customize.companyRecipients": "Requisition forms are sent only to vessels with a saved email address.",
    "requisition.customize.sendToVessels": "Send to vessels",
    "requisition.customize.companyQueued": "{{queuedCount}} requisitions queued for email. {{skippedCount}} vessels skipped because no email address is saved.",
    "requisition.customize.noRecipients": "No requisitions queued: no vessels have a saved email address. {{skippedCount}} vessels skipped.",
    "requisition.customize.companyTitle": "Generate requisition forms",
    "requisition.customize.title": "Generate requisition form",
    "requisition.customize.companyDescription": "These settings apply to every vessel in this company.",
    "requisition.customize.products": "Products",
    "requisition.customize.catalogue": "All products",
    "requisition.customize.vesselProducts": "Products specified for this vessel",
    "requisition.customize.groups": "Product groups",
    "requisition.customize.all": "All product groups",
    "requisition.customize.main": "Main grades",
    "requisition.customize.mainClassification": "Main grade",
    "requisition.customize.minorClassification": "Minor grade",
    "requisition.customize.minor": "Minor grades",
    "requisition.customize.selectGroup": "Select at least one product group.",
    "requisition.customize.error": "The requisition could not be generated. Please try again.",
    "drawer.discardUnsavedChanges": "Discard unsaved changes?",
    "drawer.unsavedChangesWillBeLost": "Your changes haven’t been saved. If you leave now, they’ll be lost.",
    "drawer.keepEditing": "Keep editing",
    "drawer.discardChanges": "Discard changes",
    "keyPorts.allVessels": "All vessels",
    "keyPorts.selectedVesselsOnly": "Selected vessels only",
    "keyPorts.applyKeyPortToAllVessels": "Apply key port to all vessels?",
    "keyPorts.noVesselsSelectedApplyToAll": "No vessels are selected. Continuing will assign this key port to all vessels.",
    "keyPorts.applyToAllVessels": "Apply to all vessels",
    "supplierPlan.plan": "Plan",
    "supplierPlan.currentPlan": "Current plan",
    "supplierPlan.filterByPlan": "Filter by plan",
    "supplierPlan.plansAndSubscription": "Plans & subscription",
    "supplierPlan.renewalDate": "Renewal date",
    "supplierPlan.transactionFee": "Transaction fee",
    "supplierPlan.thisFeeAppliesOnlyToSpotMarketTransactions": "This fee applies only to spot-market transactions.",
    "supplierPlan.feePercentage": "{{percentage}}%",
    "supplierPlan.unlockMoreFlexibilityVisibilityAndLowerCosts": "Unlock more flexibility, visibility and lower transaction costs with Closelink",
    "supplierPlan.thanksForSubscribing": "Thanks for subscribing to Closelink",
    "supplierPlan.multipleOffersSchedulesAndPrioritySupport": "Send multiple offers per enquiry, see vessel schedules, and get priority support.",
    "supplierPlan.exploreIncludedFeatures": "Explore the features included in your plan.",
    "supplierPlan.billedAnnuallyAndRenewsAutomatically": "Billed annually and renews automatically."
}
